var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path='../../typings/index.d.ts' />
/// <reference path="../_all.ts" />
var Login;
(function (Login) {
    var StateConfig = /** @class */ (function () {
        function StateConfig($stateProvider, $urlRouterProvider) {
            this.$stateProvider = $stateProvider;
            this.$urlRouterProvider = $urlRouterProvider;
            this.init();
        }
        StateConfig.prototype.init = function () {
            this.$stateProvider
                .state("login", {
                template: "<ui-view/>"
            })
                .state("login.login", {
                url: "/Login?ReturnUrl",
                template: "<brookson-login-login></brookson-login-login>"
            })
                .state("login.super", {
                url: "/Login/Super?ReturnUrl",
                template: "<brookson-login-super></brookson-login-super>"
            })
                .state("login.serviceLine", {
                url: "/Login/ServiceLine?ReturnUrl",
                template: "<brookson-login-service-line></brookson-login-service-line>"
            })
                .state("login.registration", {
                url: "/Login/Registration",
                template: "<brookson-login-registration></brookson-login-registration>"
            })
                .state("login.passwordReset", {
                url: "/Login/PasswordReset/:id",
                template: "<brookson-login-password-reset></brookson-login-password-reset>"
            })
                .state("login.forgottenPassword", {
                url: "/Login/ForgottenPassword",
                template: "<brookson-login-forgotten-password></brookson-login-forgotten-password>"
            })
                .state("login.shareholder", {
                url: "/Login/Shareholder",
                template: "<brookson-login-shareholder></brookson-login-shareholder>"
            })
                .state("login.twoFactorAuth", {
                url: "/login/two_factor_auth",
                template: "<brookson-login-twofactorauth></brookson-login-twofactorauth>",
                params: {
                    loginData: null
                }
            });
            this.$urlRouterProvider.otherwise("/Login");
        };
        return StateConfig;
    }());
    Login.StateConfig = StateConfig;
})(Login || (Login = {}));
var Shared;
(function (Shared) {
    var AccountType;
    (function (AccountType) {
        AccountType[AccountType["unknown"] = 0] = "unknown";
        AccountType[AccountType["limitedCompany"] = 1] = "limitedCompany";
        AccountType[AccountType["deemed"] = 99] = "deemed";
        AccountType[AccountType["soleTrader"] = 5] = "soleTrader";
        AccountType[AccountType["umbrella"] = 3] = "umbrella";
    })(AccountType = Shared.AccountType || (Shared.AccountType = {}));
    var MoleAccountType;
    (function (MoleAccountType) {
        MoleAccountType[MoleAccountType["unknown"] = 0] = "unknown";
        MoleAccountType[MoleAccountType["limitedCompany"] = 1] = "limitedCompany";
        MoleAccountType[MoleAccountType["limitedCompany2"] = 2] = "limitedCompany2";
        MoleAccountType[MoleAccountType["umbrella"] = 3] = "umbrella";
        MoleAccountType[MoleAccountType["cis"] = 4] = "cis";
        MoleAccountType[MoleAccountType["soleTrader"] = 5] = "soleTrader";
    })(MoleAccountType = Shared.MoleAccountType || (Shared.MoleAccountType = {}));
})(Shared || (Shared = {}));
/// <reference path="./AccountType.ts"/>
var Shared;
(function (Shared) {
    // $Classes/Enums/Interfaces(filter)[template][separator]
    // filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
    // template: The template to repeat for each matched item
    // separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]
    // More info: http://frhagn.github.io/Typewriter/
    var Member = /** @class */ (function () {
        function Member() {
            // MEMBERID
            this.memberID = 0;
            // ALTMEMBERID
            this.altMemberID = 0;
            // FIRSTNAME
            this.firstname = null;
            // LASTNAME
            this.lastname = null;
            // EMAIL
            this.email = null;
            // GROUPS
            this.groups = null;
            // USERNAME
            this.username = null;
            // PERSONALTAXACTIVE
            this.personalTaxActive = false;
            // COMPANYREF
            this.companyRef = null;
            // USERTYPE
            this.userType = 0;
            // ACCOUNTTYPE
            this.accountType = null;
            // USESTSTYLEINVOICING
            this.useSTStyleInvoicing = false;
            // ISACTIVE
            this.isActive = false;
            // DATEOFBIRTH
            this.dateOfBirth = null;
            // CREATEDDATE
            this.createdDate = null;
            this.businessType = null;
            this.role = null;
            this.connect2Enabled = false;
            this.companyName = null;
        }
        return Member;
    }());
    Shared.Member = Member;
})(Shared || (Shared = {}));
var Shared;
(function (Shared) {
    var StatePensionAge = /** @class */ (function () {
        function StatePensionAge() {
        }
        return StatePensionAge;
    }());
    Shared.StatePensionAge = StatePensionAge;
})(Shared || (Shared = {}));
/// <reference path="../AccountType.ts" />
var Shared;
(function (Shared) {
    var IR35AssessmentAnswers = /** @class */ (function () {
        function IR35AssessmentAnswers() {
        }
        return IR35AssessmentAnswers;
    }());
    Shared.IR35AssessmentAnswers = IR35AssessmentAnswers;
})(Shared || (Shared = {}));
/// <reference path="./../../_all.ts"/>
/// <reference path="../models/Member.ts"/>
/// <reference path="../models/StatePensionAge.ts" />
/// <reference path="../models/member/ServiceLine.ts" />
/// <reference path="../models/IR35AssessmentAnswers.ts" />
/// <reference path="../models/IR35AssessmentAnswers.ts" />
/// <reference path="./../interfaces/brookson.interfaces.http.ts" />
var Shared;
(function (Shared) {
    var MemberModel = /** @class */ (function () {
        function MemberModel() {
            this.userName = "";
            this.token = "";
            this.refreshToken = "";
            this.isAdmin = false;
            this.isAuthenticated = false;
            this.memberId = "";
            this.useRefreshToken = false;
            this.hasUmbBusinessType = false;
            this.hasLtdBusinessType = false;
            this.hasMulipleLtdCompanies = false;
            this.umbCustomerReference = "";
            this.ltdCustomerReference = "";
            this.companyRef = "";
            this.businessType = "";
            this.businessStatus = "";
            this.role = "";
            this.expires = "";
            this.refreshTokenExpires = "";
            this.navReferral = "";
            this.companyName = "";
            this.apiKeySource = "";
        }
        return MemberModel;
    }());
    Shared.MemberModel = MemberModel;
    var MemberService = /** @class */ (function () {
        function MemberService($injector, localStorageService, analytics) {
            var _this = this;
            this.$injector = $injector;
            this.localStorageService = localStorageService;
            this.analytics = analytics;
            this.isMiniConnectUser = function () {
                if (_this.member.serviceLines) {
                    var line = _.filter(_this.member.serviceLines, function (o) { return o.customerReference === _this.member.companyRef; });
                    if (line.length > 0) {
                        if ((line[0].isSecondShareholder === true) || ((line[0].isEligible === true) && (line[0].isActive === false))) {
                            return true;
                        }
                    }
                }
                return false;
            };
            this.companyName = function () {
                if (_this.member.serviceLines) {
                    var line = _.filter(_this.member.serviceLines, function (o) { return o.customerReference === _this.member.companyRef; });
                    if (line[0]) {
                        return line[0].companyName.toLowerCase();
                    }
                    if (_this.member.companyName) {
                        return _this.member.companyName.toLowerCase();
                    }
                }
            };
            this.setMember = function (data) {
                //set in memory values
                _this.member = _.assign(_this.member, data);
                _this.member.businessType = _this.getMemberBusinessType();
                _this.member.businessStatus = _this.getMemberBusinessStatus();
                //persist changes
                _this.localStorageService.set("brookson.member", _this.member);
                _this.analytics.set("dimension1", _this.member.memberId);
                _this.analytics.set("dimension2", _this.member.businessType);
                _this.analytics.set("dimension3", _this.member.companyRef);
                _this.analytics.set("dimension4", _this.member.isAdmin ? "Y" : "N");
                return _this.member;
            };
            this.getMember = function () {
                if (!_this.member || !_this.member.userName) {
                    var store = _this.localStorageService.get("brookson.member");
                    if (store) {
                        _this.member = store;
                    }
                }
                return _this.member;
            };
            this.getMemberBusinessType = function () {
                var member = _this.member;
                // If there's service lines, return the one matching business type from here
                if (member.serviceLines) {
                    var line = _.filter(member.serviceLines, function (o) { return o.customerReference === member.companyRef; });
                    if (line[0]) {
                        return line[0].businessType;
                    }
                    else {
                        return member.businessType;
                    }
                }
                else {
                    return member.businessType;
                }
            };
            this.getMemberBusinessStatus = function () {
                var member = _this.member;
                // If there's service lines, return the one matching business type from here
                if (member.serviceLines) {
                    var line = _.filter(member.serviceLines, function (o) { return o.customerReference === member.companyRef; });
                    if (line[0]) {
                        return line[0].businessStatus;
                    }
                    else {
                        return member.businessStatus;
                    }
                }
                else {
                    return member.businessStatus;
                }
            };
            this.updateMember = function (data) {
                return _this.setMember(data);
            };
            this.clearMember = function () {
                _this.member = null;
                _this.localStorageService.set("brookson.member", {});
                _this.localStorageService.set("brookson.dashboard", {});
            };
            this.getMemberDetails = function (silentMode, cached) {
                _this.$http = _this.$http || _this.$injector.get('$http');
                return _this.$http.get('api/Member/GetMemberDetails', {
                    silentMode: silentMode ? silentMode : silentMode,
                    cache: cached ? cached : false
                }).then(function (response) {
                    return response.data;
                });
            };
            this.getPensionAge = function (silentMode, cached) {
                var config = {
                    silentMode: silentMode ? silentMode : false,
                    cache: cached ? cached : false
                };
                return _this.$http.get('api/Member/PensionAge', config).then(function (response) {
                    return response.data;
                });
            };
            this.member = new MemberModel();
        }
        MemberService.prototype.getHasAdvisoryKeyInformation = function (silentMode, cached) {
            var config = {
                silentMode: silentMode ? silentMode : false,
                cache: cached ? cached : false
            };
            var hasAdvisor = this.$http.get('api/Advisory/HasAdvisoryKeyInformation', config).then(function (response) {
                return response.data;
            });
            return hasAdvisor;
        };
        MemberService.prototype.getHasAdvisoryKeyInformationUmbrella = function (silentMode, cached) {
            var config = {
                silentMode: silentMode ? silentMode : false,
                cache: cached ? cached : false
            };
            var hasAdvisor = this.$http.get('api/Advisory/HasAdvisoryKeyInformationUmbrella', config).then(function (response) {
                return response.data;
            });
            return hasAdvisor;
        };
        MemberService.prototype.showMemberMTD = function () {
            return this.$http.get('api/Member/ShowMemberMTD').then(function (response) {
                return response.data;
            });
        };
        MemberService.prototype.insertAuthorsationCode = function (authorisationCode) {
            var requestData = {
                authorisationCode: authorisationCode
            };
            return this.$http.post('api/Member/InsertMTDAuthorisationCode', requestData)
                .then(function (response) {
                return response.data;
            });
        };
        MemberService.$inject = ['$injector', "localStorageService", 'Analytics'];
        return MemberService;
    }());
    Shared.MemberService = MemberService;
})(Shared || (Shared = {}));
angular.module('app.shared').service('memberSrv', Shared.MemberService);
/// <reference path="../../_all.ts"/>
(function () {
    'use strict';
    angular
        .module('app.shared')
        .factory('brookson.navigation', brooksonNavigation);
    brooksonNavigation.$inject = ['$window'];
    function brooksonNavigation($window) {
        var account = {
            main: function () {
                $window.location.href = "/Account";
            }
        };
        var bankLink = {
            main: function () {
                $window.location.href = "/BankLink";
            }
        };
        var advisory = {
            main: function () {
                $window.location.href = "/Advisory";
            }
        };
        var selectServiceLine = {
            main: function () {
                $window.location.href = "/SelectServiceLine";
            }
        };
        //var jobsBoard = {
        //    main: () => {
        //        $window.location.href = "/JobsBoard";
        //    }
        //};
        var workFlex = {
            main: function () {
                $window.location.href = "/WorkFlex";
            },
            umbrella: function () {
                $window.location.href = "/WorkFlex/Umbrella";
            },
            personalServiceCompany: function () {
                $window.location.href = "/WorkFlex/PersonalServiceCompany";
            }
        };
        var dashboard = {
            main: function () {
                $window.location.href = "/Dashboard";
            }
        };
        var documentStorage = {
            main: function () {
                $window.location.href = "/DocumentStorage";
            },
            recentlyAdded: function () {
                $window.location.href = "/DocumentStorage/RecentlyAdded";
            },
            favourites: function () {
                $window.location.href = "/DocumentStorage/Favourites";
            },
            brooksonSharedDrive: function (sharedDriveId) {
                $window.location.href = "/DocumentStorage/BrooksonSharedDrive" + sharedDriveId;
            },
            folder: function (folderId) {
                $window.location.href = "DocumentStorage/" + folderId;
            },
            paySlipFolder: function () {
                $window.location.href = "DocumentStorage/2/";
            }
        };
        var employeeZone = {
            holidays: function () {
                $window.location.href = "/EmployeeZone/EmployeeHolidays";
            },
            payslips: function () {
                $window.location.href = "/EmployeeZone/Payslips";
            }
        };
        var employmentStatus = {
            main: function (returnUrl, returnText) {
                if (!returnUrl && !returnText)
                    $window.location.href = "/EmploymentStatus";
                $window.location.href = "/EmploymentStatus?returnUrl=".concat(returnUrl, "&returnText=").concat(returnText);
            },
            ir35Assignment: function (assignmentId) {
                $window.location.href = "/EmploymentStatus/" + assignmentId;
            }
        };
        var expenses = {
            main: function () {
                $window.location.href = "/Expenses/Personal";
            },
            business: function () {
                $window.location.href = "/Expenses/Business";
            },
            expenseDetails: function () {
                $window.location.href = "/Expenses/ExpenseDetails";
            },
            addExpense: function () {
                $window.location.href = "/AddExpense";
            },
            addMileage: function () {
                $window.location.href = "/AddMileage";
            },
            addReceipt: function () {
                $window.location.href = "/AddReceipt";
            },
            addAllowance: function () {
                $window.location.href = "/AddAllowance";
            },
            editExpense: function () {
                $window.location.href = "/EditExpense";
            },
            editMileage: function () {
                $window.location.href = "/EditMileage";
            },
            editReceipt: function () {
                $window.location.href = "/EditReceipt";
            },
            editAllowance: function () {
                $window.location.href = "/EditAllowance";
            },
            expenseReport: function (id) {
                $window.location.href = "/Expenses/ExpenseReport/" + id;
            },
            expensesReceiptBank: function () {
                $window.location.href = "/Expenses/ReceiptBank";
            }
        };
        var financialCenter = {
            main: function () {
                $window.location.href = "/FinancialCenter";
            }
        };
        var home = {
            logout: function () {
                $window.location.href = "/Home/LogOut";
            }
        };
        var assignments = {
            main: function () {
                $window.location.href = "/Assignments";
            },
            summary: function (assignmentId) {
                var url = "/Assignments/Summary";
                url += assignmentId ? '/' + assignmentId : '';
                $window.location.href = url;
            },
            addAssignment: function () {
                $window.location.href = "/Assignments/Add-Assignment";
            },
            editAssignment: function (assignmentId) {
                var url = "/Assignments/Edit-Assignment";
                url += assignmentId ? '/' + assignmentId : '';
                $window.location.href = url;
            }
        };
        var invoicing = {
            main: function () {
                $window.location.href = "/Invoicing";
            },
            raiseInvoice: function (id) {
                var url = "/Invoicing/Raise-Invoice";
                url += id ? '/' + id : '';
                $window.location.href = url;
            },
            createInvoice: function (id) {
                var url = "/Invoicing/create-invoice";
                url += id ? '/' + id : '';
                $window.location.href = url;
            },
            newInvoice: function () {
                var url = "/Invoicing/Raise-Invoice/";
                $window.location.href = url;
            },
        };
        var knowledgeBase = {
            main: function () {
                $window.location.href = "/Dashboard/KnowledgeBase";
            }
        };
        var login = {
            main: function () {
                $window.location.href = "/Login";
            },
            superuser: function () {
                $window.location.href = "/Login/Super";
            },
            serviceline: function () {
                $window.location.href = "/Login/ServiceLine";
            },
            registration: function () {
                $window.location.href = "/Login/Registration";
            },
            passwordReset: function (id) {
                $window.location.href = "/Login/PasswordReset/" + id;
            },
            forgottenPassword: function () {
                $window.location.href = "/Login/ForgottenPassword";
            },
            shareholder: function () {
                $window.location.href = "/login/shareholder";
            }
        };
        var moneyManager = {
            main: function () {
                $window.location.href = "/MoneyManager";
            },
            profitLoss: function () {
                $window.location.href = "/MoneyManager/ProfitLoss";
            },
            balanceSheet: function () {
                $window.location.href = "/MoneyManager/BalanceSheet";
            },
            history: function (week) {
                $window.location.href = "/MoneyManager/History/" + week;
            },
            transactions: function () {
                $window.location.href = "/MoneyManager/Transactions";
            }
        };
        var personalFinance = {
            main: function () {
                $window.location.href = "/PersonalFinance";
            },
            riskProfile: function () {
                $window.location.href = "/PersonalFinance/RiskProfile";
            },
            retirementPlanner: function () {
                $window.location.href = "/PersonalFinance/RetirementPlanner";
            }
        };
        var financialServices = {
            main: function () {
                $window.location.href = "/FinancialServices";
            }
        };
        var personalTax = {
            main: function () {
                $window.location.href = "/PersonalTax";
            },
            planner: function () {
                $window.location.href = "/TaskPlanner/saPersonalTax";
            },
            tracker: function () {
                $window.location.href = "/PersonalTax/Tracker";
            },
            hrmcersonalAccountBalance: function () {
                $window.location.href = "/PersonalTax/HMRCPersonalAccountBalance";
            },
            selfAssessment: function () {
                $window.location.href = "/PersonalTax/SelfAssessment";
            },
            selfAssessmentTAndCs: function () {
                $window.location.href = "/PersonalTax/SelfAssessment/TermsAndConditions";
            }
        };
        var taskPlanner = {
            main: function () {
                $window.location.href = "/TaskPlanner";
            },
            calendar: function () {
                $window.location.href = "/Calendar/calendar";
            },
            calendarSelectedAction: function (actionID) {
                $window.location.href = "/Calendar/calendar/" + _.camelCase(actionID);
            },
            selectedAction: function (actionID) {
                $window.location.href = "/TaskPlanner/" + _.camelCase(actionID);
            },
            selectedActionTask: function (actionID, taskID) {
                $window.location.href = "/TaskPlanner/" + _.camelCase(actionID) + "/" + taskID;
            }
        };
        var sme = {
            holidays: function () {
                $window.location.href = "/Sme/Holidays";
            }
        };
        var openBankingRedirect = {
            holidays: function () {
                $window.location.href = "/OpenBankingRedirect";
            }
        };
        var payment = {
            main: function () {
                $window.location.href = "/Payment";
            },
            adminBillableItems: function () {
                $window.location.href = "/Payment/Admin/BillableItems";
            }
        };
        var service = {
            account: account,
            bankLink: bankLink,
            dashboard: dashboard,
            documentStorage: documentStorage,
            employmentStatus: employmentStatus,
            expenses: expenses,
            home: home,
            assignments: assignments,
            invoicing: invoicing,
            knowledgeBase: knowledgeBase,
            login: login,
            moneyManager: moneyManager,
            personalFinance: personalFinance,
            financialServices: financialServices,
            personalTax: personalTax,
            taskPlanner: taskPlanner,
            openBankingRedirect: openBankingRedirect,
            sme: sme,
            employeeZone: employeeZone,
            financialCenter: financialCenter,
            advisory: advisory,
            selectServiceLine: selectServiceLine,
            /*            jobsBoard: jobsBoard,*/
            workFlex: workFlex,
            payment: payment
        };
        return service;
    }
})();
/// <reference path="../../_all.ts" />
/// <reference path="./../../shared/services/brookson.services.member.ts"/>
/// <reference path="../../shared/modules/brookson.navigation.ts" />
/// <reference path="../models/member/TfaMemberContactDetails.ts" />
/// <reference path="../../shared/models/member/TfaMemberContactDetails.ts" />
var Shared;
(function (Shared) {
    var AuthenticationService = /** @class */ (function () {
        function AuthenticationService($injector, $httpParamSerializer, $q, sharedConfig, memberSrv, brooksonNavigation, localStorageService) {
            var _this = this;
            this.$injector = $injector;
            this.$httpParamSerializer = $httpParamSerializer;
            this.$q = $q;
            this.sharedConfig = sharedConfig;
            this.memberSrv = memberSrv;
            this.brooksonNavigation = brooksonNavigation;
            this.localStorageService = localStorageService;
            this._authentication = {
                isAuth: false,
                userName: "",
                useRefreshTokens: false
            };
            this.validateLoginRequest = function (memberId, password) {
                _this.$http = _this.$http || _this.$injector.get("$http");
                var url = _this.serviceBase + "api/TwoFactorAuth/ValidateLoginRequest";
                var request = {
                    memberId: memberId,
                    password: password
                };
                return _this.$http.post(url, request)
                    .then(function (response) {
                    return response.data;
                }, function (err) {
                    console.log(err.data);
                })
                    .catch(function (err) {
                    console.log(err.data);
                });
            };
            this.twoFactorAuthRequest = function (contactAddressNumber, memberId) {
                _this.$http = _this.$http || _this.$injector.get("$http");
                var url = _this.serviceBase + "api/TwoFactorAuth/TwoFactorAuthRequest";
                var request = {
                    contactAddressNumber: contactAddressNumber,
                    memberId: memberId
                };
                return _this.$http.post(url, request)
                    .then(function (response) {
                    return response.data;
                });
            };
            this.twoFactorAuthValidation = function (otp, memberId) {
                _this.$http = _this.$http || _this.$injector.get("$http");
                var url = _this.serviceBase + "api/TwoFactorAuth/TwoFactorAuthValidation";
                var request = {
                    otp: otp,
                    memberId: memberId
                };
                return _this.$http.post(url, request)
                    .then(function (response) {
                    return response.data;
                });
            };
            this.getMemberMaskedContactDetails = function (memberId) {
                _this.$http = _this.$http || _this.$injector.get("$http");
                var url = _this.serviceBase + "api/TwoFactorAuth/GetMaskedMemberContactDetails";
                var request = {
                    memberId: memberId
                };
                return _this.$http.post(url, request)
                    .then(function (response) {
                    return response.data;
                });
            };
            this.getMemberContactDetails = function (memberId) {
                _this.$http = _this.$http || _this.$injector.get("$http");
                var url = _this.serviceBase + "api/TwoFactorAuth/GetMemberContactDetails";
                var request = {
                    memberId: memberId
                };
                return _this.$http.post(url, request)
                    .then(function (response) {
                    return response.data;
                });
            };
            this.saveTwoFactorAuthSetting = function (memberId, enableTfa) {
                _this.$http = _this.$http || _this.$injector.get("$http");
                var url = _this.serviceBase + "api/TwoFactorAuth/SaveTwoFactorAuthSetting";
                var request = {
                    memberId: memberId,
                    enableTfa: enableTfa
                };
                return _this.$http.post(url, request)
                    .then(function (response) {
                    return response.data;
                });
            };
            this.memberTwoFactorAuthStatus = function (memberId) {
                _this.$http = _this.$http || _this.$injector.get("$http");
                var url = _this.serviceBase + "api/TwoFactorAuth/MemberTwoFactorAuthStatus";
                var request = {
                    memberId: memberId
                };
                return _this.$http.post(url, request)
                    .then(function (response) {
                    return response.data;
                });
            };
            this.login = function (loginData) {
                var deferred = _this.$q.defer();
                var data = {
                    grant_type: "password",
                    username: loginData.userName,
                    password: loginData.password,
                    client_id: "",
                    scope: [loginData.sessionId, loginData.apiKeySource],
                };
                if (_this.authSettings.useRefreshToken) {
                    data.client_id = _this.authSettings.clientId;
                }
                _this.$http = _this.$http || _this.$injector.get("$http");
                _this.$http.post(_this.serviceBase + "token", _this.$httpParamSerializer(data), {
                    headers: {
                        'Content-Type': "application/x-www-form-urlencoded"
                    }
                })
                    .then(function (response) {
                    var refreshToken = "";
                    if (_this.authSettings.useRefreshToken) {
                        refreshToken = response.data.refresh_token;
                    }
                    if (response.data.access_token) {
                        _this.localStorageService.set("brookson.showcs01confirmation", true);
                        var result = {
                            token: response.data.access_token,
                            memberId: Number(response.data.userName),
                            userName: Number(response.data.userName),
                            isAuthenticated: true,
                            refreshToken: refreshToken,
                            useRefreshToken: _this.authSettings.useRefreshToken,
                            isAdmin: response.data.is_admin === 'true' ? true : false,
                            expires: response.data['.expires'],
                            refreshTokenExpires: response.data.clientRefreshTokenExpires,
                            apiKeySource: response.data.apiKeySource
                        };
                        deferred.resolve(result);
                    }
                    else {
                        deferred.reject(response.data);
                    }
                }, function (err) {
                    deferred.reject(err.data);
                });
                return deferred.promise;
            };
            this.updateAccessTokenServiceLine = function (id, serviceLine, refreshToken, apiKeySource) {
                var deferred = _this.$q.defer();
                var data = {
                    member_id: id,
                    company_ref: serviceLine.customerReference,
                    alt_member_id: serviceLine.altMemberId,
                    business_type: serviceLine.businessType,
                    role: serviceLine.role,
                    navReferral: serviceLine.navReferral,
                    apiKeySource: apiKeySource
                };
                _this.refreshToken(data)
                    .then(function (response) {
                    if (response.access_token) {
                        deferred.resolve(response);
                    }
                    else {
                        deferred.reject(response);
                    }
                })
                    .catch(function (err) {
                    deferred.reject(err);
                });
                return deferred.promise;
            };
            this.refreshToken = function (service_line) {
                var deferred = _this.$q.defer();
                var member = _this.memberSrv.getMember();
                if (member && member.useRefreshToken) {
                    var data = {
                        grant_type: "refresh_token",
                        refresh_token: member.refreshToken,
                        client_id: _this.authSettings.clientId,
                        set_service_line: false,
                        member_id: "",
                        alt_member_id: "",
                        company_ref: "",
                        business_type: "",
                        role: "",
                        navReferral: "",
                        apiKeySource: ""
                    };
                    if (service_line) {
                        data.set_service_line = true;
                        data.member_id = service_line.member_id;
                        data.alt_member_id = service_line.alt_member_id;
                        data.company_ref = service_line.company_ref;
                        data.business_type = service_line.business_type;
                        data.role = service_line.role;
                        data.navReferral = service_line.navReferral;
                        data.apiKeySource = service_line.apiKeySource;
                    }
                    _this.$http = _this.$http || _this.$injector.get("$http");
                    _this.$http.post(_this.serviceBase + "token", _this.$httpParamSerializer(data), { headers: { 'Content-Type': "application/x-www-form-urlencoded" } })
                        .then(function (response) {
                        var data = response.data;
                        var result = {
                            token: data.access_token,
                            userName: data.userName,
                            isAuthenticated: true,
                            refreshToken: data.refresh_token,
                            useRefreshToken: true,
                            expires: data['.expires'],
                            refreshTokenExpires: data.clientRefreshTokenExpires,
                            apiKeySource: service_line === undefined ? data.apiKeySource : service_line.apiKeySource
                        };
                        _this.memberSrv.updateMember(result);
                        deferred.resolve(data);
                    }).catch(function (err) { return deferred.reject(err); });
                }
                else {
                    deferred.reject();
                }
                return deferred.promise;
            };
            this.logout = function () {
                _this.localStorageService.remove("brookson.showcs01confirmation");
                _this.memberSrv.clearMember();
                _this.brooksonNavigation.home.logout();
            };
            this.activateMember = function (memberId, registrationId, password) {
                _this.$http = _this.$http || _this.$injector.get("$http");
                var url = _this.serviceBase + "api/Member/ActivateMember";
                var request = {
                    memberId: memberId,
                    registrationId: registrationId,
                    password: password
                };
                return _this.$http.post(url, request)
                    .then(function (response) {
                    return response.data;
                });
            };
            this.requestPasswordReset = function (memberId) {
                _this.$http = _this.$http || _this.$injector.get("$http");
                var url = _this.serviceBase + "api/Member/RequestPasswordResetSms/" + memberId;
                return _this.$http.get(url)
                    .then(function (response) {
                    return response.data;
                });
            };
            this.requestForgottenClientId = function (firstName, surname, email, dateOfBirth) {
                _this.$http = _this.$http || _this.$injector.get("$http");
                var url = _this.serviceBase + "api/Member/RequestForgottenClientId";
                var request = {
                    firstName: firstName,
                    surname: surname,
                    email: email,
                    dateOfBirth: dateOfBirth
                };
                return _this.$http.post(url, request)
                    .then(function (response) {
                    return response.data;
                });
            };
            this.resetMemberPassword = function (id, memberId, password) {
                _this.$http = _this.$http || _this.$injector.get("$http");
                var url = _this.serviceBase + "api/Member/resetMemberPassword";
                var request = {
                    id: id,
                    memberId: memberId,
                    password: password
                };
                return _this.$http.post(url, request)
                    .then(function (response) {
                    return response.data;
                });
            };
            this.verifyShareholderLogin = function (userName, registrationId, password) {
                _this.$http = _this.$http || _this.$injector.get("$http");
                var url = _this.serviceBase + "api/Member/verifyShareholderLogin";
                var request = {
                    username: userName,
                    registrationId: registrationId,
                    password: password
                };
                return _this.$http.post(url, request)
                    .then(function (response) {
                    return response.data;
                });
            };
            this.serviceBase = sharedConfig.baseApiUrl;
            this.authSettings = sharedConfig.authSettings;
        }
        AuthenticationService.$inject = ["$injector", "$httpParamSerializer", "$q", "shared.config", "memberSrv", "brookson.navigation", 'localStorageService'];
        return AuthenticationService;
    }());
    Shared.AuthenticationService = AuthenticationService;
})(Shared || (Shared = {}));
angular
    .module('app.shared')
    .service('authenticationSrv', Shared.AuthenticationService);
/// <reference path="../../_all.ts"/>
(function () {
    "use strict";
    var app = angular.module("app.shared");
    app.factory("brookson.ui.popup", [
        "$q", "$uibModal", "$sce", "$sanitize", function ($q, $uibModal, $sce, $sanitize) {
            var options = {
                animation: true,
                size: "sm",
                templateUrl: "src/app/shared/views/ui/brookson.ui.popup.html"
            };
            var _showConfirmationPopup = function (title, message, acceptText, closeText) {
                var defer = $q.defer();
                var confirmationOptions = options;
                confirmationOptions.controller = ['$scope', '$uibModalInstance', '$rootScope', function ($scope, $uibModalInstance, $rootScope) {
                        $scope.title = title;
                        $scope.message = $sanitize($sce.trustAsHtml(message));
                        if (acceptText) {
                            $scope.acceptButtonText = acceptText;
                        }
                        else {
                            $scope.acceptButtonText = "Ok";
                        }
                        if (closeText) {
                            $scope.closeButtonText = closeText;
                        }
                        else {
                            $scope.closeButtonText = "Cancel";
                        }
                        $scope.ok = function () {
                            $uibModalInstance.close();
                            defer.resolve();
                        };
                        $scope.cancel = function () {
                            $uibModalInstance.dismiss();
                            $rootScope.$broadcast('UserCancelledConfirmationPopup', { userClickedCancelledButton: true });
                            defer.reject();
                        };
                    }];
                $uibModal.open(confirmationOptions);
                return defer.promise;
            };
            var _showTemplatedConfirmationPopup = function (title, messageTemplateUrl, model, acceptText, closeText, popupSize) {
                var defer = $q.defer();
                popupSize = popupSize || "sm";
                var infoOptions = {
                    animation: true,
                    size: popupSize,
                    windowClass: "templated-confirmation-popup",
                    templateUrl: "src/app/shared/views/ui/brookson.ui.templated-confirmation-popup.html"
                };
                infoOptions.controller = ['$scope', '$uibModalInstance', 'memberSrv', function ($scope, $uibModalInstance, memberSrv) {
                        $scope.title = title;
                        $scope.messageTemplateUrl = messageTemplateUrl;
                        $scope.model = model;
                        $scope.businessType = memberSrv.member.businessType;
                        if (acceptText) {
                            $scope.acceptButtonText = acceptText;
                        }
                        else {
                            $scope.acceptButtonText = "Ok";
                        }
                        if (closeText) {
                            $scope.closeButtonText = closeText;
                        }
                        else {
                            $scope.closeButtonText = "Cancel";
                        }
                        $scope.ok = function () {
                            $uibModalInstance.close();
                            defer.resolve();
                        };
                        $scope.cancel = function () {
                            $uibModalInstance.dismiss();
                            defer.reject();
                        };
                    }];
                $uibModal.open(infoOptions);
                return defer.promise;
            };
            var _showSaveAs = function (title, message, acceptText, closeText) {
                var defer = $q.defer();
                options.templateUrl = "src/app/shared/views/ui/brookson.ui.popup.input.html";
                options.size = "md";
                var confirmationOptions = options;
                confirmationOptions.controller = ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
                        $scope.title = title;
                        $scope.message = $sanitize($sce.trustAsHtml(message));
                        $scope.result = "";
                        if (acceptText) {
                            $scope.acceptButtonText = acceptText;
                        }
                        else {
                            $scope.acceptButtonText = "Ok";
                        }
                        if (closeText) {
                            $scope.closeButtonText = closeText;
                        }
                        else {
                            $scope.closeButtonText = "Cancel";
                        }
                        $scope.ok = function () {
                            $uibModalInstance.close();
                            defer.resolve($scope.result);
                        };
                        $scope.cancel = function () {
                            $uibModalInstance.dismiss();
                            defer.reject();
                        };
                    }];
                $uibModal.open(confirmationOptions);
                return defer.promise;
            };
            var _showYesNoPopup = function (title, message) {
                var defer = $q.defer();
                var yesNoOptions = options;
                yesNoOptions.controller = ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
                        $scope.title = title;
                        $scope.message = $sanitize($sce.trustAsHtml(message));
                        $scope.acceptButtonText = "Yes";
                        $scope.closeButtonText = "No";
                        $scope.ok = function () {
                            $uibModalInstance.close();
                            defer.resolve();
                        };
                        $scope.cancel = function () {
                            $uibModalInstance.dismiss();
                            defer.reject();
                        };
                    }];
                $uibModal.open(yesNoOptions);
                return defer.promise;
            };
            var _showInfoPopup = function (title, message) {
                var defer = $q.defer();
                var infoOptions = options;
                infoOptions.controller = ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
                        $scope.title = title;
                        $scope.message = $sanitize($sce.trustAsHtml(message));
                        $scope.acceptButtonText = "Ok";
                        $scope.ok = function () {
                            $uibModalInstance.close();
                            defer.resolve();
                        };
                        $scope.cancel = function () {
                            $uibModalInstance.dismiss();
                            defer.reject();
                        };
                    }];
                $uibModal.open(infoOptions);
                return defer.promise;
            };
            var _showTemplatedInfoPopup = function (title, messageTemplateUrl) {
                var defer = $q.defer();
                var infoOptions = {
                    animation: true,
                    size: "sm",
                    windowClass: "templated-info-popup",
                    templateUrl: "src/app/shared/views/ui/brookson.ui.templated-info-popup.html"
                };
                infoOptions.controller = ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
                        $scope.title = title;
                        $scope.messageTemplateUrl = messageTemplateUrl;
                        $scope.acceptButtonText = "Ok";
                        $scope.ok = function () {
                            $uibModalInstance.close();
                            defer.resolve();
                        };
                        $scope.cancel = function () {
                            $uibModalInstance.dismiss();
                            defer.reject();
                        };
                    }];
                $uibModal.open(infoOptions);
                return defer.promise;
            };
            var _showTemplatedHelpPopup = function (title, messageTemplateUrl) {
                var defer = $q.defer();
                var infoOptions = {
                    animation: true,
                    size: "sm",
                    windowClass: "templated-info-popup",
                    templateUrl: "src/app/shared/views/ui/brookson.ui.templated-help-popup.html"
                };
                infoOptions.controller = ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
                        $scope.title = title;
                        $scope.messageTemplateUrl = messageTemplateUrl;
                        $scope.acceptButtonText = "Ok";
                        $scope.ok = function () {
                            $uibModalInstance.close();
                            defer.resolve();
                        };
                        $scope.cancel = function () {
                            $uibModalInstance.dismiss();
                            defer.reject();
                        };
                    }];
                $uibModal.open(infoOptions);
                return defer.promise;
            };
            var _showErrorPopup = function (message, errorRef) {
                var defer = $q.defer();
                var errorOptions = options;
                errorOptions.controller = ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
                        $scope.title = "Sorry";
                        $scope.message = $sanitize($sce.trustAsHtml(message));
                        $scope.acceptButtonText = "Ok";
                        if (errorRef) {
                            var errorMsg = "<strong>(Ref: " + errorRef + ")</strong>";
                            $scope.errorRef = $sce.trustAsHtml(errorMsg);
                        }
                        $scope.ok = function () {
                            $uibModalInstance.close();
                            defer.resolve();
                        };
                        $scope.cancel = function () {
                            $uibModalInstance.dismiss();
                            defer.reject();
                        };
                    }];
                $uibModal.open(errorOptions);
                return defer.promise;
            };
            var _showAcceptPopup = function (title, message, acceptText, size) {
                var defer = $q.defer();
                options.size = size ? size : 'sm';
                var acceptOptions = options;
                acceptOptions.controller = ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
                        $scope.title = title;
                        $scope.message = $sanitize($sce.trustAsHtml(message));
                        if (acceptText) {
                            $scope.acceptButtonText = acceptText;
                        }
                        else {
                            $scope.acceptButtonText = "Ok";
                        }
                        $scope.ok = function () {
                            $uibModalInstance.close();
                            defer.resolve();
                        };
                    }];
                $uibModal.open(acceptOptions);
                return defer.promise;
            };
            return {
                showConfirmationPopup: _showConfirmationPopup,
                showTemplatedConfirmationPopup: _showTemplatedConfirmationPopup,
                showYesNoPopup: _showYesNoPopup,
                showInfoPopup: _showInfoPopup,
                showTemplatedInfoPopup: _showTemplatedInfoPopup,
                showTemplatedHelpPopup: _showTemplatedHelpPopup,
                showErrorPopup: _showErrorPopup,
                showAcceptPopup: _showAcceptPopup,
                showSaveAs: _showSaveAs
            };
        }
    ]);
})();
/// <reference path="../../_all.ts"/>
var Shared;
(function (Shared) {
    var ContactEnums = /** @class */ (function () {
        function ContactEnums() {
            this.ContactInformation = {
                CustomerServicesPhone: '0345 058 1200 or 01925 232 526',
                CustomerServicesEmail: 'businessadvisors@brookson.co.uk'
            };
        }
        ContactEnums.Default = function () { return new ContactEnums(); };
        return ContactEnums;
    }());
    Shared.ContactEnums = ContactEnums;
    var InvoicingEnums = /** @class */ (function () {
        function InvoicingEnums() {
            this.RatePeriods = {
                HOUR: 0,
                DAY: 1,
                WEEK: 2,
                properties: {
                    0: { value: "Hour", adjective: "Hourly" },
                    1: { value: "Day", adjective: "Daily" },
                    2: { value: "Week", adjective: "Weekly" }
                }
            };
            this.InvoiceCreationStatus = {
                OVERRIDE: 0,
                SUCCESSFUL: 1,
                EXCEPTION: 2
            };
            this.InvoiceStatus = {
                NONE: 0,
                NEW: 1,
                MODIFIED: 2,
                DELETED: 3
            };
            this.Sectors = {
                PUBLIC: 0,
                PRIVATE: 1,
                NOLONGERINUSE: 2,
                NEITHER: 3,
                properties: {
                    0: { description: 'Public', id: 0 },
                    1: { description: 'Private', id: 1 },
                    2: { description: 'NoLongerInUse', id: 2 },
                    3: { description: 'Neither', id: 3 }
                }
            };
            this.TimesheetFrequency = {
                WEEKLY: 0,
                FORTNIGHTLY: 2,
                MONTHLY: 3,
                properties: {
                    0: { description: 'Weekly', id: 0 },
                    1: { description: 'Fortnightly', id: 2 },
                    2: { description: 'Monthly', id: 3 },
                }
            };
            this.Ir35Captured = {
                NOTASSESSED: 0,
                OUTSIDEIR35: 1,
                INSIDEIR35: 2,
                properties: {
                    0: { description: 'Status not assessed yet', id: 0 },
                    1: { description: 'Outside IR35', id: 1 },
                    2: { description: 'Inside IR35', id: 2 },
                }
            };
        }
        InvoicingEnums.Default = function () { return new InvoicingEnums(); };
        return InvoicingEnums;
    }());
    Shared.InvoicingEnums = InvoicingEnums;
    var CurrencyEnums = /** @class */ (function () {
        function CurrencyEnums() {
            this.CurrencyCodes = {
                GBP: 10,
                EUR: 20,
                USD: 30,
                YEN: 60,
                AUD: 70,
                CAD: 80,
                NOK: 90,
                ZAR: 100,
                SEK: 110,
                CHF: 120,
                AED: 130,
                QAR: 140,
                SGD: 150,
                properties: {
                    10: { value: "GBP", code: "£" },
                    20: { value: "EUR", code: "€" },
                    30: { value: "USD", code: "$" },
                    60: { value: "YEN", code: "¥" },
                    70: { value: "AUD", code: "$" },
                    80: { value: "CAD", code: "$" },
                    90: { value: "NOK", code: "kr" },
                    100: { value: "ZAR", code: "R" },
                    110: { value: "SEK", code: "kr" },
                    120: { value: "CHF", code: "chf" },
                    130: { value: "AED", code: "aed" },
                    140: { value: "QAR", code: "qar" },
                    150: { value: "SGD", code: "S$" }
                }
            };
        }
        CurrencyEnums.Default = function () { return new CurrencyEnums(); };
        return CurrencyEnums;
    }());
    Shared.CurrencyEnums = CurrencyEnums;
    var ExpensesEnums = /** @class */ (function () {
        function ExpensesEnums() {
            this.PersonalOrCompany = {
                PERSONAL: 0,
                COMPANY: 1,
                properties: {
                    0: { description: 'Personal' },
                    1: { description: 'Company' }
                }
            };
            this.ExpenseTypeCategory = {
                MILEAGE: 'MILEAGE'
            };
            this.ExpenseWarningCodeTypes = {
                HighRisk: 1,
                Amount: 2,
                TwentyFourMonthRule: 3,
            };
            this.ExpenseSubmissionType = {
                UNKNOWN: 0,
                MILEAGE: 1,
                RECEIPTATTACHED: 2,
                RECEIPTPRINTED: 3,
                MIRACLEMANUAL: 4,
                properties: {
                    0: { description: 'Unknown' },
                    1: { description: 'Mileage' },
                    2: { description: 'Receipt Attached' },
                    3: { description: 'Receipt Printed' },
                    4: { description: 'Manual' }
                }
            };
            this.ReceiptStatus = {
                UNKNOWN: 0,
                UNATTACHED: 1,
                UNSUBMITTED: 2,
                SUBMITTED: 3
            };
            this.FuelTypes = {
                PETROL: 1,
                DIESEL: 2,
                LPG: 3,
                HYBRIDP: 4,
                HYBRIDD: 5,
                ELECTRIC: 6,
                BIOFUEL: 7,
                EURO6D: 8,
                properties: {
                    1: { description: 'Petrol' },
                    2: { description: 'Diesel' },
                    3: { description: 'LPG' },
                    4: { description: 'Hybrid Petrol' },
                    5: { description: 'Hybrid Diesel' },
                    6: { description: 'Electric' },
                    7: { description: 'Biofuel' },
                    8: { description: 'Euro6d' }
                }
            };
            this.EngineSize = {
                PETROL1_1400: 10,
                PETROL1401_2000: 20,
                PETROL2001_9999: 30,
                LPG1_1400: 40,
                LPG1401_2000: 50,
                LPG2001_9999: 60,
                DIESEL1_1600: 70,
                DIESEL1601_2000: 80,
                DIESEL2001_9999: 90,
                properties: {
                    10: { description: "1-1400cc", code: "1400" },
                    20: { description: "1401-2000cc", code: "2000" },
                    30: { description: "2001-9999cc", code: "9999" },
                    40: { description: "1-1400cc", code: "1400" },
                    50: { description: "1401-2000cc", code: "2000" },
                    60: { description: "2001-9999cc", code: "9999" },
                    70: { description: "1-1600cc", code: "1600" },
                    80: { description: "1601-2000cc", code: "2000" },
                    90: { description: "2001-9999cc", code: "9999" },
                }
            };
        }
        ExpensesEnums.Default = function () { return new ExpensesEnums(); };
        return ExpensesEnums;
    }());
    Shared.ExpensesEnums = ExpensesEnums;
    var ImageEnums = /** @class */ (function () {
        function ImageEnums() {
            this.ImageSize = {
                ORIGINAL: 0,
                CUSTOM: 1,
                ASPECTRATIO: 2
            };
        }
        ImageEnums.Default = function () { return new ImageEnums(); };
        return ImageEnums;
    }());
    Shared.ImageEnums = ImageEnums;
    var DocumentStorageEnums = /** @class */ (function () {
        function DocumentStorageEnums() {
            this.FileView = {
                DETAILED: 0,
                THUMBNAIL: 1
            };
            this.SharedDriveLinkStatus = {
                NONE: 0,
                SUCCESSFUL: 1,
                ERROR: 2
            };
            this.DocumentCategory = {
                FOLDER: "",
                RECENTLYADDED: "Recently Added",
                FAVOURITES: "Favourites",
                SHAREDDRIVE: "Brookson Shared Drive"
            };
            this.DocumentDataSource = {
                MEMBERWEBDOCUMENTS: 0,
                QUEUESERVICE: 1,
                MOLEDATA: 2,
                DROPBOX: 3
            };
        }
        DocumentStorageEnums.Default = function () { return new DocumentStorageEnums(); };
        return DocumentStorageEnums;
    }());
    Shared.DocumentStorageEnums = DocumentStorageEnums;
    var DialogueEnums = /** @class */ (function () {
        function DialogueEnums() {
            this.Dialogues = {
                MILEAGE24MONTHRULE: "MILEAGE24MONTHRULE",
                EXPENSESNOTICE: "EXPENSESNOTICE"
            };
        }
        DialogueEnums.Default = function () { return new DialogueEnums(); };
        return DialogueEnums;
    }());
    Shared.DialogueEnums = DialogueEnums;
    var PersonalTaxEnums = /** @class */ (function () {
        function PersonalTaxEnums() {
            this.Timeframes = {
                FORECAST: "FORECAST",
                YEARTODATE: "YEARTODATE",
                properties: {
                    "FORECAST": { value: "FORECAST", description: "Forecast" },
                    "YEARTODATE": { value: "YEARTODATE", description: "Year To Date" }
                }
            };
        }
        PersonalTaxEnums.Default = function () { return new PersonalTaxEnums(); };
        return PersonalTaxEnums;
    }());
    Shared.PersonalTaxEnums = PersonalTaxEnums;
    var TaskPlannerEnums = /** @class */ (function () {
        function TaskPlannerEnums() {
            this.TaskStatus = {
                COMPLETED: 0,
                CURRENT: 1,
                FUTURE: 2,
                OVERDUE: 3,
                properties: {
                    0: { values: 0, description: "Completed", css: "task-completed" },
                    1: { values: 1, description: "Current", css: "task-current" },
                    2: { values: 2, description: "Future", css: "task-future" },
                    3: { values: 3, description: "Overdue", css: "task-overdue" },
                }
            };
            this.TaskResponsibility = {
                ME: 'Me',
                BROOKSON: 'Brookson'
            };
        }
        TaskPlannerEnums.Default = function () { return new TaskPlannerEnums(); };
        return TaskPlannerEnums;
    }());
    Shared.TaskPlannerEnums = TaskPlannerEnums;
    var LoggingEnums = /** @class */ (function () {
        function LoggingEnums() {
            this.LoggingLevel = {
                DEBUG: 0,
                INFO: 1,
                WARN: 2,
                ERROR: 3,
                FATAL: 4
            };
        }
        LoggingEnums.Default = function () { return new LoggingEnums(); };
        return LoggingEnums;
    }());
    Shared.LoggingEnums = LoggingEnums;
    var BankLinkEnums = /** @class */ (function () {
        function BankLinkEnums() {
            this.BankAccountType = {
                CURRENT: 0,
                DEPOSIT: 1,
                CREDIT_CARD: 2,
                DEPOSIT_BOND: 3
            };
            this.TransactionType = {
                BUSINESS: 0,
                PERSONAL: 1,
                UNALLOCATED: 2,
                ALL: 3,
                OUTGOINGS: 4,
                properties: {
                    0: { description: 'Business' },
                    1: { description: 'Personal' },
                    2: { description: 'Unallocated' },
                    3: { description: 'All Types' },
                    4: { description: 'Outgoings & Balances' }
                }
            };
            this.TransactionStatuses = {
                NONE: 0,
                SAVED: 1,
                SUBMITTED: 2,
                PROCESSED: 3,
                INTOUCHPROCESSED: 4,
            };
            this.BankLogos = {
                BARCLAYS: '/Content/img/logos/banklogos/svg/logo_barclays.svg',
                CASHPLUS: '/Content/img/logos/banklogos/svg/logo_cashplus.svg',
                HSBC: '/Content/img/logos/banklogos/svg/logo_hsbc.svg',
                LLOYDS: '/Content/img/logos/banklogos/svg/logo_lloyds.svg',
                RBS: '/Content/img/logos/banklogos/svg/logo_rbs.svg',
                SANTANDER: '/Content/img/logos/banklogos/svg/logo_santander.png',
                HALIFAX: '/Content/img/logos/banklogos/svg/halifax.svg'
            };
            this.BankIcons = {
                BARC: '/Content/img/logos/banklogos/svg/icon_barclays.svg',
                CASHPLUS: '/Content/img/logos/banklogos/svg/icon_cashplus.svg',
                HSBC: '/Content/img/logos/banklogos/svg/icon_hsbc.svg',
                LLOYDS: '/Content/img/logos/banklogos/svg/icon_lloydsbank.svg',
                RBS: '/Content/img/logos/banklogos/svg/icon_rbs.svg',
                SANTANDER: '/Content/img/logos/banklogos/svg/icon_santander.svg',
                HALIFAX: '/Content/img/logos/banklogos/svg/halifax.svg'
            };
        }
        BankLinkEnums.Default = function () { return new BankLinkEnums(); };
        return BankLinkEnums;
    }());
    Shared.BankLinkEnums = BankLinkEnums;
    var NotificationEnums = /** @class */ (function () {
        function NotificationEnums() {
            this.NotificationSymbol = {
                "money": 'fa-gbp',
                "process": 'fa-cog',
                "guide": 'fa-question-circle',
                "video": 'fa-play',
                "document": 'fa-file',
                "book": 'fa-calendar',
                "information": 'fa-info-circle'
            };
            this.NotificationColourLabel = {
                "red": 'label-danger',
                "blue": 'label-primary',
                "green": 'label-success',
                "yellow": 'label-warning',
                "grey": 'label-default'
            };
        }
        NotificationEnums.Default = function () { return new NotificationEnums(); };
        return NotificationEnums;
    }());
    Shared.NotificationEnums = NotificationEnums;
    var HolidaysEnums = /** @class */ (function () {
        function HolidaysEnums() {
            this.HolidayRequestStatus = {
                ALL: 0,
                PENDING: 1,
                APPROVED: 2,
                REJECTED: 3,
                properties: {
                    0: { description: "All" },
                    1: { description: "Pending" },
                    2: { description: "Approved" },
                    3: { description: "Rejected" }
                }
            };
        }
        HolidaysEnums.Default = function () { return new HolidaysEnums(); };
        return HolidaysEnums;
    }());
    Shared.HolidaysEnums = HolidaysEnums;
    var MemberEnums = /** @class */ (function () {
        function MemberEnums() {
            this.ServiceLineRole = {
                UNKNOWN: 'UNKNOWN',
                DIRECTOR: 'DIRECTOR',
                SHAREHOLDER: 'SHAREHOLDER',
                EMPLOYEE: 'EMPLOYEE',
                NONPRINCIPALDIR: 'NON PRINCIPAL DIR'
            };
            this.ServiceLineBusinessType = {
                UNKNOWN: 'UNKNOWN',
                LTD: 'LTD',
                UMBRELLA: 'UMBRELLA',
                SME: 'SME'
            };
        }
        MemberEnums.Default = function () { return new MemberEnums(); };
        return MemberEnums;
    }());
    Shared.MemberEnums = MemberEnums;
    var IR35Enums = /** @class */ (function () {
        function IR35Enums() {
            this.IR35Status = {
                IR35Status_TaxedAsPAYE: 0,
                IR35Status_TaxedAsSelfEmployed: 1,
                IR35Status_Caution: 2,
                IR35Status_ActionRequired: 3,
                IR35Status_WithdrawnReview: 4,
                IR35Status_AssessmentFormSubmit: 5,
                IR35Status_AssessmentFormStarted: 6,
                properties: {
                    0: { description: "Taxed as PAYE" },
                    1: { description: "Taxed as Self Employed" },
                    2: { description: "Caution" },
                    3: { description: "Action Required" },
                    4: { description: "Review Incomplete" },
                    5: { description: "Assessment Form Submitted" },
                    6: { description: "Assessment Form Incomplete" }
                }
            };
        }
        IR35Enums.Default = function () { return new IR35Enums(); };
        return IR35Enums;
    }());
    Shared.IR35Enums = IR35Enums;
    angular.module("app.shared")
        .constant("contact.enums", ContactEnums.Default())
        .constant("invoicing.enums", InvoicingEnums.Default())
        .constant("currency.enums", CurrencyEnums.Default())
        .constant("expenses.enums", ExpensesEnums.Default())
        .constant("image.enums", ImageEnums.Default())
        .constant("documentStorage.enums", DocumentStorageEnums.Default())
        .constant('dialogue.enums', DialogueEnums.Default())
        .constant('personalTax.enums', PersonalTaxEnums.Default())
        .constant('taskPlanner.enums', TaskPlannerEnums.Default())
        .constant('logging.enums', LoggingEnums.Default())
        .constant('bankLink.enums', BankLinkEnums.Default())
        .constant('notification.enums', NotificationEnums.Default())
        .constant('holidays.enums', HolidaysEnums.Default())
        .constant('member.enums', MemberEnums.Default())
        .constant('ir35.enums', IR35Enums.Default());
})(Shared || (Shared = {}));
/// <reference path="../../_all.ts"/>
/// <reference path="../../shared/services/brookson.services.authentication.ts" />
/// <reference path="./../../shared/modules/brookson.ui.popup.ts" />
/// <reference path="../../shared/modules/brookson.enums.ts" />
var Login;
(function (Login) {
    var BrooksonLoginForgottenPassword = /** @class */ (function () {
        function BrooksonLoginForgottenPassword() {
            this.controller = ForgottenPasswordCtrlController;
            this.templateUrl = "src/app/login/views/forgottenPassword.html";
        }
        return BrooksonLoginForgottenPassword;
    }());
    Login.BrooksonLoginForgottenPassword = BrooksonLoginForgottenPassword;
    var ForgottenPasswordCtrlController = /** @class */ (function () {
        function ForgottenPasswordCtrlController($state, authenticationSrv, popup, enums, dateUtils, $window) {
            var _this = this;
            this.$state = $state;
            this.authenticationSrv = authenticationSrv;
            this.popup = popup;
            this.enums = enums;
            this.dateUtils = dateUtils;
            this.$window = $window;
            this.username = "";
            this.message = null;
            this.smsMessage = "";
            this.isForgottenId = false;
            this.isForgottenPassword = false;
            this.forgottenIdFirstName = "";
            this.forgottenIdSurname = "";
            this.forgottenIdEmail = "";
            this.requestPasswordReset = function (form) {
                if (form.$invalid) {
                    _this.message = "Please enter your username";
                    return;
                }
                _this.resetMessage();
                _this.authenticationSrv.requestPasswordReset(_this.username)
                    .then(function (data) {
                    if (data) {
                        _this.popup.showInfoPopup('Reset link sent', 'An SMS was sent to your mobile phone number. Please follow the instructions in order to reset your password. If you have any complications please call us on ' + _this.enums.ContactInformation.CustomerServicesPhone + ' for assistance.')
                            .then(function () {
                            _this.$state.go('login.login');
                        });
                    }
                    else {
                        _this.message = 'We were unable to send you the instuctions to reset your password. Please call us on ' + _this.enums.ContactInformation.CustomerServicesPhone + ' for assistance.';
                        return;
                    }
                })
                    .catch(function (error) {
                    _this.message = 'We were unable to send you the instuctions to reset your password. Please call us on ' + _this.enums.ContactInformation.CustomerServicesPhone + ' for assistance.';
                    return;
                });
            };
            this.requestForgottenClientId = function (form, $event) {
                if (form.$invalid) {
                    _this.message = "All information is required to complete your request.";
                    return;
                }
                _this.resetMessage();
                var convertedDOB = _this.dateUtils.convertDateToMidnightGmt(_this.forgottenIdDob);
                var dOBString = convertedDOB.toISOString();
                _this.authenticationSrv.requestForgottenClientId(_this.forgottenIdFirstName, _this.forgottenIdSurname, _this.forgottenIdEmail, dOBString)
                    .then(function (data) {
                    if (data) {
                        _this.popup.showInfoPopup('Client ID sent', 'An SMS has been sent to your mobile phone number. Please use this Client ID as your username for Connect. If you have any complications, please call us on ' + _this.enums.ContactInformation.CustomerServicesPhone + ' for assistance.')
                            .then(function () {
                            _this.$state.go('login.login');
                        });
                        return;
                    }
                    else {
                        _this.message = 'We were unable to send your client ID. Please review your details and try again, if the problem persists please call us on ' + _this.enums.ContactInformation.CustomerServicesPhone + ' for assistance.';
                        return;
                    }
                })
                    .catch(function (error) {
                    _this.message = 'We were unable to send your client ID. Please call us on ' + _this.enums.ContactInformation.CustomerServicesPhone + ' for assistance.';
                    return;
                });
            };
            this.hasForgottenId = function (input) {
                _this.resetMessage();
                _this.isForgottenId = input;
                _this.isForgottenPassword = !input;
            };
            this.hasForgottenPassword = function (input) {
                _this.resetMessage();
                _this.isForgottenPassword = input;
                _this.isForgottenId = !input;
            };
            this.goToLogin = function () {
                _this.$state.go("login.login");
            };
            this.resetMessage = function () {
                _this.message = null;
            };
            if (this.$window.appSettings.isIntouchSite) {
                this.enums.ContactInformation.CustomerServicesPhone = '01202 901951';
            }
        }
        ForgottenPasswordCtrlController.$inject = ['$state', 'authenticationSrv', 'brookson.ui.popup', 'contact.enums', 'brookson.utilities.date', "$window"];
        return ForgottenPasswordCtrlController;
    }());
})(Login || (Login = {}));
var Shared;
(function (Shared) {
    var VatScheme = /** @class */ (function () {
        function VatScheme() {
        }
        VatScheme.none = "_blank_";
        VatScheme.flatRate = "FRV";
        VatScheme.nonFlatRate = "Non_FRV";
        return VatScheme;
    }());
    Shared.VatScheme = VatScheme;
})(Shared || (Shared = {}));
/// <reference path="./../enums/VatScheme.ts"/>
var Shared;
(function (Shared) {
    var BusinessDetailSummary = /** @class */ (function () {
        function BusinessDetailSummary() {
            var _this = this;
            this.getEffectiveVatSchemeOn = function (date) {
                if (!date || (!_this.flatRateVatEffectiveDate && !_this.standardRateVatEffectiveDate)) {
                    return _this.vatScheme;
                }
                switch (_this.vatScheme) {
                    case Shared.VatScheme.nonFlatRate:
                        if (_this.standardRateVatEffectiveDate) {
                            return date < _this.standardRateVatEffectiveDate ? Shared.VatScheme.flatRate : Shared.VatScheme.nonFlatRate;
                        }
                        return date < _this.flatRateVatEffectiveDate ? Shared.VatScheme.nonFlatRate : Shared.VatScheme.flatRate;
                    case Shared.VatScheme.flatRate:
                        if (_this.flatRateVatEffectiveDate) {
                            return date < _this.flatRateVatEffectiveDate ? Shared.VatScheme.nonFlatRate : Shared.VatScheme.flatRate;
                        }
                        return date < _this.standardRateVatEffectiveDate ? Shared.VatScheme.flatRate : Shared.VatScheme.nonFlatRate;
                    default:
                        if (_this.standardRateVatEffectiveDate) {
                            return date < _this.standardRateVatEffectiveDate ? Shared.VatScheme.none : Shared.VatScheme.nonFlatRate;
                        }
                        return date < _this.flatRateVatEffectiveDate ? Shared.VatScheme.none : Shared.VatScheme.flatRate;
                }
            };
        }
        return BusinessDetailSummary;
    }());
    Shared.BusinessDetailSummary = BusinessDetailSummary;
})(Shared || (Shared = {}));
/// <reference path="../models/BusinessDetailSummary.ts" />
/// <reference path="./brookson.services.member.ts"/>
/// <reference path="./../models/member/ServiceLine.ts"/>
var Shared;
(function (Shared) {
    var ServiceLineService = /** @class */ (function () {
        function ServiceLineService($http, $q, sharedConfig, memberSrv) {
            var _this = this;
            this.$http = $http;
            this.$q = $q;
            this.sharedConfig = sharedConfig;
            this.memberSrv = memberSrv;
            this.serviceLines = [];
            this.getBusinessDetailSummary = function () {
                return _this.$http.get(_this.serviceBase + 'api/Member/GetBusinessDetailSummary', {
                    cache: true
                })
                    .then(function (response) {
                    var businessDetailSummary = new Shared.BusinessDetailSummary();
                    businessDetailSummary.companyName = response.data.companyName;
                    businessDetailSummary.companyRegistrationNo = response.data.companyRegistrationNo;
                    businessDetailSummary.vatNo = response.data.vatNo;
                    businessDetailSummary.vatScheme = response.data.vatScheme;
                    if (response.data.flatRateVatEffectiveDate) {
                        businessDetailSummary.flatRateVatEffectiveDate = new Date(response.data.flatRateVatEffectiveDate);
                    }
                    if (response.data.standardRateVatEffectiveDate) {
                        businessDetailSummary.standardRateVatEffectiveDate = new Date(response.data.standardRateVatEffectiveDate);
                    }
                    _this.businessDetailSummary = businessDetailSummary;
                    return _this.businessDetailSummary;
                });
            };
            this.getServiceLines = function (member) {
                var deferred = _this.$q.defer();
                if (member.memberId) {
                    if (_this.serviceLines.length > 0) {
                        deferred.resolve(_this.serviceLines);
                    }
                    else {
                        _this.$http.get(_this.serviceBase + 'api/Member/GetServiceLinesDistinct/' + member.memberId)
                            .success(function (data) {
                            //save in the service;
                            _this.serviceLines = data;
                            deferred.resolve(data);
                        }).error(function (err, status) {
                            deferred.reject(err);
                        });
                    }
                }
                else {
                    deferred.reject({ error_description: 'Invalid Member Id.' });
                }
                return deferred.promise;
            };
            this.serviceBase = sharedConfig.baseApiUrl;
        }
        ServiceLineService.$inject = ['$http', '$q', 'shared.config', 'memberSrv'];
        return ServiceLineService;
    }());
    Shared.ServiceLineService = ServiceLineService;
})(Shared || (Shared = {}));
angular
    .module('app.shared')
    .service('serviceLineSrv', Shared.ServiceLineService);
var Shared;
(function (Shared) {
    // $Classes/Enums/Interfaces(filter)[template][separator]
    // filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
    // template: The template to repeat for each matched item
    // separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]
    // More info: http://frhagn.github.io/Typewriter/
    var Notification = /** @class */ (function () {
        function Notification() {
            // ID
            this.id = 0;
            // COMPANYCONTACTNO
            this.companyContactNo = null;
            // TYPE
            this.type = null;
            // TITLE
            this.title = null;
            // METADESCRIPTION
            this.metaDescription = null;
            // LINK
            this.link = null;
            // SYMBOL
            this.symbol = null;
            // COLOUR
            this.colour = null;
            // SHOWGUIDE
            this.showGuide = false;
            // ACTION
            this.action = null;
            this.sortOrder = 0;
            this.onClick = null;
            this.documentCategoryMappingId = 0;
            this.documents = null;
        }
        return Notification;
    }());
    Shared.Notification = Notification;
})(Shared || (Shared = {}));
/// <reference path="./Notification.ts"/>
var Shared;
(function (Shared) {
    // $Classes/Enums/Interfaces(filter)[template][separator]
    // filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
    // template: The template to repeat for each matched item
    // separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]
    // More info: http://frhagn.github.io/Typewriter/
    var GetNotificationsResponse = /** @class */ (function () {
        function GetNotificationsResponse() {
            // SMARTTILENOTIFICATIONS
            this.smartTileNotifications = [];
            // ALERTNOTIFICATIONS
            this.alertNotifications = [];
            // ACTIONNOTIFACTIONS
            this.actionTileNotifications = [];
            // ACTIONNOTIFACTIONS
            this.bannersNotifications = [];
        }
        return GetNotificationsResponse;
    }());
    Shared.GetNotificationsResponse = GetNotificationsResponse;
    var TileNotificationsResponse = /** @class */ (function () {
        function TileNotificationsResponse() {
            // SMARTTILENOTIFICATIONS
            this.smartTileNotifications = [];
            // ALERTNOTIFICATIONS
            //public alertNotifications: Notification[] = [];
            // ACTIONNOTIFACTIONS
            this.actionTileNotifications = [];
            // ACTIONNOTIFACTIONS
            //public bannersNotifications: Notification[] = [];
        }
        return TileNotificationsResponse;
    }());
    Shared.TileNotificationsResponse = TileNotificationsResponse;
})(Shared || (Shared = {}));
var Shared;
(function (Shared) {
    // $Classes/Enums/Interfaces(filter)[template][separator]
    // filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
    // template: The template to repeat for each matched item
    // separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]
    var TaskAction = /** @class */ (function () {
        function TaskAction() {
            // ACTIONID
            this.actionId = null;
            // ACTION_WEB_TASK_NO
            this.action_Web_Task_no = null;
            // ACTIONTITLE
            this.actionTitle = null;
            // ACTIONDESCRIPTION
            this.actionDescription = null;
            // EXTENDEDACTIONDESCRIPTION
            this.extendedActionDescription = null;
            // RESPONSIBILITY
            this.responsibility = null;
            // DUEDATE
            this.dueDate = null;
            // DEADLINE
            this.deadline = null;
            // STATUS
            this.status = null;
            // ACTIONORDER
            this.actionOrder = 0;
            // ATTACHMENT
            this.attachment = null;
            // ISINWARNING
            this.isInWarning = false;
            // BUTTON1TEXT
            this.button1Text = null;
            // BUTTON2TEXT
            this.button2Text = null;
            // CATEGORYID
            this.categoryId = 0;
            this.categoryDesc = "";
            this.documents = [];
            this.closeable = false;
            this.closeMessage = "";
            this.taskCode = "";
            this.taskTitle = "";
            this.camelCase = "";
        }
        return TaskAction;
    }());
    Shared.TaskAction = TaskAction;
    var TaskStatus;
    (function (TaskStatus) {
        TaskStatus[TaskStatus["completed"] = 0] = "completed";
        TaskStatus[TaskStatus["current"] = 1] = "current";
        TaskStatus[TaskStatus["future"] = 2] = "future";
        TaskStatus[TaskStatus["overdue"] = 3] = "overdue";
    })(TaskStatus = Shared.TaskStatus || (Shared.TaskStatus = {}));
})(Shared || (Shared = {}));
/// <reference path="./../../_all.ts"/>
(function () {
    'use strict';
    angular
        .module('app.shared')
        .service('notificationSrv', notificationSrv);
    notificationSrv.$inject = ['$http', 'shared.config'];
    function notificationSrv($http, sharedConfig) {
        var service = {};
        var serviceBase = sharedConfig.baseApiUrl;
        // Methods
        service.getTileNotifications = getTileNotifications;
        service.closeNotification = closeNotification;
        service.getAlertNotifications = getAlertNotifications;
        function getTileNotifications(silentMode) {
            return $http.get(serviceBase + 'api/Notifications/GetTileNotifications', {
                params: {
                    silentMode: silentMode ? silentMode : false
                },
                cache: true
            }).then(function (response) {
                return response.data;
            });
        }
        function getAlertNotifications(silentMode) {
            return $http.get(serviceBase + 'api/Notifications/GetAlertNotifications', {
                params: {
                    silentMode: silentMode ? silentMode : false
                },
                cache: true
            }).then(function (response) {
                return response.data;
            });
        }
        function closeNotification(notification) {
            return $http.delete(serviceBase + "api/Notifications/DeleteNotification/" + notification.id)
                .then(function (response) {
                return response.data;
            });
        }
        return service;
    }
})();
/// <reference path="./TaskAction.ts"/>
var Shared;
(function (Shared) {
    // $Classes/Enums/Interfaces(filter)[template][separator]
    // filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
    // template: The template to repeat for each matched item
    // separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]
    // More info: http://frhagn.github.io/Typewriter/
    var Task = /** @class */ (function () {
        function Task() {
            // TASKTITLE
            this.taskTitle = null;
            // COMPLETEDDATE
            this.completedDate = null;
            // TASKACTIONS
            this.taskActions = [];
            // TASKCODE
            this.taskCode = null;
            // BUSINESS
            this.business = false;
        }
        return Task;
    }());
    Shared.Task = Task;
    var TaskObject = /** @class */ (function () {
        function TaskObject() {
            this.title = null;
            this.type = null;
            this.startsAt = null;
            this.endsAt = null;
            this.action_Web_Task_no = null;
            this.status = null;
            this.actionId = null;
            this.actionTitle = null;
            this.timestamp = null;
            this.events = null;
            this.highlightMonth = false;
        }
        return TaskObject;
    }());
    Shared.TaskObject = TaskObject;
})(Shared || (Shared = {}));
var Shared;
(function (Shared) {
    // $Classes/Enums/Interfaces(filter)[template][separator]
    // filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
    // template: The template to repeat for each matched item
    // separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]
    // More info: http://frhagn.github.io/Typewriter/
    var MemberCurrentStage = /** @class */ (function () {
        function MemberCurrentStage() {
            // MEMBERID
            this.memberId = 0;
            // STAGE
            this.stage = 0;
            // STEP3
            this.step3 = false;
            // STEP4
            this.step4 = false;
            // COMPLETIONDATE
            this.completionDate = null;
            // COUNTOFASSIGNMENTREQUIRINGACTIONS
            this.countOfAssignmentRequiringActions = 0;
            // ISIR35CONFIRMED
            this.isIr35Confirmed = false;
            // ISDRAFTSCONFIRMED
            this.isDraftsConfirmed = false;
            // SHOWCONFIRMATIONMESSAGE
            this.showConfirmationMessage = false;
        }
        return MemberCurrentStage;
    }());
    Shared.MemberCurrentStage = MemberCurrentStage;
})(Shared || (Shared = {}));
var Shared;
(function (Shared) {
    var UtrNumber = /** @class */ (function () {
        function UtrNumber() {
            this.utrReceived = null;
            this.utrNumber = null;
        }
        return UtrNumber;
    }());
    Shared.UtrNumber = UtrNumber;
})(Shared || (Shared = {}));
/// <reference path="./../../_all.ts"/>
/// <reference path="./../models/Task.ts"/>
/// <reference path="./../interfaces/brookson.interfaces.http.ts"/>
/// <reference path="../models/MemberCurrentStage.ts" />
/// <reference path="./../modules/brookson.enums.ts" />
/// <reference path="../models/UtrNumber.ts" />
/// <reference path="../models/TaxPackSummary.ts" />
var Shared;
(function (Shared) {
    var TaskPlannerSrv = /** @class */ (function () {
        function TaskPlannerSrv($http, $q, logger, growl, $stateParams, documentStorageSrv, brooksonPdfModal, enums, screenSize, $cacheFactory, $rootScope) {
            var _this = this;
            this.$http = $http;
            this.$q = $q;
            this.logger = logger;
            this.growl = growl;
            this.$stateParams = $stateParams;
            this.documentStorageSrv = documentStorageSrv;
            this.brooksonPdfModal = brooksonPdfModal;
            this.enums = enums;
            this.screenSize = screenSize;
            this.$cacheFactory = $cacheFactory;
            this.$rootScope = $rootScope;
            this.sectionTitle = '';
            this.selectedTask = {};
            this.selectedAction = new Shared.TaskAction();
            //private methods
            this.buildMonthsArray = function () {
                var months = [];
                var i;
                for (i = -2; i < 10; i++) {
                    var selectedMonth = moment(_this.viewDate).add(i, 'month').startOf('month');
                    var currentMonth = moment().startOf('month');
                    //var month = {
                    //    timestamp: selectedMonth,
                    //    events: [],
                    //    highlightMonth: (moment(selectedMonth).isSame(currentMonth) ? true : false)
                    //};
                    var month = new Shared.TaskObject();
                    month.timestamp = selectedMonth;
                    month.events = [];
                    month.highlightMonth = (moment(selectedMonth).isSame(currentMonth) ? true : false);
                    months.push(month);
                }
                return months;
            };
            this.flattenActions = function (data) {
                var result = [];
                result = _.chain(data).map(function (task) {
                    return _.map(task.taskActions, function (taskAction) {
                        taskAction.taskGroup = task.taskTitle;
                        return taskAction;
                    });
                }).flatten().value();
                return result;
            };
            //public methods
            this.updateUTR = function (utrNumber, branchId) {
                var url = 'api/Planner/UpdateUTRNumbers';
                return _this.$http.post(url, {
                    UtrNumber: utrNumber, BranchId: branchId
                }).then(function (response) {
                    _this.buildMonths(false, false).then(function (data) {
                        var config = { title: "Task Planner" };
                        _this.growl.success("UTR has been updated.", config);
                        _this.closeTask(_this.selectedAction).then(function () {
                            var cache = _this.$cacheFactory.get('$http');
                            cache.remove('api/Planner/GetTasks');
                            _this.getAndParseTasks().then(function () {
                                _this.updateCurrentTaskAndAction();
                            });
                        });
                    });
                    return response.data;
                }).catch(function () {
                    var config = { title: "Task Planner" };
                    _this.growl.error("UTR failed to update.", config);
                });
            };
            this.updateAuthCode = function (authCode) {
                var url = 'api/Planner/UpdateAuthCode';
                return _this.$http.post(url, {
                    AuthCode: authCode
                }).then(function (response) {
                    _this.buildMonths(false, false).then(function (data) {
                        var config = { title: "Task Planner" };
                        _this.growl.success("Auth Code has been updated.", config);
                        _this.closeTask(_this.selectedAction).then(function () {
                            var cache = _this.$cacheFactory.get('$http');
                            cache.remove('api/Planner/GetTasks');
                            _this.getAndParseTasks().then(function () {
                                _this.updateCurrentTaskAndAction();
                            });
                        });
                    });
                    return response.data;
                }).catch(function () {
                    var config = { title: "Task Planner" };
                    _this.growl.error("Auth Code failed to update.", config);
                });
            };
            this.updateCurrentTaskAndAction = function () {
                if (_this.tasks.length) {
                    var task = _.find(_this.tasks, function (n) { return (n.id.toLowerCase() === _this.$stateParams['taskID'].toLowerCase()); });
                    if (!task || task.taskActions.length === 0) {
                        _this.taskActions = [];
                    }
                    else {
                        _this.taskActions = task.taskActions;
                        _this.selectedTask = task;
                        _this.taskTitle = task.taskTitle;
                        if (_this.selectedAction.action_Web_Task_no) {
                            var action = _.find(_this.taskActions, function (m) { return (m.action_Web_Task_no === _this.selectedAction.action_Web_Task_no); });
                            if (action) {
                                _this.selectedAction.status = action.status;
                                _this.selectedAction = action;
                            }
                        }
                    }
                }
            };
            this.buildMonths = function (silentMode, cacheMode) {
                if (silentMode === void 0) { silentMode = true; }
                if (cacheMode === void 0) { cacheMode = true; }
                // Get the tasks, once complete, filter them into the monthly buckets
                return _this.getTasks(silentMode, cacheMode).then(function (data) {
                    _this.flatActions = _this.flattenActions(data);
                    return _this.getTasksComplete(data);
                });
            };
            this.getAndParseTasks = function (silentMode) {
                return _this.getTasks(silentMode).then(function (data) {
                    return _this.parseTasks(data);
                });
            };
            this.parseTasks = function (data) {
                // Do any special parsing of the tasks here
                var deferred = _this.$q.defer();
                _this.sectionTitles.business.overdue = 0;
                _this.sectionTitles.personal.overdue = 0;
                // Add on an ID for menus and an overdue counter
                for (var i = 0; i < data.length; i++) {
                    data[i].id = _.camelCase(data[i].taskTitle);
                    data[i].overdue = 0;
                    data[i].taskActions = _.orderBy(data[i].taskActions, ['actionOrder'], ['asc']);
                    var taskActions = data[i].taskActions;
                    for (var j = 0; j < taskActions.length; j++) {
                        // Status: 0 = Completed, 1 = Current, 2 = Future, 3 = Overdue
                        // Overdue calcs
                        if (taskActions[j].status === 3) {
                            // BUSINESS
                            if (data[i].business) {
                                _this.sectionTitles.business.overdue++;
                            }
                            else {
                                // PERSONAL
                                _this.sectionTitles.personal.overdue++;
                            }
                            data[i].overdue++;
                        }
                        // /Overdue calcs
                    }
                }
                _this.tasks = data;
                deferred.resolve(data);
                return deferred.promise;
            };
            this.getTasksComplete = function (data) {
                var months = [];
                var deferred = _this.$q.defer();
                months = _this.buildMonthsArray();
                // Loop over each month and find any data within data
                if (data !== null) {
                    for (var month = 0; month < months.length; month++) {
                        var currentMonth = moment(months[month].timestamp);
                        var i;
                        for (i = 0; i < data.length; i++) {
                            var j;
                            for (j = 0; j < data[i].taskActions.length; j++) {
                                var taskDate = data[i].taskActions[j].dueDate;
                                if (moment(taskDate).startOf('month').isSame(currentMonth)) {
                                    var date = moment(taskDate);
                                    //var task = {
                                    //    title: data[i].taskTitle,
                                    //    type: 'info',
                                    //    startsAt: date,
                                    //    endsAt: date,
                                    //    action_Web_Task_no: data[i].taskActions[j].action_Web_Task_no,
                                    //    // Status: 0 = Completed, 1 = Current, 2 = Future, 3 = Overdue
                                    //    status: data[i].taskActions[j].status,
                                    //    actionId: data[i].taskActions[j].actionId,
                                    //    actionTitle: data[i].taskActions[j].actionTitle
                                    //};
                                    var task = new Shared.TaskObject();
                                    task.title = data[i].taskTitle;
                                    task.type = 'info';
                                    task.startsAt = date;
                                    task.endsAt = date;
                                    task.action_Web_Task_no = data[i].taskActions[j].action_Web_Task_no;
                                    task.status = data[i].taskActions[j].status;
                                    task.actionId = data[i].taskActions[j].actionId;
                                    task.actionTitle = data[i].taskActions[j].actionTitle;
                                    months[month].events.push(task);
                                }
                            }
                        }
                    }
                }
                _this.annualMonths = months;
                deferred.resolve(_this.annualMonths);
                return deferred.promise;
            };
            this.getTasks = function (silentMode, cacheMode) {
                if (cacheMode === void 0) { cacheMode = true; }
                var url = 'api/Planner/GetTasks';
                if (_this.overrideCacheMode)
                    cacheMode = false;
                return _this.$http.get(url, {
                    silentMode: silentMode ? silentMode : false,
                    cache: cacheMode
                }).then(function (response) {
                    if (response.data === "nill") {
                        response.data = [];
                    }
                    return response.data;
                });
            };
            this.getActionsByDay = function (day) {
                var result = [];
                result = _.filter(_this.flatActions, function (n) {
                    return moment(n.dueDate).isSame(day, 'day');
                });
                return result;
            };
            this.getActionById = function (id) {
                var result = [];
                result = _.filter(_this.flatActions, function (n) {
                    return n.actionId === id;
                });
                return result;
            };
            this.addMonth = function () {
                _this.viewDate = moment(_this.viewDate).add(1, 'months');
                _this.buildMonths(false);
            };
            this.subtractMonth = function () {
                _this.viewDate = moment(_this.viewDate).subtract(1, 'months');
                _this.buildMonths(false);
            };
            this.getTaskActions = function (silentMode) {
                if (silentMode === void 0) { silentMode = false; }
                return _this.getTasks(silentMode).then(function (data) {
                    var result = [];
                    _.forEach(data, function (task) {
                        result = _.concat(result, task.taskActions);
                    });
                    return result;
                });
            };
            this.getTasksToBeDisplayed = function (silentMode, cacheMode) {
                if (silentMode === void 0) { silentMode = false; }
                if (cacheMode === void 0) { cacheMode = true; }
                return _this.$http.get('api/Planner/GetTasksToBeDisplayed', {
                    silentMode: silentMode,
                    cache: cacheMode
                }).then(function (response) {
                    return response.data;
                });
            };
            this.getFolderByID = function (folderID, silentMode) {
                if (silentMode === void 0) { silentMode = false; }
                var url = 'api/DocumentStorage/GetFolderById/' + folderID;
                return _this.$http.get(url, {
                    silentMode: silentMode,
                    cache: true
                }).then(function (data) {
                    if (data.data !== null) {
                        return data.data.documents;
                    }
                    return null;
                });
            };
            this.get3MonthsRelatedDocs = function (folderID) {
                return _this.getFolderByID(folderID)
                    .then(_this.getFolderByIDComplete);
            };
            this.getFolderByIDComplete = function (data) {
                var docData = data;
                var docs = [];
                // #5102 FUTURE VAT2 was bringing back previous VAT return doc if created too early.
                if (!(_this.selectedAction.status === Shared.TaskStatus.future && _this.selectedAction.action_Web_Task_no === 'VAT2')) {
                    var threeMonthsAgo = moment().subtract(3, 'months');
                    docs = _.filter(docData, function (o) {
                        return moment(o.date).isAfter(threeMonthsAgo);
                    });
                }
                _this.selectedAction.documents = docs;
                return _this.selectedAction.documents;
            };
            this.getYearEndStage = function (silentMode) {
                var url = 'api/Planner/GetYearEndStage';
                return _this.$http.get(url, {
                    cache: 'true',
                    params: {
                        silentMode: silentMode ? silentMode : false
                    }
                })
                    .then(function (response) {
                    return response.data;
                });
            };
            this.getYearEndMemberConfirmationStatus = function (silentMode) {
                if (silentMode === void 0) { silentMode = false; }
                var url = 'api/Planner/GetYearEndMemberConfirmationStatus';
                return _this.$http.get(url, {
                    cache: 'true',
                    silentMode: silentMode
                }).then(function (response) {
                    return response.data;
                });
            };
            this.showTaskCompletionInput = function (webTaskNo, actionDetails) {
                if (actionDetails) {
                    _this.selectedAction = actionDetails;
                }
                if (_this.selectedAction.action_Web_Task_no === webTaskNo && (_this.selectedAction.status > 0 && _this.selectedAction.status < 4)) {
                    return true;
                }
                return false;
            };
            this.confirmAccountsStep = function (step) {
                var url = 'api/Planner/UpdateConfirmAccountsStep';
                return _this.$http.post(url, {
                    step: step
                }).then(function (response) {
                    _this.buildMonths(false, false).then(function (data) {
                        var config = { title: "Task Planner" };
                        _this.growl.success("Step ".concat(step, " has been updated"), config);
                        //return response.data;
                    });
                    return response.data;
                })
                    .catch(function () {
                    var config = { title: "Task Planner" };
                    _this.growl.error("Account confirmation failed to update.", config);
                    var defer = _this.$q.defer();
                    defer.resolve(false);
                    return defer.promise;
                });
            };
            this.getYearEndStatus = function () {
                var url = 'api/Planner/GetYearEndStatus';
                return _this.$http.get(url, {
                    cache: true
                }).then(function (response) {
                    return response.data;
                });
            };
            this.updatePackStatus = function () {
                var url = 'api/SelfAssessment/UpdatePackStatus';
                return _this.$http.post(url, {
                    status: 2
                }).then(function (response) {
                    _this.closeTask(_this.selectedAction).then(function () {
                        var cache = _this.$cacheFactory.get('$http');
                        cache.remove('api/Planner/GetTasks');
                        _this.getAndParseTasks().then(function () {
                            _this.updateCurrentTaskAndAction();
                        });
                    });
                    return response.data;
                });
            };
            this.getTaxPackStatus = function () {
                var url = 'api/SelfAssessment/GetTaxPackStatus';
                return _this.$http.get(url, {
                    cache: false
                }).then(function (response) {
                    return response.data;
                });
            };
            this.getTaxPackSummary = function () {
                var url = 'api/SelfAssessment/getTaxPackSummary';
                return _this.$http.get(url, {
                    cache: false
                }).then(function (response) {
                    return response.data;
                });
            };
            this.getUtrNumber = function () {
                var url = 'api/SelfAssessment/GetUtrNumber';
                return _this.$http.get(url, {
                    cache: false
                }).then(function (response) {
                    return response.data;
                });
            };
            this.previewDocument = function (document) {
                _this.brooksonPdfModal.view(document.documentId, document.path, _this.previewCallback);
            };
            this.previewCallback = function (id, path) {
                return _this.documentStorageSrv.getSelectedPDF(id, path).then(function (data) { return data; });
            };
            /**
             * Returns whether the user is viewing on a small device
             */
            this.isMobile = function () { return _this.screenSize.is('xs', 'sm'); };
            /**
             * Closes a task by adding an entry into the database based on the task action number.
             *
             *
             * @memberOf TaskPlannerSrv
             */
            this.closeTask = function (taskAction, silentMode) {
                var actionWebTaskNo = taskAction.action_Web_Task_no;
                var actionNumber = taskAction.actionId;
                var actionNumbers = actionWebTaskNo + '|' + actionNumber;
                return _this.$http.put('api/Planner/CloseTask/' + actionNumbers, {}, {
                    silentMode: silentMode ? silentMode : false
                }).then(function (response) {
                    return response.data;
                });
            };
            this.getIsPayBeforeSubmit = function (silentMode) {
                var url = 'api/SelfAssessment/GetIsPayBeforeSubmit';
                return _this.$http.get(url, { silentMode: silentMode ? silentMode : false
                }).then(function (response) {
                    return response.data;
                });
            };
            this.sectionTitles = {
                business: {
                    name: 'Business Tasks',
                    overdue: 0
                },
                personal: {
                    name: 'Personal',
                    overdue: 0
                },
                personalTax: {
                    name: 'Personal Tax'
                },
                saPersonalTax: {
                    name: 'SA Personal Tax'
                },
                paye: {
                    name: 'PAYE'
                },
                payroll: {
                    name: 'Payroll'
                },
                utr: {
                    name: 'UTR'
                },
                vat: {
                    name: 'VAT'
                },
                yearEnd: {
                    name: 'Year End'
                }
            };
        }
        TaskPlannerSrv.$inject = ['$http', '$q', 'brookson.logger', 'growl', '$stateParams', 'documentStorageSrv', 'brookson.pdf.modal', 'taskPlanner.enums', 'screenSize', '$cacheFactory', '$rootScope'];
        return TaskPlannerSrv;
    }());
    Shared.TaskPlannerSrv = TaskPlannerSrv;
})(Shared || (Shared = {}));
angular
    .module('app.shared')
    .service('taskPlannerSrv', Shared.TaskPlannerSrv);
/// <reference path="../../_all.ts"/>
// Please note that most methods can take "any" as input parameters because they all get converted to Moment which can convert from any type (string, number, Date, moment.Moment).
var Shared;
(function (Shared) {
    var BrooksonUtilitiesDate = /** @class */ (function () {
        function BrooksonUtilitiesDate() {
            var _this = this;
            this.taxYearMonth = 4;
            this.taxYearDay = 5;
            this.getPreviousDayOfWeek = function (dayOfWeek) {
                // Get the current week number of the year
                var currentNumberOfWeeks = moment().weeks();
                // Minus 1 off the above number
                var previousWeekNumber = --currentNumberOfWeeks;
                // Given the above number, find the monday based on that week
                var previousWeekOfDay = moment().weeks(previousWeekNumber).day(dayOfWeek);
                return previousWeekOfDay;
            };
            this.convertToMoment = function (date) {
                if (moment.isMoment(date)) {
                    return date;
                }
                if ((date instanceof Date)) {
                    return moment(date);
                }
                return moment(date, [moment.ISO_8601, "YYYY-MM-DD", "DD-MM-YYYY", "YYYY/MM/DD", "DD/MM/YYYY", 'dddd', 'YYYY-MM-DDThh:mm:ss', "ddd MMM DD YYYY hh:mm:ss GMTzzz"], true);
            };
            this.stripOutTimezone = function (date) {
                if (!moment.isMoment(date)) {
                    date = moment(date);
                }
                var noTimezone = date.format("ddd MMM DD YYYY").toString();
                return moment.parseZone(noTimezone + " 00:00:00 GMT+0000");
            };
            this.convertToUtcMoment = function (date) {
                return moment.utc(date);
            };
            this.convertToJsDate = function (date) {
                if ((date instanceof Date)) {
                    return date;
                }
                return _this.convertToMoment(date).toDate();
            };
            this.convertToViewString = function (date) {
                return _this.convertToMoment(date).format("DD/MM/YYYY");
            };
            this.convertToViewMonthString = function (date) {
                return _this.convertToMoment(date).format("DD/MMM/YYYY");
            };
            this.convertToServerString = function (date) {
                return _this.convertToMoment(date).format("YYYY-MM-DD");
            };
            this.convertDateToMidnightGmt = function (date) {
                if (!date) {
                    return date;
                }
                return moment.utc([date.getFullYear(), date.getMonth(), date.getDate()]).toDate();
            };
            this.dateDiff = function (date1, date2) {
                return _this.convertToMoment(date1).diff(_this.convertToMoment(date2));
            };
            this.isValid = function (date) {
                return _this.convertToMoment(date).isValid();
            };
            this.isSame = function (date1, date2) {
                if (date1 === date2) {
                    return true;
                }
                return _this.dateDiff(_this.convertToMoment(date1), _this.convertToMoment(date2)) === 0;
            };
            this.isBefore = function (date1, date2) {
                return (_this.dateDiff(_this.convertToMoment(date1), _this.convertToMoment(date2)) < 0);
            };
            this.isBeforeOrSame = function (date1, date2) {
                return (_this.dateDiff(_this.convertToMoment(date1), _this.convertToMoment(date2)) <= 0);
            };
            this.isAfter = function (date1, date2) {
                return (_this.dateDiff(_this.convertToMoment(date1), _this.convertToMoment(date2)) > 0);
            };
            this.isAfterOrSame = function (date1, date2) {
                return (_this.dateDiff(_this.convertToMoment(date1), _this.convertToMoment(date2)) >= 0);
            };
            this.taxYearStart = function () {
                var now = moment();
                var startDateString = _this.taxYearDay + "/" + _this.taxYearMonth + "/" + now.year();
                var startDate = moment(startDateString, 'DD/MM/YYYY').add(1, 'days');
                if (startDate > now) {
                    startDate.add(-1, 'years');
                }
                return startDate;
            };
            this.taxYearEnd = function () {
                return _this.taxYearStart().add(1, 'years').add(-1, 'days');
            };
            this.currentTaxYear = function () {
                return _this.taxYearStart().year() + "/" + _this.taxYearEnd().year();
            };
            this.previousTaxYear = function () {
                return _this.previousTaxYearStart().year() + "/" + _this.previousTaxYearEnd().year();
            };
            this.previousTaxYearStart = function () {
                return _this.taxYearStart().add(-1, 'years');
            };
            this.previousTaxYearEnd = function () {
                return _this.taxYearEnd().add(-1, 'years');
            };
            this.nextTaxYearStart = function () {
                return _this.taxYearStart().add(1, 'years');
            };
            this.nextTaxYearEnd = function () {
                return _this.taxYearEnd().add(1, 'years');
            };
            this.nextTaxYear = function () {
                return _this.nextTaxYearStart().year() + "/" + _this.nextTaxYearEnd().year();
            };
            this.ageFromDate = function (date) {
                return _this.convertToMoment(date).diff(moment(), 'years');
            };
            /**
             * Returns whether the date passed in is the C# default date
             * ('0001-01-01T00:00:00')
             *
             * @param {string} date
             * @returns {boolean}
             */
            this.isMinDate = function (date) {
                return date === "0001-01-01T00:00:00";
            };
            this.taxYearStartByOffset = function (offset) {
                return _this.taxYearStart().add(offset, 'years');
            };
            this.taxYearEndByOffset = function (offset) {
                return _this.taxYearEnd().add(offset, 'years');
            };
            this.taxYearByOffset = function (offset) {
                return _this.taxYearStartByOffset(offset).year() + "/" + _this.taxYearEndByOffset(offset).year();
            };
        }
        BrooksonUtilitiesDate.prototype.isOverNMonthsAgo = function (date, numberOfMonths) {
            var nMonthsAgo = moment().subtract(numberOfMonths, 'months');
            return moment(date).isBefore(nMonthsAgo);
        };
        return BrooksonUtilitiesDate;
    }());
    Shared.BrooksonUtilitiesDate = BrooksonUtilitiesDate;
})(Shared || (Shared = {}));
angular
    .module('app.shared')
    .service('brookson.utilities.date', Shared.BrooksonUtilitiesDate);
var Shared;
(function (Shared) {
    var MicroCalendlyBooking = /** @class */ (function () {
        function MicroCalendlyBooking() {
        }
        return MicroCalendlyBooking;
    }());
    Shared.MicroCalendlyBooking = MicroCalendlyBooking;
    var EventType;
    (function (EventType) {
        EventType[EventType["AccountantIntroduction"] = 0] = "AccountantIntroduction";
        EventType[EventType["AdvisoryDocument"] = 1] = "AdvisoryDocument";
        EventType[EventType["FinancialHealthCheck"] = 2] = "FinancialHealthCheck";
    })(EventType = Shared.EventType || (Shared.EventType = {}));
})(Shared || (Shared = {}));
/// <reference path="./../models/MicroCalendlyBooking.ts"/>
var Shared;
(function (Shared) {
    var CalendlyService = /** @class */ (function () {
        function CalendlyService($http) {
            var _this = this;
            this.$http = $http;
            this.getCalendlyIntroductionBooking = function (silentMode) {
                return _this.$http.get("api/Calendly/GetCalendlyIntroductionBooking", {
                    silentMode: silentMode ? silentMode : false
                })
                    .then(function (response) {
                    return response.data;
                });
            };
            this.getCalendlyAdvisoryBooking = function (silentMode) {
                return _this.$http.get("api/Calendly/GetCalendlyAdvisoryBooking", {
                    silentMode: silentMode ? silentMode : false
                })
                    .then(function (response) {
                    return response.data;
                });
            };
            this.getCalendlyFinancialHealthCheckBooking = function (silentMode) {
                return _this.$http.get("api/Calendly/GetCalendlyFinancialHealthCheckBooking", {
                    silentMode: silentMode ? silentMode : false
                })
                    .then(function (response) {
                    return response.data;
                });
            };
            this.getCalendlyMemberMortgageUrl = function (memberId, silentMode) {
                return _this.$http.get("api/Calendly/GetMemberMortgageReviewLink?memberId=" + memberId, {
                    silentMode: silentMode ? silentMode : false
                })
                    .then(function (response) {
                    return response.data;
                });
            };
        }
        CalendlyService.$inject = ['$http'];
        return CalendlyService;
    }());
    Shared.CalendlyService = CalendlyService;
})(Shared || (Shared = {}));
angular.module('app.shared')
    .service('calendlySrv', Shared.CalendlyService);
/// <reference path="../../_all.ts"/>
/// <reference path="./brookson.enums.ts"/>
/// <reference path="./../models/Notification.ts"/>
/// <reference path="./../models/GetNotificationsResponse.ts"/>
/// <reference path="./../models/TaskAction.ts"/>
/// <reference path="./brookson.navigation.ts"/>
/// <reference path="./../services/brookson.services.notification.ts"/>
/// <reference path="./../services/brookson.services.task-planner.ts"/>
/// <reference path="./brookson.utilities.date.ts"/>
/// <reference path="./../services/brookson.services.calendly.ts" />
var Shared;
(function (Shared) {
    /**
     * Model for local storage to identify whether notifications have been shown
     *
     * @export
     * @class NotificationsShown
     */
    var NotificationsShown = /** @class */ (function () {
        function NotificationsShown() {
        }
        return NotificationsShown;
    }());
    Shared.NotificationsShown = NotificationsShown;
    /**
     * A model of all the notifications / smart tiles when getNotifications is called
     *
     * @export
     * @class Notifications
     */
    var Notifications = /** @class */ (function () {
        /**
         * Creates an instance of Notifications.
         *
         * @param {Array<Notification>} notifications
         * @param {Array<TaskAction>} planner
         *
         * @memberOf Notifications
         */
        /*constructor(public notifications: Array<Notification>, public tiles: Array<Notification>, public planner: Array<TaskAction>, public banners: Array<Notification>) { }*/
        function Notifications(notifications, planner) {
            this.notifications = notifications;
            this.planner = planner;
        }
        return Notifications;
    }());
    Shared.Notifications = Notifications;
    /**
     * A notification manager to help maintain the notifications and smart tiles
     *
     * @export
     * @class BrooksonNotificationManager
     * @implements {IBrooksonNotificationManager}
     */
    var BrooksonNotificationManager = /** @class */ (function () {
        /**
         * Creates an instance of BrooksonNotificationManager.
         *
         * @param {ng.IQService} $q
         * @param {ng.IWindowService} $window
         * @param {INotificationService} notificationSrv
         * @param {ITaskPlannerSrv} taskPlannerSrv
         * @param {*} moneyManagerSrv
         * @param {IBrooksonUtilitiesDate} brooksonUtilitiesDate
         * @param {ng.growl.IGrowlService} growl
         * @param {ITaskPlannerEnums} taskPlannerEnums
         * @param {IBankLinkEnums} bankLinkEnums
         * @param {ng.local.storage.ILocalStorageService} localStorageService
         * @param {IBrooksonNavigation} brooksonNavigation
         * @param {*} screenSize
         *
         * @memberOf BrooksonNotificationManager
         */
        function BrooksonNotificationManager($q, $window, notificationSrv, taskPlannerSrv, moneyManagerSrv, brooksonUtilitiesDate, growl, taskPlannerEnums, bankLinkEnums, localStorageService, brooksonNavigation, screenSize, calendlyService, dateUtils) {
            var _this = this;
            this.$q = $q;
            this.$window = $window;
            this.notificationSrv = notificationSrv;
            this.taskPlannerSrv = taskPlannerSrv;
            this.moneyManagerSrv = moneyManagerSrv;
            this.brooksonUtilitiesDate = brooksonUtilitiesDate;
            this.growl = growl;
            this.taskPlannerEnums = taskPlannerEnums;
            this.bankLinkEnums = bankLinkEnums;
            this.localStorageService = localStorageService;
            this.brooksonNavigation = brooksonNavigation;
            this.screenSize = screenSize;
            this.calendlyService = calendlyService;
            this.dateUtils = dateUtils;
            /**
             * Property that stores whether a type of notification has been shown
             *
             * @private
             * @type {NotificationsShown}
             * @memberOf BrooksonNotificationManager
             */
            this.notificationsShown = {
                taskPlannerNotifications: false,
                unallocatedTransactions: false,
                outstandingPayments: false
            };
            /**
             * Gets a model of all the notifications
             *
             * @returns {ng.IPromise<Notifications>}
             *
             * @memberOf BrooksonNotificationManager
             */
            this.getNotifications = function () {
                if (_this.notifications) {
                    var deferred = _this.$q.defer();
                    deferred.resolve(_this.notifications);
                    return deferred.promise;
                }
                /*return this.$q.all([this.getTaskPlannerNotifications(),this.getAlertNotifications(), this.getUnallocatedTransactions()]).then(data => {*/
                return _this.$q.all([_this.getTaskPlannerNotifications(), _this.getAlertNotifications()]).then(function (data) {
                    var planner = data[0];
                    var alertNotifications = data[1];
                    //var unallocatedTransactionNotification = <Notification>data[2];
                    planner.forEach(function (task) {
                        task.camelCase = _.camelCase(task.taskTitle);
                        return task;
                    });
                    var notifications = [];
                    notifications = _.concat(notifications, alertNotifications.alertNotifications);
                    // Show an outstanding payments growl (once) if present in alert notifications.
                    _this.tryShowOutstandingPaymentsGrowl(alertNotifications.alertNotifications);
                    //if (unallocatedTransactionNotification) notifications.push(unallocatedTransactionNotification);
                    var result = new Notifications(notifications, planner);
                    if (_this.notifications === undefined) {
                        _this.notifications = result;
                    }
                    else {
                        _this.notifications.notifications = notifications;
                        _this.notifications.planner = planner;
                    }
                    var deferred = _this.$q.defer();
                    deferred.resolve(_this.notifications);
                    return deferred.promise;
                });
            };
            this.tryShowOutstandingPaymentsGrowl = function (alerts) {
                if (!alerts || alerts.length === 0) {
                    return;
                }
                var currentPath = (_this.$window && _this.$window.location && _this.$window.location.pathname)
                    ? ('' + _this.$window.location.pathname).toLowerCase()
                    : '';
                if (currentPath === '/payment' || currentPath.indexOf('/payment/') === 0 ||
                    currentPath === '/account' || currentPath.indexOf('/account/') === 0) {
                    return;
                }
                var pathSegments = currentPath.split('/').filter(function (segment) { return segment.length > 0; });
                if (pathSegments.length !== 1) {
                    return; // Don't show on nested pages
                }
                if (_this.getNotificationKey(BrooksonNotificationManager.OUTSTANDING_PAYMENTS_KEY)) {
                    return;
                }
                var paymentAlert = _.find(alerts, function (a) {
                    var action = (a && a.action) ? ('' + a.action).toLowerCase() : '';
                    var title = (a && a.title) ? ('' + a.title).toLowerCase() : '';
                    return action === 'paymentoutstanding' || title.indexOf('payments') >= 0;
                });
                if (!paymentAlert) {
                    return;
                }
                if (_this.screenSize && _this.screenSize.is && _this.screenSize.is('xs, sm')) {
                    _this.setNotificationKey(BrooksonNotificationManager.OUTSTANDING_PAYMENTS_KEY);
                    return;
                }
                var message = paymentAlert.metaDescription || 'You have payments outstanding.</br> Click here to view and pay.';
                _this.growl.warning(message, {
                    title: 'Payments & Billing',
                    ttl: -1,
                    disableCountDown: true,
                    variables: {
                        cssClass: 'payment-growl',
                        onClick: function () {
                            _this.$window.location.href = '/Payment';
                        }
                    }
                });
                //Removed for now, might add back if tile is created as well
                //this.setNotificationKey(BrooksonNotificationManager.OUTSTANDING_PAYMENTS_KEY);
            };
            /**
             * Returns any task planner notifications
             *
             * @returns {ng.IPromise<Array<TaskAction>>}
             *
             * @memberOf BrooksonNotificationManager
             */
            this.getTaskPlannerNotifications = function () {
                return _this.taskPlannerSrv.getTasksToBeDisplayed(true).then(function (data) {
                    if (!_this.getNotificationKey(BrooksonNotificationManager.TASK_PLANNER_NOTIFICATION_KEY)) {
                        var taskActions = data;
                        _.filter(taskActions, function (taskAction) {
                            return taskAction.responsibility === _this.taskPlannerEnums.TaskResponsibility.ME;
                        });
                        var overDueTaskActions = _.filter(taskActions, function (taskAction) { return taskAction.status === _this.taskPlannerEnums.TaskStatus.OVERDUE; });
                        var upcomingTaskActions = _.filter(taskActions, function (taskAction) { return taskAction.status !== _this.taskPlannerEnums.TaskStatus.OVERDUE; });
                        /**
                        *  If there is more than 1 upcoming task action to be completed, only display
                        * one notification so we don't clutter the dashboard
                        * */
                        if (upcomingTaskActions.length === 1) {
                            _.forEach(upcomingTaskActions, function (taskAction) {
                                if (!_this.screenSize.is('xs, sm')) {
                                    _this.growl.warning(taskAction.actionTitle + " is upcoming <strong>" + moment(taskAction.dueDate).format("DD/MM/YYYY") + "</strong>", {
                                        title: "Task Planner",
                                        ttl: 5000,
                                        disableCountDown: true,
                                        variables: {
                                            onClick: function () {
                                                _this.goToTask(taskAction);
                                            }
                                        }
                                    });
                                }
                            });
                        }
                        else if (upcomingTaskActions.length > 1) {
                            _this.growl.warning("You have tasks that are upcoming.", {
                                title: "Task Planner",
                                ttl: 5000,
                                disableCountDown: true,
                                variables: {
                                    onClick: function () {
                                        _this.goToTaskPlanner();
                                    }
                                }
                            });
                        }
                        /**
                         *  If there is more than 1 overdue task action to be completed, only display
                         * one notification so we don't clutter the dashboard
                         * */
                        if (overDueTaskActions.length === 1) {
                            _.forEach(overDueTaskActions, function (taskAction) {
                                if (!_this.screenSize.is('xs, sm')) {
                                    _this.growl.error(taskAction.actionTitle + " is overdue <strong>" + moment(taskAction.dueDate).format("DD/MM/YYYY") + "</strong>", {
                                        title: "Task Planner",
                                        ttl: -1,
                                        disableCountDown: true,
                                        variables: {
                                            onClick: function () {
                                                _this.goToTask(taskAction);
                                            }
                                        }
                                    });
                                }
                            });
                        }
                        else if (overDueTaskActions.length > 1) {
                            _this.growl.error("You have tasks that are overdue.", {
                                title: "Task Planner",
                                ttl: -1,
                                disableCountDown: true,
                                variables: {
                                    onClick: function () {
                                        _this.goToTaskPlanner();
                                    }
                                }
                            });
                        }
                        _this.setNotificationKey(BrooksonNotificationManager.TASK_PLANNER_NOTIFICATION_KEY);
                    }
                    return data;
                });
            };
            /**
            * Go to a Task in Task Planner
            *
            * @param {TaskAction} task
            *
            * @memberOf IBrooksonNotificationManager
            */
            this.goToTask = function (task) {
                _this.brooksonNavigation.taskPlanner.selectedActionTask('todo', task.actionId);
            };
            /**
             *
             *
             *
             * @memberOf BrooksonNotificationManager
             */
            this.getUnallocatedTransactions = function () {
                if (_this.getNotificationKey(BrooksonNotificationManager.UNALLOCATED_TRANSACTIONS_CLEAR_KEY)) {
                    var deferred = _this.$q.defer();
                    deferred.resolve();
                    return deferred.promise;
                }
                return _this.moneyManagerSrv.getTransactions('', true).then(function (data) {
                    var result = null;
                    if (data == null) {
                        return result;
                    }
                    var transactions = data.transactions;
                    var transactionsToAllocate = _.filter(transactions, {
                        transactionType: _this.bankLinkEnums.TransactionType.UNALLOCATED
                    }).length;
                    if (transactionsToAllocate > 0) {
                        if (!_this.getNotificationKey(BrooksonNotificationManager.UNALLOCATED_TRANSACTIONS_KEY)) {
                            _this.growl.warning("You have ".concat(transactionsToAllocate, " unallocated transaction").concat(transactionsToAllocate === 1 ? '' : 's'), {
                                title: "Bank",
                                ttl: 5000,
                                disableCountDown: true,
                                variables: {
                                    /**
                                     *
                                     */
                                    onClick: function () {
                                        _this.brooksonNavigation.bankLink.main();
                                    }
                                }
                            });
                        }
                        result = {
                            title: 'Bank',
                            metaDescription: "".concat(transactionsToAllocate, " unallocated transaction").concat(transactionsToAllocate === 1 ? '' : 's'),
                            colour: 'yellow',
                            symbol: 'money'
                        };
                        result.onClick = function () { return _this.brooksonNavigation.expenses.business(); };
                    }
                    _this.notificationsShown.unallocatedTransactions = true;
                    _this.setNotificationKey(BrooksonNotificationManager.UNALLOCATED_TRANSACTIONS_KEY);
                    return result;
                });
            };
            /**
              * Dismisses a smart tile
              *
              * @param {Notification} smartTile
              *
              * @memberOf IBrooksonNotificationManager
              */
            this.closeSmartTile = function (smartTile) {
                _.pull(_this.tileNotifications, smartTile);
                _this.notificationSrv.closeNotification(smartTile);
            };
            /**
             * Closes all of the alerts
             *
             *
             * @memberOf IBrooksonNotificationManager
             */
            this.closeAlerts = function () {
                _.forEach(_this.notifications.notifications, function (alert) {
                    if (alert.id)
                        _this.notificationSrv.closeNotification(alert);
                });
                _this.notifications.notifications.length = 0;
                _this.setNotificationKey(BrooksonNotificationManager.UNALLOCATED_TRANSACTIONS_CLEAR_KEY);
            };
            /**
             * Reset the local storage value to state that the user has not viewed the notifications
             *
             *
             * @memberOf IBrooksonNotificationManager
             */
            this.clearNotificationsShown = function () {
                _this.localStorageService.set(BrooksonNotificationManager.LOCAL_STORAGE_KEY, {});
            };
            /**
             * Returns a list of all the smart notifications to be displayed
             *
             * @private
             * @returns {ng.IPromise<GetNotificationsResponse>}
             *
             * @memberOf BrooksonNotificationManager
             */
            this.getAlertNotifications = function () {
                return _this.notificationSrv.getAlertNotifications(true).then(function (data) { return data; });
            };
            /**
             * Returns a value from notificaiton local storage container and returns the property
             *
             * @private
             * @param {string} notification
             * @returns
             *
             * @memberOf BrooksonNotificationManager
             */
            this.getNotificationKey = function (notification) {
                var data = _this.localStorageService.get(BrooksonNotificationManager.LOCAL_STORAGE_KEY);
                _this.notificationsShown = data === null ? {} : data;
                return _this.notificationsShown[notification];
            };
            /**
             * Sets that a certain type of notification has been displayed to the user by setting it in local storage
             *
             * @private
             *
             * @memberOf BrooksonNotificationManager
             */
            this.setNotificationKey = function (notification) {
                _this.notificationsShown[notification] = true;
                _this.localStorageService.set(BrooksonNotificationManager.LOCAL_STORAGE_KEY, _this.notificationsShown);
            };
            /**
             * Redirects the user to Task Planner
             *
             *
             * @memberOf BrooksonNotificationManager
             */
            this.goToTaskPlanner = function () {
                _this.brooksonNavigation.taskPlanner.main();
            };
            this.notificationScrollingMessage = "";
            this.displaynotificationScrollingMessage = false;
        }
        /**
         * The local storage key for storing whether a user has seen notifications
         *
         * @static
         * @type {string}
         * @memberOf BrooksonNotificationManager
         */
        BrooksonNotificationManager.LOCAL_STORAGE_KEY = 'brookson.notifications';
        /**
         * The local storage key for whether they have seen the task planner notifications
         *
         * @static
         * @type {string}
         * @memberOf BrooksonNotificationManager
         */
        BrooksonNotificationManager.TASK_PLANNER_NOTIFICATION_KEY = 'taskPlannerNotifications';
        /**
         * The local storage key for whether they have seen the unallocated transactions notifications
         *
         * @static
         * @type {string}
         * @memberOf BrooksonNotificationManager
         */
        BrooksonNotificationManager.UNALLOCATED_TRANSACTIONS_KEY = 'unallocatedTransactions';
        /**
         * The local storage key for whether the user has dismissed all of the alerts
         *
         * @static
         * @type {string}
         * @memberOf BrooksonNotificationManager
         */
        BrooksonNotificationManager.UNALLOCATED_TRANSACTIONS_CLEAR_KEY = 'unallocatedTransactionsClear';
        /**
         * The local storage key for whether the user has seen the outstanding payments notification
         */
        BrooksonNotificationManager.OUTSTANDING_PAYMENTS_KEY = 'outstandingPayments';
        /**
         * Angular Dependency Injection
         *
         * @static
         *
         * @memberOf BrooksonNotificationManager
         */
        BrooksonNotificationManager.$inject = ['$q', '$window', 'notificationSrv', 'taskPlannerSrv', 'moneyManagerSrv', 'brookson.utilities.date', 'growl', 'taskPlanner.enums', 'bankLink.enums', 'localStorageService', 'brookson.navigation', 'screenSize', 'calendlySrv', 'brookson.utilities.date'];
        return BrooksonNotificationManager;
    }());
    Shared.BrooksonNotificationManager = BrooksonNotificationManager;
})(Shared || (Shared = {}));
angular
    .module('app.shared')
    .service('brookson.notifications.manager', Shared.BrooksonNotificationManager);
var Login;
(function (Login) {
    var LoginData = /** @class */ (function () {
        function LoginData() {
        }
        return LoginData;
    }());
    Login.LoginData = LoginData;
})(Login || (Login = {}));
/// <reference path="../../_all.ts"/>
/// <reference path="../../shared/services/brookson.services.authentication.ts" />
/// <reference path="../../shared/services/brookson.services.service-line.ts" />
/// <reference path="../../shared/services/brookson.services.member.ts" />
/// <reference path="./../../shared/modules/brookson.notifications.manager.ts"/>
/// <reference path="../../shared/modules/brookson.navigation.ts" />
/// <reference path="../../shared/interfaces/brookson.interfaces.window.ts" />
/// <reference path="../../shared/models/member/validateUserResponse.ts" />
/// <reference path="../models/loginData.ts" />
var Login;
(function (Login) {
    var BrooksonLoginLogin = /** @class */ (function () {
        function BrooksonLoginLogin() {
            this.controller = LoginCtrlController;
            this.templateUrl = "src/app/login/views/login.html";
        }
        return BrooksonLoginLogin;
    }());
    Login.BrooksonLoginLogin = BrooksonLoginLogin;
    var LoginCtrlController = /** @class */ (function () {
        function LoginCtrlController($window, $state, $stateParams, authenticationSrv, serviceLineSrv, memberSrv, focus, brooksonNotificationsManager, brooksonNavigation, localStorageService) {
            var _this = this;
            this.$window = $window;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.authenticationSrv = authenticationSrv;
            this.serviceLineSrv = serviceLineSrv;
            this.memberSrv = memberSrv;
            this.focus = focus;
            this.brooksonNotificationsManager = brooksonNotificationsManager;
            this.brooksonNavigation = brooksonNavigation;
            this.localStorageService = localStorageService;
            this.email = "";
            this.password = "";
            this.apiKeySource = "";
            this.message = "";
            this.requestInProgress = false;
            this.$onInit = function () {
                if (_this.$window.brookson.serverLogin) {
                    _this.serverLogin();
                }
                _this.localStorageService.remove("brookson.2faSetup");
                _this.focusOnUsernameInput();
            };
            this.serverLogin = function () {
                _this.email = _this.$window.brookson.serverLogin.UserName;
                _this.password = _this.$window.brookson.serverLogin.Password;
                _this.apiSessionId = _this.$window.brookson.serverLogin.sessionId;
                _this.apiKeySource = _this.$window.brookson.serverLogin.ApiKeySource;
                _this.login(true);
            };
            this.login = function (isValid) {
                var loginData = new Login.LoginData();
                loginData.userName = _this.email;
                loginData.password = _this.password;
                loginData.sessionId = _this.apiSessionId;
                loginData.apiKeySource = _this.apiKeySource;
                if (!isValid) {
                    _this.message = "Form invalid!";
                    return;
                }
                _this.requestInProgress = true;
                if ((_this.$window.brookson.serverLogin === null || _this.$window.brookson.serverLogin === undefined) && _this.$window.appSettings.twoFactorEnabled === 'True') { // ignore any API requests from D365 or Internal Connect
                    _this.authenticationSrv.validateLoginRequest(loginData.userName, loginData.password).then(function (result) {
                        if (result !== null) {
                            if (result.validLoginRequest) {
                                if (_this.$window.appSettings.enable2FAForAllMembers === 'True') {
                                    if (result.twoFactorEnabled) {
                                        // open the 2FA page and send OTP
                                        _this.$state.go("login.twoFactorAuth", { loginData: loginData });
                                    }
                                    else {
                                        _this.loginProcess(loginData);
                                    }
                                }
                                else {
                                    _this.loginProcess(loginData);
                                }
                            }
                            else {
                                _this.message = result.loginMessage;
                                _this.focusOnPasswordInput();
                                _this.requestInProgress = false;
                            }
                        }
                        else {
                            _this.message = 'The user name or password is incorrect.';
                            _this.focusOnPasswordInput();
                            _this.requestInProgress = false;
                        }
                    });
                }
                else {
                    _this.loginProcess(loginData);
                }
            };
            this.loginProcess = function (loginData) {
                _this.authenticationSrv.login(loginData)
                    .then(function (result) {
                    if (_this.$window.brookson.serverLogin != null && _this.$window.brookson.serverLogin.hasOwnProperty('sessionId')) {
                        result.apiKeySource = result.apiKeySource;
                        delete _this.$window.brookson.serverLogin['sessionId'];
                    }
                    var member = _this.memberSrv.setMember(result);
                    if (_this.$window.brookson.serverLogin) {
                        if (_this.$window.brookson.serverLogin.InternalLogin)
                            member.navReferral = _this.$window.brookson.serverLogin.userNameString.toString();
                        if (_this.$window.brookson.serverLogin.ApiKeySource !== null && _this.$window.brookson.serverLogin.ApiKeySource !== '') {
                            member.navReferral = _this.$window.brookson.serverLogin.ApiKeySource + "-" + _this.$window.brookson.serverLogin.userNameString.toString().replace('@people20.com', '');
                            member.apiKeySource = _this.$window.brookson.serverLogin.ApiKeySource;
                        }
                    }
                    _this.brooksonNotificationsManager.clearNotificationsShown();
                    if (member.isAdmin) {
                        _this.$state.go("login.super", _this.$stateParams);
                    }
                    else {
                        _this.serviceLineSrv.getServiceLines(member)
                            .then(function (lines) {
                            if (lines.length) {
                                member.serviceLines = lines;
                                var hasMultipleServiceLines = _.keys(_.groupBy(lines, 'customerReference')).length > 1;
                                if (hasMultipleServiceLines) {
                                    _this.$state.go("login.serviceLine", _this.$stateParams);
                                }
                                else {
                                    member.businessType = lines[0].businessType;
                                    member.role = lines[0].role;
                                    member.companyRef = lines[0].customerReference;
                                    lines[0].navReferral = member.navReferral;
                                    _this.authenticationSrv.updateAccessTokenServiceLine(member.memberId, member.serviceLines[0], member.refreshToken, member.apiKeySource)
                                        .then(function (data) {
                                        // If is leaver, go to self assessment
                                        if (member.serviceLines[0].isEligible) {
                                            _this.brooksonNavigation.personalTax.selfAssessment();
                                            return;
                                        }
                                        if (_this.$stateParams['ReturnUrl']) {
                                            _this.$window.location.href = _this.$stateParams['ReturnUrl'];
                                        }
                                        else {
                                            _this.brooksonNavigation.dashboard.main();
                                        }
                                        // Umbrella users should go to Connect 2.0
                                        if (member.businessType.toLowerCase() === 'umbrella' && !_this.$window.appSettings.umbEnabled) {
                                            _this.$window.location.href = _this.$window.appSettings.connect2Url + '/Login.aspx?lo=a25';
                                            return;
                                        }
                                    })
                                        .catch(function () { });
                                }
                                _this.memberSrv.setMember(member);
                            }
                            else {
                                _this.message = "Unable to find service lines for user.";
                                _this.focusOnPasswordInput();
                            }
                        }, function (err) {
                            _this.message = err.error_description;
                            _this.focusOnPasswordInput();
                        });
                    }
                }, function (err) {
                    _this.message = err.error_description;
                    _this.focusOnPasswordInput();
                }).then(function () {
                    _this.requestInProgress = false;
                });
            };
            this.focusOnPasswordInput = function () {
                _this.focus('password');
            };
            this.focusOnUsernameInput = function () {
                _this.focus('username');
            };
            this.memberSrv.clearMember();
        }
        LoginCtrlController.$inject = ["$window", "$state", '$stateParams', "authenticationSrv", "serviceLineSrv", "memberSrv", 'focus', 'brookson.notifications.manager', 'brookson.navigation', 'localStorageService'];
        return LoginCtrlController;
    }());
})(Login || (Login = {}));
/// <reference path="../../_all.ts"/>
/// <reference path="../../shared/services/brookson.services.authentication.ts" />
/// <reference path="../../shared/services/brookson.services.member.ts" />
/// <reference path="../../shared/services/brookson.services.service-line.ts" />
/// <reference path="../../shared/modules/brookson.enums.ts" />
var Login;
(function (Login) {
    var BrooksonLoginPasswordReset = /** @class */ (function () {
        function BrooksonLoginPasswordReset() {
            this.controller = PasswordResetCtrlController;
            this.templateUrl = "src/app/login/views/passwordReset.html";
        }
        return BrooksonLoginPasswordReset;
    }());
    Login.BrooksonLoginPasswordReset = BrooksonLoginPasswordReset;
    var PasswordResetCtrlController = /** @class */ (function () {
        function PasswordResetCtrlController($state, $stateParams, authenticationSrv, memberSrv, serviceLineSrv, brooksonNavigation, enums, $window) {
            var _this = this;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.authenticationSrv = authenticationSrv;
            this.memberSrv = memberSrv;
            this.serviceLineSrv = serviceLineSrv;
            this.brooksonNavigation = brooksonNavigation;
            this.enums = enums;
            this.$window = $window;
            this.username = "";
            this.password = "";
            this.confirmPassword = "";
            this.message = null;
            this.passwordStrengthValidation = function (password) {
                if (password.length < 8) {
                    _this.message = "Password must be a least 8 characters long.";
                    return false;
                }
                return true;
            };
            this.setNewPassword = function () {
                var resetId = _this.$stateParams['id'];
                if (_this.password !== _this.confirmPassword) {
                    _this.message = "The confirmation password must match.";
                    return;
                }
                if (_this.passwordStrengthValidation(_this.password)) {
                    _this.message = null;
                    _this.authenticationSrv
                        .resetMemberPassword(resetId, _this.username, _this.password)
                        .then(function (data) {
                        if (data) {
                            _this.authenticationSrv.login({
                                userName: _this.username,
                                password: _this.password
                            }).then(function (result) {
                                var member = _this.memberSrv.setMember(result);
                                if (member.isAdmin) {
                                    _this.$state.go("login.super");
                                }
                                else {
                                    _this.serviceLineSrv.getServiceLines(member).then(function (lines) {
                                        if (lines.length) {
                                            member.serviceLines = lines;
                                            if (lines.length > 1) {
                                                _this.$state.go("login.serviceLine");
                                            }
                                            else {
                                                member.companyRef = lines[0].customerReference;
                                                _this.authenticationSrv
                                                    .updateAccessTokenServiceLine(member.memberId, member.serviceLines[0], member.refreshToken, member.apiKeySource)
                                                    .then(function (data) {
                                                    _this.brooksonNavigation.dashboard.main();
                                                })
                                                    .catch(function () { });
                                            }
                                            _this.memberSrv.setMember(member);
                                        }
                                        else {
                                            _this.message = "Login failed. Your password has been changed but we were unable to log you back in. Please call us on " + _this.enums.ContactInformation.CustomerServicesPhone + " for assistance.";
                                        }
                                    }, function (err) {
                                        _this.message = err.error_description;
                                    });
                                }
                            }, function (err) {
                                _this.message = "Login failed. Your password has been changed but we were unable to log you back in. Please call us on " + _this.enums.ContactInformation.CustomerServicesPhone + " for assistance.";
                            });
                        }
                        else {
                            _this.message = "Activation failed. Please call us on " + _this.enums.ContactInformation.CustomerServicesPhone + " for assistance.";
                        }
                    });
                }
            };
            if (this.$window.appSettings.isIntouchSite) {
                this.enums.ContactInformation.CustomerServicesPhone = '01202 901951';
            }
        }
        PasswordResetCtrlController.$inject = ["$state", "$stateParams", "authenticationSrv", "memberSrv", 'serviceLineSrv', 'brookson.navigation', 'contact.enums', "$window"];
        return PasswordResetCtrlController;
    }());
})(Login || (Login = {}));
var Shared;
(function (Shared) {
    // $Classes/Enums/Interfaces(filter)[template][separator]
    // filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
    // template: The template to repeat for each matched item
    // separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]
    // More info: http://frhagn.github.io/Typewriter/
    var SubmitPersonSignificantControl;
    (function (SubmitPersonSignificantControl) {
        SubmitPersonSignificantControl[SubmitPersonSignificantControl["NoResponse"] = 0] = "NoResponse";
        SubmitPersonSignificantControl[SubmitPersonSignificantControl["Yes"] = 1] = "Yes";
        SubmitPersonSignificantControl[SubmitPersonSignificantControl["No"] = 2] = "No";
    })(SubmitPersonSignificantControl = Shared.SubmitPersonSignificantControl || (Shared.SubmitPersonSignificantControl = {}));
})(Shared || (Shared = {}));
/// <reference path="./SubmitPersonSignificantControl.ts" />
var Shared;
(function (Shared) {
    // $Classes/Enums/Interfaces(filter)[template][separator]
    // filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
    // template: The template to repeat for each matched item
    // separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]
    // More info: http://frhagn.github.io/Typewriter/
    var NavPersonalInformation = /** @class */ (function () {
        function NavPersonalInformation() {
            // JOBTITLE
            this.jobTitle = null;
            // TITLE
            this.title = null;
            // FIRSTNAME
            this.firstName = null;
            // MIDDLENAME
            this.middleName = null;
            // SURNAME
            this.surname = null;
            // FILINGCODE
            this.filingCode = null;
            // HOMEPHONENO
            this.homePhoneNo = null;
            // MOBILEPHONENO
            this.mobilePhoneNo = null;
            // WORKPHONENO
            this.workPhoneNo = null;
            // EMAIL
            this.eMail = null;
            // SMSALERTPREFERENCE
            this.smsAlertPreference = 0;
            // EMAILPAYSLIPSPREFERENCE
            this.emailPayslipsPreference = 0;
            // PREFERREDMETHODOFCONTACT
            this.preferredMethodOfContact = null;
            // ADDRESS
            this.address = null;
            // ADDRESS2
            this.address2 = null;
            // CITY
            this.city = null;
            // COUNTY
            this.county = null;
            // POSTCODE
            this.postcode = null;
            // PASSWORD
            this.password = null;
            // CONFIRMPASSWORD
            this.confirmPassword = null;
            // DOB
            this.dob = null;
            // NINUMBER
            this.niNumber = null;
            // UTRNUMBER
            this.utrNumber = null;
            // NATIONALITY
            this.nationality = null;
            // NATIONALITYOPTION
            this.nationalityOption = null;
            //DOSUBMITPSC
            this.doSubmitPSC = null;
            // Contact Joining Date
            this.contactJoiningDate = null;
            // Contract File Name
            this.contractFileName = null;
            this.tfaEnabled = false;
            this.tfaEnabledAmended = false;
            this.twoFactorDisabledExpiryDate = null;
            this.twoFactorOverrideDate = null;
        }
        return NavPersonalInformation;
    }());
    Shared.NavPersonalInformation = NavPersonalInformation;
})(Shared || (Shared = {}));
var Shared;
(function (Shared) {
    // $Classes/Enums/Interfaces(filter)[template][separator]
    // filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
    // template: The template to repeat for each matched item
    // separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]
    // More info: http://frhagn.github.io/Typewriter/
    var InvoicingAssignmentRate = /** @class */ (function () {
        function InvoicingAssignmentRate() {
            // RATETYPES
            this.rateTypes = [];
            // ASSIGNMENTRATEID
            this.assignmentRateID = 0;
            // RATE
            this.rate = 0;
            // DESCRIPTION
            this.description = null;
            // CURRENCY
            this.currency = null;
            // RATEPERIOD
            this.ratePeriod = null;
            // RATETYPE
            this.rateType = null;
            // PAYMENTCODE
            this.paymentCode = null;
            // STARTDATE
            this.startDate = null;
            // ENDDATE
            this.endDate = null;
            this.chargableDays = 0;
            this.chargableTotal = 0;
            this.totalHoursWorked = 0;
        }
        return InvoicingAssignmentRate;
    }());
    Shared.InvoicingAssignmentRate = InvoicingAssignmentRate;
    var Currencies;
    (function (Currencies) {
        Currencies[Currencies["GBP"] = 10] = "GBP";
        Currencies[Currencies["EUR"] = 20] = "EUR";
        Currencies[Currencies["USD"] = 30] = "USD";
        Currencies[Currencies["YEN"] = 60] = "YEN";
        Currencies[Currencies["AUD"] = 70] = "AUD";
        Currencies[Currencies["CAD"] = 80] = "CAD";
        Currencies[Currencies["NOK"] = 90] = "NOK";
        Currencies[Currencies["ZAR"] = 100] = "ZAR";
        Currencies[Currencies["SEK"] = 110] = "SEK";
        Currencies[Currencies["CHF"] = 120] = "CHF";
        Currencies[Currencies["AED"] = 130] = "AED";
    })(Currencies = Shared.Currencies || (Shared.Currencies = {}));
    var RatePeriods;
    (function (RatePeriods) {
        RatePeriods[RatePeriods["Hour"] = 0] = "Hour";
        RatePeriods[RatePeriods["Day"] = 1] = "Day";
        RatePeriods[RatePeriods["Week"] = 2] = "Week";
    })(RatePeriods = Shared.RatePeriods || (Shared.RatePeriods = {}));
})(Shared || (Shared = {}));
/// <reference path="./InvoicingAssignmentRate.ts"/>
var Shared;
(function (Shared) {
    // $Classes/Enums/Interfaces(filter)[template][separator]
    // filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
    // template: The template to repeat for each matched item
    // separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]
    // More info: http://frhagn.github.io/Typewriter/
    var EmployeeRate = /** @class */ (function () {
        function EmployeeRate() {
            // CONTRACTRATEID
            this.contractRateID = 0;
            // EMPLOYEEID
            this.employeeID = 0;
            // RATEDESCRIPTION
            this.rateDescription = null;
            // RATE
            this.rate = 0;
            // STAFFID
            this.staffID = null;
            // STAFFIDM
            this.staffIDM = null;
            // CREATEDDATETIME
            this.createdDateTime = null;
            // YEARKEY
            this.yearKey = 0;
            // ISDAYRATE
            this.isDayRate = false;
            // PAYMENTCODE
            this.paymentCode = null;
            // RATEPERIOD
            this.ratePeriod = null;
            // STARTDATE
            this.startDate = null;
            // ENDDATE
            this.endDate = null;
            // CURRENCY
            this.currency = null;
        }
        return EmployeeRate;
    }());
    Shared.EmployeeRate = EmployeeRate;
})(Shared || (Shared = {}));
/// <reference path="./../../shared/models/EmployeeRate.ts"/>
var Shared;
(function (Shared) {
    // $Classes/Enums/Interfaces(filter)[template][separator]
    // filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
    // template: The template to repeat for each matched item
    // separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]
    // More info: http://frhagn.github.io/Typewriter/
    var NavBusinessInformation = /** @class */ (function () {
        function NavBusinessInformation() {
            // COMPANIES
            this.companies = [];
            // EMPLOYEERATES
            this.employeeRates = [];
        }
        return NavBusinessInformation;
    }());
    Shared.NavBusinessInformation = NavBusinessInformation;
})(Shared || (Shared = {}));
/// <reference path="./NavPersonalInformation.ts" />
/// <reference path="./NavBusinessInformation.ts" />
var Shared;
(function (Shared) {
    // $Classes/Enums/Interfaces(filter)[template][separator]
    // filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
    // template: The template to repeat for each matched item
    // separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]
    // More info: http://frhagn.github.io/Typewriter/
    var NavContactInformation = /** @class */ (function () {
        function NavContactInformation() {
            // PERSONALINFORMATION
            this.personalInformation = null;
            // BUSINESSINFORMATION
            this.businessInformation = null;
            this.twoFactorAuthenticationEnabled = false;
        }
        return NavContactInformation;
    }());
    Shared.NavContactInformation = NavContactInformation;
})(Shared || (Shared = {}));
var Shared;
(function (Shared) {
    // $Classes/Enums/Interfaces(filter)[template][separator]
    // filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
    // template: The template to repeat for each matched item
    // separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]
    // More info: http://frhagn.github.io/Typewriter/
    var BankAccount = /** @class */ (function () {
        function BankAccount() {
            // BANKACCOUNTID
            this.bankAccountID = null;
            // BANKNAME
            this.bankName = null;
            // SORTCODE
            this.sortCode = null;
            // ACCOUNTNO
            this.accountNo = null;
        }
        return BankAccount;
    }());
    Shared.BankAccount = BankAccount;
})(Shared || (Shared = {}));
var Shared;
(function (Shared) {
    // $Classes/Enums/Interfaces(filter)[template][separator]
    // filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
    // template: The template to repeat for each matched item
    // separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]
    // More info: http://frhagn.github.io/Typewriter/
    var AssignmentHeader = /** @class */ (function () {
        function AssignmentHeader() {
            // AGENCY
            this.agency = null;
            // DATESTARTED
            this.dateStarted = null;
            // DATEENDED
            this.dateEnded = null;
            // ASSIGNMENTID
            this.assignmentId = null;
            // CLIENT
            this.client = null;
            // ASSIGNMENTNAME
            this.assignmentName = null;
            // INSTRUCTIONTEXT
            this.instructionText = null;
            // OVERALLSTATUSTEXT
            this.overallStatusText = null;
            // ASSIGNMENTADDRESS
            this.assignmentAddress = null;
            // ASSIGNMENTNOTES
            this.assignmentNotes = null;
            // AGENCYREFERENCE
            this.agencyReference = null;
            this.fullAssignmentName = null;
        }
        return AssignmentHeader;
    }());
    Shared.AssignmentHeader = AssignmentHeader;
})(Shared || (Shared = {}));
/// <reference path="./Assignment.ts"/>
var Shared;
(function (Shared) {
    // $Classes/Enums/Interfaces(filter)[template][separator]
    // filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
    // template: The template to repeat for each matched item
    // separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]
    // More info: http://frhagn.github.io/Typewriter/
    var Review = /** @class */ (function () {
        function Review() {
            // REVIEWID
            this.reviewId = 0;
            // CONTRACTRECEIVED
            this.contractReceived = null;
            // RESARECEIVED
            this.resaReceived = null;
            // LEGALREVIEWED
            this.legalReviewed = null;
            // REVIEWCOMPLETED
            this.reviewCompleted = null;
            // RESASTATUS
            this.resaStatus = null;
            // CONTRACTSTATUS
            this.contractStatus = null;
            // FINALOUTCOME
            this.finalOutcome = null;
            // RESADOCUMENT
            this.resaDocument = null;
            // ATTENDANCENOTEDOCUMENT
            this.attendanceNoteDocument = null;
            // CONTRACTDOCUMENT
            this.contractDocument = null;
            // ASSIGNMENTID
            this.assignmentID = null;
            // ASSIGNMENT
            this.assignment = null;
        }
        return Review;
    }());
    Shared.Review = Review;
})(Shared || (Shared = {}));
var Shared;
(function (Shared) {
    // $Classes/Enums/Interfaces(filter)[template][separator]
    // filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
    // template: The template to repeat for each matched item
    // separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]
    // More info: http://frhagn.github.io/Typewriter/
    var Location = /** @class */ (function () {
        function Location() {
            // STARTDATE
            this.startDate = null;
            // EXPECTEDENDDATE
            this.expectedEndDate = null;
            // LASTDAYONSITE
            this.lastDayOnSite = null;
            // SITENAME
            this.siteName = null;
            // ADDRESS1
            this.address1 = null;
            // ADDRESS2
            this.address2 = null;
            // ADDRESS3
            this.address3 = null;
            // CITY
            this.city = null;
            // COUNTY
            this.county = null;
            // POSTCODE
            this.postCode = null;
        }
        return Location;
    }());
    Shared.Location = Location;
})(Shared || (Shared = {}));
var Shared;
(function (Shared) {
    var PublicSectorAssignmentCheckButtonPressed;
    (function (PublicSectorAssignmentCheckButtonPressed) {
        PublicSectorAssignmentCheckButtonPressed[PublicSectorAssignmentCheckButtonPressed["public"] = 0] = "public";
        PublicSectorAssignmentCheckButtonPressed[PublicSectorAssignmentCheckButtonPressed["private"] = 1] = "private";
        PublicSectorAssignmentCheckButtonPressed[PublicSectorAssignmentCheckButtonPressed["notrequired"] = 2] = "notrequired";
    })(PublicSectorAssignmentCheckButtonPressed = Shared.PublicSectorAssignmentCheckButtonPressed || (Shared.PublicSectorAssignmentCheckButtonPressed = {}));
})(Shared || (Shared = {}));
var Shared;
(function (Shared) {
    var JobTitle = /** @class */ (function () {
        function JobTitle() {
        }
        return JobTitle;
    }());
    Shared.JobTitle = JobTitle;
})(Shared || (Shared = {}));
var Shared;
(function (Shared) {
    var EnumObj = /** @class */ (function () {
        function EnumObj(name, id) {
            this.name = name;
            this.id = id;
        }
        return EnumObj;
    }());
    Shared.EnumObj = EnumObj;
})(Shared || (Shared = {}));
/// <reference path="./AAssignmentHeader.ts"/>
/// <reference path="./Review.ts"/>
/// <reference path="./Location.ts"/>
/// <reference path="./BrooksonDate.ts"/>
/// <reference path="./publicSectorAssignmentCheck/assignmentSelection.ts" />
/// <reference path="./sdc/JobTitle.ts" />
/// <reference path="./EnumObj.ts"/>
var Shared;
(function (Shared) {
    // $Classes/Enums/Interfaces(filter)[template][separator]
    // filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
    // template: The template to repeat for each matched item
    // separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]
    // More info: http://frhagn.github.io/Typewriter/
    var Assignment = /** @class */ (function (_super) {
        __extends(Assignment, _super);
        function Assignment() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            // RATETYPES
            _this.rateTypes = [];
            // MEMBERID
            _this.memberId = 0;
            // HASIR35QUESTIONNAIRE
            _this.hasIR35Questionnaire = false;
            // IR35QUESTIONNAIRECOMPLETE
            _this.iR35QuestionnaireComplete = false;
            // COMPANY
            _this.company = null;
            // MEMBERADVISEDSTATUSOLD
            _this.memberAdvisedStatusOld = null;
            // REVIEWS
            _this.reviews = [];
            // PREFERREDEMAILADDRESSES
            _this.preferredEmailAddresses = [];
            // LOCATIONS
            _this.locations = [];
            _this.isAssignment24MonthRuleReclaimable = false;
            _this.sdcStatus = 0;
            _this.publicSector = null;
            _this.jobTitleOption = null;
            _this.jobTitle = null;
            _this.industry = null;
            _this.iR35CapturedFromDate = null;
            _this.iR35CapturedEffectiveDate = null;
            _this.showExpensesPopup = false;
            return _this;
        }
        return Assignment;
    }(Shared.AssignmentHeader));
    Shared.Assignment = Assignment;
    var Sectors;
    (function (Sectors) {
        Sectors[Sectors["public"] = 0] = "public";
        Sectors[Sectors["private"] = 1] = "private";
        Sectors[Sectors["nolongerinuse"] = 2] = "nolongerinuse";
    })(Sectors = Shared.Sectors || (Shared.Sectors = {}));
})(Shared || (Shared = {}));
/// <reference path="./AddressMole.ts" />
var Shared;
(function (Shared) {
    // $Classes/Enums/Interfaces(filter)[template][separator]
    // filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
    // template: The template to repeat for each matched item
    // separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]
    // More info: http://frhagn.github.io/Typewriter/
    var Customer = /** @class */ (function () {
        function Customer() {
            // CUSTOMERNUMBER
            this.customerNumber = null;
            // CUSTOMERNAME
            this.customerName = null;
            // CUSTOMERADDRESS
            this.customerAddress = null;
            // CUSTOMERADDRESSOBJ
            this.customerAddressObj = null;
            // CONTACTNAME
            this.contactName = null;
            // CONTACTNUMBER
            this.contactNumber = null;
            // BILLINGADDRESS
            this.billingAddress = null;
            // BILLINGADDRESSOBJ
            this.billingAddressObj = null;
            // ASSIGNMENTS
            this.assignments = [];
            this.umbTimesheetDisabled = 0;
        }
        return Customer;
    }());
    Shared.Customer = Customer;
})(Shared || (Shared = {}));
var Shared;
(function (Shared) {
    // $Classes/Enums/Interfaces(filter)[template][separator]
    // filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
    // template: The template to repeat for each matched item
    // separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]
    // More info: http://frhagn.github.io/Typewriter/
    var Address = /** @class */ (function () {
        function Address() {
            this.name = null;
            // ADDRESSLINE1
            this.addressLine1 = null;
            // ADDRESSLINE2
            this.addressLine2 = null;
            // ADDRESSLINE3
            this.addressLine3 = null;
            // TOWN
            this.town = null;
            // COUNTY
            this.county = null;
            // POSTCODE
            this.postcode = null;
            // COUNTRY
            this.country = null;
        }
        return Address;
    }());
    Shared.Address = Address;
})(Shared || (Shared = {}));
/// <reference path="./Address.ts"/>
var Shared;
(function (Shared) {
    // $Classes/Enums/Interfaces(filter)[template][separator]
    // filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
    // template: The template to repeat for each matched item
    // separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]
    // More info: http://frhagn.github.io/Typewriter/
    var NamedAddress = /** @class */ (function (_super) {
        __extends(NamedAddress, _super);
        function NamedAddress() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            // NAME
            _this.name = null;
            return _this;
        }
        return NamedAddress;
    }(Shared.Address));
    Shared.NamedAddress = NamedAddress;
})(Shared || (Shared = {}));
var Shared;
(function (Shared) {
    var VatBusinessPostingGroup;
    (function (VatBusinessPostingGroup) {
        // ""
        VatBusinessPostingGroup[VatBusinessPostingGroup["Blank"] = 0] = "Blank";
        // "EU"
        VatBusinessPostingGroup[VatBusinessPostingGroup["EU"] = 1] = "EU";
        // "EXEMPT"
        VatBusinessPostingGroup[VatBusinessPostingGroup["EXEMPT"] = 2] = "EXEMPT";
        // "UK"
        VatBusinessPostingGroup[VatBusinessPostingGroup["UK"] = 3] = "UK";
        // "NON EU"
        VatBusinessPostingGroup[VatBusinessPostingGroup["NONEU"] = 4] = "NONEU";
    })(VatBusinessPostingGroup = Shared.VatBusinessPostingGroup || (Shared.VatBusinessPostingGroup = {}));
})(Shared || (Shared = {}));
var Shared;
(function (Shared) {
    var VatProdPostingGroup;
    (function (VatProdPostingGroup) {
        // ""
        VatProdPostingGroup[VatProdPostingGroup["Blank"] = 0] = "Blank";
        // "EXEMPT"
        VatProdPostingGroup[VatProdPostingGroup["EXEMPT"] = 1] = "EXEMPT";
        // "VAT10"
        VatProdPostingGroup[VatProdPostingGroup["VAT10"] = 2] = "VAT10";
        // "VAT17"
        VatProdPostingGroup[VatProdPostingGroup["VAT17"] = 3] = "VAT17";
        // "VAT5"
        VatProdPostingGroup[VatProdPostingGroup["VAT5"] = 4] = "VAT5";
        // "ZERO"
        VatProdPostingGroup[VatProdPostingGroup["ZERO"] = 5] = "ZERO";
    })(VatProdPostingGroup = Shared.VatProdPostingGroup || (Shared.VatProdPostingGroup = {}));
})(Shared || (Shared = {}));
/// <reference path="./Assignment.ts"/>
/// <reference path="./Customer.ts"/>
/// <reference path="./NamedAddress.ts"/>
/// <reference path="./InvoicingAssignmentRate.ts"/>
/// <reference path="./../enums/VatBusinessPostingGroup.ts" />
/// <reference path="./../enums/VatProdPostingGroup.ts" />
var Shared;
(function (Shared) {
    // $Classes/Enums/Interfaces(filter)[template][separator]
    // filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
    // template: The template to repeat for each matched item
    // separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]
    // More info: http://frhagn.github.io/Typewriter/
    var InvoicingAssignment = /** @class */ (function (_super) {
        __extends(InvoicingAssignment, _super);
        function InvoicingAssignment() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            // RATES
            _this.rates = [];
            // CUSTOMER
            _this.customer = null;
            // CURRENCYCODE
            _this.currencyCode = 0;
            // ISSELFBILLING
            _this.isSelfBilling = false;
            // NARRATIVE
            _this.narrative = null;
            // PONUMBER
            _this.poNumber = null;
            // DEEMED
            _this.deemed = false;
            // REMITTANCEADDRESS
            _this.remittanceAddress = null;
            // COMPANYNO
            _this.companyNo = null;
            // VATNO
            _this.vatNo = null;
            // ISRAISEDINERROR
            _this.isRaisedInError = false;
            // VATREGSTATUS
            _this.vatRegStatus = 0;
            _this.defaultHours = 0;
            _this.invoiceDistributionEnabled = false;
            return _this;
        }
        return InvoicingAssignment;
    }(Shared.Assignment));
    Shared.InvoicingAssignment = InvoicingAssignment;
})(Shared || (Shared = {}));
/// <reference path="./../../shared/models/AccountType.ts"/>
/// <reference path="./BankAccount.ts"/>
/// <reference path="./../../shared/models/InvoicingAssignment.ts"/>
var Shared;
(function (Shared) {
    // $Classes/Enums/Interfaces(filter)[template][separator]
    // filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
    // template: The template to repeat for each matched item
    // separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]
    // More info: http://frhagn.github.io/Typewriter/
    var NavCompanyInformation = /** @class */ (function () {
        function NavCompanyInformation() {
            // COMPANYTYPE
            this.companyType = null;
            // COMPANYNAME
            this.companyName = null;
            // COMPANYREGISTRATIONNO
            this.companyRegistrationNo = null;
            // COMPANYREFERENCE
            this.companyReference = null;
            // DIRECTORSNAME
            this.directorsName = null;
            // VATREGISTRATIONNO
            this.vatRegistrationNo = null;
            // BANKACCOUNTS
            this.bankAccounts = [];
            // ASSIGNMENTS
            this.assignments = [];
            //CORPORATIONTAXREFNO
            this.corporationTaxRefNo = null;
        }
        return NavCompanyInformation;
    }());
    Shared.NavCompanyInformation = NavCompanyInformation;
})(Shared || (Shared = {}));
var Shared;
(function (Shared) {
    var NAVNationality = /** @class */ (function () {
        function NAVNationality() {
            this.code = null;
            this.name = null;
            this.nationality = null;
        }
        return NAVNationality;
    }());
    Shared.NAVNationality = NAVNationality;
})(Shared || (Shared = {}));
/// <reference path="../../_all.ts"/>
/// <reference path="./../models/NavContactInformation.ts"/>
/// <reference path="../models/NavPersonalInformation.ts"/>
/// <reference path="./../models/NavCompanyInformation.ts"/>
/// <reference path="./../models/NavBusinessInformation.ts"/>
/// <reference path="./../../shared/services/brookson.services.member.ts"/>
/// <reference path="./../models/NavNationality.ts" />
var Shared;
(function (Shared) {
    var AccountService = /** @class */ (function () {
        function AccountService($http, memberSrv) {
            var _this = this;
            this.$http = $http;
            this.memberSrv = memberSrv;
            this.getAccountDetailsForUser = function () {
                return _this.$http.get('api/Account/GetAccountDetailsForUser').then(function (response) {
                    if (response.data) {
                        _this.personalInformation = response.data.personalInformation;
                        _this.businessInformation = response.data.businessInformation;
                        _this.company = _.find(response.data.businessInformation.companies, function (company) {
                            return company.companyReference === _this.member.companyRef;
                        });
                        _.each(_this.company.bankAccounts, function (bankAccount) {
                            bankAccount.bankName = bankAccount.bankName.toLowerCase();
                        });
                    }
                    return response.data;
                });
            };
            this.updateAccountDetailsForUser = function (personalInformation, password) {
                return _this.$http.post('api/Account/UpdateAccountDetailsForUser', {
                    personalInformation: personalInformation,
                    password: password
                }).then(function (response) {
                    return response.data;
                });
            };
            this.getNationalities = function (silentMode) {
                return _this.$http.get('api/Account/GetNationalities', {
                    silentMode: silentMode ? silentMode : false
                }).then(function (response) {
                    return response.data;
                });
            };
            this.getCommonPasswords = function (silentMode) {
                return _this.$http.get('api/Account/common-passwords', {
                    silentMode: silentMode ? silentMode : false
                }).then(function (response) {
                    return response.data;
                });
            };
            this.member = memberSrv.getMember();
        }
        AccountService.$inject = ['$http', 'memberSrv'];
        return AccountService;
    }());
    Shared.AccountService = AccountService;
})(Shared || (Shared = {}));
angular
    .module('app.shared')
    .service('accountSrv', Shared.AccountService);
/// <reference path="../../_all.ts"/>
/// <reference path="../../shared/services/brookson.services.member.ts" />
/// <reference path="../../shared/services/brookson.services.service-line.ts" />
/// <reference path="../../shared/services/brookson.services.authentication.ts" />
/// <reference path="./../../shared/modules/brookson.notifications.manager.ts"/>
/// <reference path="../../shared/modules/brookson.enums.ts" />
/// <reference path="../../shared/services/brookson.services.account.ts" />
var Login;
(function (Login) {
    var BrooksonLoginRegistration = /** @class */ (function () {
        function BrooksonLoginRegistration() {
            this.controller = RegistrationCtrlController;
            this.templateUrl = "src/app/login/views/registration.html";
        }
        return BrooksonLoginRegistration;
    }());
    Login.BrooksonLoginRegistration = BrooksonLoginRegistration;
    var RegistrationCtrlController = /** @class */ (function () {
        function RegistrationCtrlController($state, memberSrv, serviceLineSrv, authenticationSrv, brooksonNavigation, enums, $window, accountSrv) {
            var _this = this;
            this.$state = $state;
            this.memberSrv = memberSrv;
            this.serviceLineSrv = serviceLineSrv;
            this.authenticationSrv = authenticationSrv;
            this.brooksonNavigation = brooksonNavigation;
            this.enums = enums;
            this.$window = $window;
            this.accountSrv = accountSrv;
            this.username = '';
            this.registrationId = '';
            this.password = '';
            this.confirmPassword = '';
            this.message = null;
            this.strengthMessage = '';
            this.strengthClass = '';
            this.isWeakPassword = true;
            this.hasTyped = false;
            this.isCommonPassword = false;
            this.activateMember = function () {
                if (_this.password !== _this.confirmPassword) {
                    _this.message = 'The confirmation password must match.';
                    return;
                }
                if (_this.passwordStrengthValidation(_this.password)) {
                    _this.message = null;
                    _this.authenticationSrv.activateMember(_this.username, _this.registrationId, _this.password)
                        .then(function (data) {
                        if (data) {
                            _this.authenticationSrv.login({
                                userName: _this.username,
                                password: _this.password
                            })
                                .then(function (result) {
                                var member = _this.memberSrv.setMember(result);
                                if (member.isAdmin) {
                                    _this.$state.go("login.super");
                                }
                                else {
                                    _this.serviceLineSrv.getServiceLines(member)
                                        .then(function (lines) {
                                        if (lines.length) {
                                            member.serviceLines = lines;
                                            if (lines.length > 1) {
                                                _this.$state.go("login.serviceLine");
                                            }
                                            else {
                                                member.companyRef = lines[0].customerReference;
                                                _this.authenticationSrv.updateAccessTokenServiceLine(member.memberId, member.serviceLines[0], member.refreshToken, member.apiKeySource)
                                                    .then(function (data) {
                                                    _this.brooksonNavigation.dashboard.main();
                                                })
                                                    .catch(function () { });
                                            }
                                            _this.memberSrv.setMember(member);
                                        }
                                        else {
                                            _this.message = "Login failed. Your password has been changed but we were unable to log you back in. Please call us on " + _this.enums.ContactInformation.CustomerServicesPhone + " for assistance.";
                                        }
                                    }, function (err) {
                                        _this.message = err.error_description;
                                    });
                                }
                            }, function (err) {
                                _this.message = "Login failed. Your password has been changed but we were unable to log you back in. Please call us on " + _this.enums.ContactInformation.CustomerServicesPhone + " for assistance.";
                            });
                        }
                        else {
                            _this.message = 'Activation failed. Please call us on ' + _this.enums.ContactInformation.CustomerServicesPhone + ' for assistance.';
                        }
                    });
                }
            };
            this.passwordStrengthValidation = function (password) {
                var commonPasswords = [];
                _this.accountSrv.getCommonPasswords(true).then(function (data) {
                    commonPasswords = data;
                });
                _this.hasTyped = true;
                var strength = 0;
                if (password.length < 8) {
                    _this.message = 'Password must be a least 8 characters long.';
                    return false;
                }
                // Check if the password is common
                if (commonPasswords.indexOf(password.trim()) !== -1) {
                    _this.strengthMessage = 'Weak (Common Password)';
                    _this.strengthClass = 'strength-weak';
                    _this.isWeakPassword = true;
                    _this.message = 'The password is too common or easy to guess. Please choose a stronger one';
                    return false;
                }
                _this.isCommonPassword = false;
                // Check password strength criteria
                if (password.length >= 8)
                    strength++;
                if (/[A-Z]/.test(password))
                    strength++;
                if (/[a-z]/.test(password))
                    strength++;
                if (/[0-9]/.test(password))
                    strength++;
                if (/[\W]/.test(password))
                    strength++;
                // Set validity and strength messages based on criteria
                if (strength <= 2) {
                    _this.strengthMessage = 'Weak';
                    _this.strengthClass = 'strength-weak';
                    _this.isWeakPassword = true;
                    _this.message = 'Password must contain a combination of letters, numbers, and/or symbols';
                    return false;
                }
                else if (strength === 3) {
                    _this.strengthMessage = 'Medium';
                    _this.strengthClass = 'strength-medium';
                    _this.isWeakPassword = false;
                }
                else if (strength > 3) {
                    _this.strengthMessage = 'Strong';
                    _this.strengthClass = 'strength-strong';
                    _this.isWeakPassword = false;
                }
                return true;
            };
            this.goToLogin = function () {
                _this.$state.go("login.login");
            };
            if (this.$window.appSettings.isIntouchSite) {
                this.enums.ContactInformation.CustomerServicesPhone = '01202 901951';
            }
        }
        RegistrationCtrlController.$inject = ['$state', 'memberSrv', 'serviceLineSrv', 'authenticationSrv', 'brookson.navigation', 'contact.enums', "$window", 'accountSrv'];
        return RegistrationCtrlController;
    }());
})(Login || (Login = {}));
/// <reference path="../../_all.ts"/>
/// <reference path="../../shared/interfaces/brookson.interfaces.window.ts" />
/// <reference path="../../shared/services/brookson.services.member.ts" />
/// <reference path="../../shared/services/brookson.services.authentication.ts" />
/// <reference path="../../shared/modules/brookson.navigation.ts" />
/// <reference path="../../shared/models/member/ServiceLine.ts" />
var Login;
(function (Login) {
    var BrooksonLoginServiceLine = /** @class */ (function () {
        function BrooksonLoginServiceLine() {
            this.controller = ServiceLineCtrlController;
            this.templateUrl = "src/app/login/views/serviceLine.html";
        }
        return BrooksonLoginServiceLine;
    }());
    Login.BrooksonLoginServiceLine = BrooksonLoginServiceLine;
    var ServiceLineCtrlController = /** @class */ (function () {
        function ServiceLineCtrlController($window, $stateParams, memberSrv, authenticationSrv, brooksonNavigation) {
            var _this = this;
            this.$window = $window;
            this.$stateParams = $stateParams;
            this.memberSrv = memberSrv;
            this.authenticationSrv = authenticationSrv;
            this.brooksonNavigation = brooksonNavigation;
            this.serviceLines = [];
            this.message = "";
            this.loading = false;
            this.$onInit = function () {
                _this.member = _this.memberSrv.getMember();
                _this.serviceLines = _this.member.serviceLines;
            };
            this.submit = function (isValid) {
                if (isValid) {
                    _this.loading = true;
                    // Umbrella users should go to Connect 2.0
                    if (_this.selectedServiceLine.businessType.toLowerCase() === 'umbrella' && !_this.$window.appSettings.umbEnabled) {
                        _this.$window.location.href = _this.$window.appSettings.connect2Url + '/Login.aspx?lo=a25';
                        _this.loading = false;
                        return;
                    }
                    //update the user service active service line
                    _this.member.companyRef = _this.selectedServiceLine.customerReference;
                    _this.memberSrv.setMember(_this.member);
                    _this.selectedServiceLine.navReferral = _this.member.navReferral;
                    _this.authenticationSrv.updateAccessTokenServiceLine(_this.member.memberId, _this.selectedServiceLine, _this.member.refreshToken, _this.member.apiKeySource)
                        .then(function (data) {
                        // If is leaver, go to self assessment
                        if (_this.selectedServiceLine.isEligible) {
                            _this.brooksonNavigation.personalTax.selfAssessment();
                            return;
                        }
                        if (_this.$stateParams['ReturnUrl']) {
                            _this.$window.location.href = _this.$stateParams['ReturnUrl'];
                        }
                        else {
                            _this.brooksonNavigation.dashboard.main();
                        }
                    }, function (err) {
                        _this.message = err.data.error_description;
                        _this.loading = false;
                    })
                        .catch(function () { });
                }
            };
        }
        ServiceLineCtrlController.$inject = ['$window', '$stateParams', 'memberSrv', 'authenticationSrv', 'brookson.navigation'];
        return ServiceLineCtrlController;
    }());
})(Login || (Login = {}));
/// <reference path="../../_all.ts"/>
/// <reference path="../../shared/interfaces/brookson.interfaces.window.ts" />
/// <reference path="../../shared/services/brookson.services.service-line.ts" />
/// <reference path="../../shared/services/brookson.services.member.ts" />
/// <reference path="../../shared/services/brookson.services.authentication.ts" />
/// <reference path="../../shared/modules/brookson.navigation.ts" />
var Login;
(function (Login) {
    var BrooksonLoginSuper = /** @class */ (function () {
        function BrooksonLoginSuper() {
            this.controller = SuperCtrlController;
            this.templateUrl = "src/app/login/views/super.html";
        }
        return BrooksonLoginSuper;
    }());
    Login.BrooksonLoginSuper = BrooksonLoginSuper;
    var SuperCtrlController = /** @class */ (function () {
        function SuperCtrlController($window, $state, $stateParams, serviceLineSrv, memberSrv, authenticationSrv, focus, brooksonNavigation) {
            var _this = this;
            this.$window = $window;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.serviceLineSrv = serviceLineSrv;
            this.memberSrv = memberSrv;
            this.authenticationSrv = authenticationSrv;
            this.focus = focus;
            this.brooksonNavigation = brooksonNavigation;
            this.memberId = "";
            this.message = "";
            this.isLoading = false;
            this.$onInit = function () {
                _this.focusOnMemberInput();
            };
            this.submit = function (isValid) {
                if (isValid && !_this.isLoading) {
                    _this.isLoading = true;
                    var input = {
                        memberId: _this.memberId
                    };
                    var member_1 = _this.memberSrv.getMember();
                    if (!member_1.isAdmin) {
                        _this.message = "Cannot verify as administrator!";
                        return;
                    }
                    var memberIdCopy_1 = angular.copy(_this.memberId);
                    _this.serviceLineSrv.getServiceLines(input)
                        .then(function (lines) {
                        if (lines.length) {
                            member_1.memberId = memberIdCopy_1;
                            member_1.serviceLines = lines;
                            var hasMultipleServiceLines = _.keys(_.groupBy(lines, 'customerReference')).length > 1;
                            if (hasMultipleServiceLines) {
                                _this.$state.go('login.serviceLine', _this.$stateParams);
                            }
                            else {
                                member_1.businessType = lines[0].businessType;
                                member_1.role = lines[0].role;
                                member_1.companyRef = lines[0].customerReference;
                                _this.authenticationSrv.updateAccessTokenServiceLine(member_1.memberId, member_1.serviceLines[0], member_1.refreshToken, member_1.apiKeySource)
                                    .then(function (data) {
                                    // If is leaver, go to self assessment
                                    if (member_1.serviceLines[0].isEligible) {
                                        _this.brooksonNavigation.personalTax.selfAssessment();
                                        return;
                                    }
                                    if (_this.$stateParams['ReturnUrl']) {
                                        _this.$window.location.href = _this.$stateParams['ReturnUrl'];
                                    }
                                    else {
                                        _this.brooksonNavigation.dashboard.main();
                                    }
                                    if (member_1.businessType.toLowerCase() === 'umbrella' && !_this.$window.appSettings.umbEnabled) {
                                        _this.$window.location.href = _this.$window.appSettings.connect2Url + '?lo=a25';
                                    }
                                }, function (err) {
                                    _this.message = err.data.error_description;
                                    _this.focusOnMemberInput();
                                });
                            }
                            _this.memberSrv.setMember(member_1);
                        }
                        else {
                            _this.isLoading = false;
                            _this.message = "Unable to find service lines for user.";
                            _this.focusOnMemberInput();
                        }
                    }, function (err) {
                        _this.isLoading = false;
                        _this.message = err.error_description;
                        _this.focusOnMemberInput();
                    })
                        .then(function () {
                    });
                }
                else {
                    _this.isLoading = false;
                    _this.message = "Form is invalid!";
                    _this.focusOnMemberInput();
                }
            };
            this.focusOnMemberInput = function () {
                _this.focus('memberId');
            };
        }
        SuperCtrlController.$inject = ['$window', '$state', '$stateParams', 'serviceLineSrv', 'memberSrv', 'authenticationSrv', 'focus', 'brookson.navigation'];
        return SuperCtrlController;
    }());
})(Login || (Login = {}));
/// <reference path="../../_all.ts"/>
/// <reference path="../../shared/services/brookson.services.authentication.ts" />
var Login;
(function (Login) {
    var BrooksonLoginShareholder = /** @class */ (function () {
        function BrooksonLoginShareholder() {
            this.controller = ShareholderLoginController;
            this.templateUrl = "src/app/login/views/shareholder.html";
        }
        return BrooksonLoginShareholder;
    }());
    Login.BrooksonLoginShareholder = BrooksonLoginShareholder;
    var ShareholderLoginController = /** @class */ (function () {
        function ShareholderLoginController($state, $stateParams, authenticationSrv, memberSrv, serviceLineSrv, brooksonNavigation, $window) {
            var _this = this;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.authenticationSrv = authenticationSrv;
            this.memberSrv = memberSrv;
            this.serviceLineSrv = serviceLineSrv;
            this.brooksonNavigation = brooksonNavigation;
            this.$window = $window;
            this.registrationId = "";
            this.username = "";
            this.newPassword = "";
            this.confirmPassword = "";
            this.message = "";
            this.$onInit = function () {
            };
            this.goToLogin = function () {
                _this.$state.go("login.login");
            };
            this.submitLogin = function (isValid) {
                if (!isValid) {
                    _this.message = "Form invalid!";
                    return;
                }
                if (_this.newPassword !== _this.confirmPassword) {
                    _this.message = "Passwords do not match";
                    return;
                }
                _this.authenticationSrv.verifyShareholderLogin(_this.username, _this.registrationId, _this.newPassword)
                    .then(function (result) {
                    if (result) {
                        var loginData = {
                            userName: _this.username,
                            password: _this.newPassword
                        };
                        _this.authenticationSrv.login(loginData)
                            .then(function (result) {
                            var member = _this.memberSrv.setMember(result);
                            _this.serviceLineSrv.getServiceLines(member)
                                .then(function (lines) {
                                if (lines.length) {
                                    member.serviceLines = lines;
                                    var hasMultipleServiceLines = _.keys(_.groupBy(lines, 'customerReference')).length > 1;
                                    if (hasMultipleServiceLines) {
                                        _this.$state.go("login.serviceLine", _this.$stateParams);
                                    }
                                    else {
                                        member.businessType = lines[0].businessType;
                                        member.role = lines[0].role;
                                        member.companyRef = lines[0].customerReference;
                                        _this.authenticationSrv.updateAccessTokenServiceLine(member.memberId, member.serviceLines[0], member.refreshToken, member.apiKeySource)
                                            .then(function (data) {
                                            // Umbrella users should go to Connect 2.0
                                            if (member.businessType.toLowerCase() === 'umbrella' && !_this.$window.appSettings.umbEnabled) {
                                                _this.$window.location.href = _this.$window.appSettings.connect2Url + '/Login.aspx?lo=a25';
                                                return;
                                            }
                                            if (member.role.toLowerCase() === "shareholder") {
                                                _this.brooksonNavigation.personalTax.selfAssessment();
                                            }
                                            else {
                                                _this.brooksonNavigation.dashboard.main();
                                            }
                                        })
                                            .catch(function () { });
                                    }
                                    _this.memberSrv.setMember(member);
                                }
                                else {
                                    _this.message = "Unable to find service lines for user.";
                                }
                            }, function (err) {
                                _this.message = err.error_description;
                            });
                        });
                    }
                    else {
                        _this.message = "The credentials you provided are incorrect.";
                        return;
                    }
                }, function (error) {
                    _this.message = error.error_description;
                }).then(function () {
                    return;
                });
            };
        }
        ShareholderLoginController.$inject = ["$state", "$stateParams", "authenticationSrv", "memberSrv", "serviceLineSrv", "brookson.navigation", "$window"];
        return ShareholderLoginController;
    }());
})(Login || (Login = {}));
/// <reference path="../../shared/models/member/TfaMemberContactDetails.ts" />
var Login;
(function (Login) {
    var BrooksonTwoFactorAuth = /** @class */ (function () {
        function BrooksonTwoFactorAuth() {
            this.controller = TwoFactorAuthController;
            this.templateUrl = 'src/app/login/views/twoFactorAuth.html';
        }
        return BrooksonTwoFactorAuth;
    }());
    Login.BrooksonTwoFactorAuth = BrooksonTwoFactorAuth;
    var TwoFactorAuthController = /** @class */ (function () {
        function TwoFactorAuthController($window, $state, $stateParams, serviceLineSrv, memberSrv, authenticationSrv, focus, brooksonNavigation, brooksonNotificationsManager, $interval, $scope) {
            var _this = this;
            this.$window = $window;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.serviceLineSrv = serviceLineSrv;
            this.memberSrv = memberSrv;
            this.authenticationSrv = authenticationSrv;
            this.focus = focus;
            this.brooksonNavigation = brooksonNavigation;
            this.brooksonNotificationsManager = brooksonNotificationsManager;
            this.$interval = $interval;
            this.$scope = $scope;
            this.showOTP = false;
            this.message = "";
            this.isLoading = false;
            this.authRequestError = false;
            this.otpError = false;
            this.submitted = false;
            this.intervalId = 0;
            this.timer = null;
            this.$onInit = function () {
                if (!_this.$stateParams["loginData"]) {
                    _this.$state.go("login.login");
                }
                else {
                    _this.authenticationSrv.getMemberMaskedContactDetails(_this.$stateParams["loginData"].userName).then(function (memberContactDetails) {
                        if (memberContactDetails !== null) {
                            _this.contactDetailList = memberContactDetails;
                        }
                        _this.isLoading = false;
                    });
                    _this.$scope.$on("$destroy", function () {
                        _this.stopTimer();
                    });
                }
            };
            this.submit = function (isValid) {
                _this.submitted = true;
                _this.otpError = false;
                _this.authRequestError = false;
                if (_this.showOTP) {
                    _this.authenticationSrv.twoFactorAuthValidation(_this.otp, _this.$stateParams["loginData"].userName).then(function (response) {
                        if (response !== null && response !== undefined) {
                            if (response.accountLockOut) {
                                _this.stopTimer();
                                _this.$state.go("login.login");
                            }
                            else {
                                if (response.validationResponse) {
                                    _this.stopTimer();
                                    _this.loginProcess(_this.$stateParams["loginData"]);
                                }
                                else {
                                    // Wrong OTP, try again.
                                    _this.focus('otp');
                                    _this.otpError = true;
                                    _this.submitted = false;
                                }
                            }
                        }
                        else {
                            _this.focus('otp');
                            _this.otpError = true;
                            _this.submitted = false;
                        }
                    });
                }
                else {
                    if (_this.selectedCommms !== undefined) {
                        $('.countdown').text('');
                        _this.authenticationSrv.twoFactorAuthRequest(_this.selectedCommms, _this.$stateParams["loginData"].userName).then(function (response) {
                            if (response) {
                                _this.showOTP = true;
                                _this.focus('otp');
                                _this.startTimer();
                            }
                            else {
                                _this.authRequestError = true;
                            }
                            _this.submitted = false;
                        });
                    }
                }
            };
            this.startTimer = function () {
                var duration;
                var interval = 1000;
                duration = moment.duration({ 'minutes': 5 });
                $('.countdown').text(duration.format('mm:ss'));
                if (angular.isDefined(_this.otpTimer)) {
                    _this.stopTimer();
                }
                _this.otpExpired = false;
                _this.otpTimer = _this.$interval(function () {
                    duration = moment.duration(duration - interval, 'milliseconds');
                    if (duration > 1000) {
                        if (duration > 60000) {
                            $('.countdown').text(duration.format('mm:ss'));
                        }
                        else {
                            $('.countdown').text(duration.format('ss') + ' seconds');
                        }
                    }
                    else {
                        _this.otpExpired = true;
                        $('.countdown').text('');
                    }
                }, 1000);
            };
            this.stopTimer = function () {
                if (angular.isDefined(_this.otpTimer)) {
                    _this.$interval.cancel(_this.otpTimer);
                    _this.otpTimer = undefined;
                }
            };
            this.loginProcess = function (loginData) {
                _this.authenticationSrv.login(loginData)
                    .then(function (result) {
                    if (_this.$window.brookson.serverLogin != null && _this.$window.brookson.serverLogin.hasOwnProperty('sessionId')) {
                        result.apiKeySource = result.apiKeySource;
                        delete _this.$window.brookson.serverLogin['sessionId'];
                    }
                    var member = _this.memberSrv.setMember(result);
                    if (_this.$window.brookson.serverLogin) {
                        if (_this.$window.brookson.serverLogin.InternalLogin)
                            member.navReferral = _this.$window.brookson.serverLogin.userNameString.toString();
                        if (_this.$window.brookson.serverLogin.ApiKeySource !== null && _this.$window.brookson.serverLogin.ApiKeySource !== '') {
                            member.navReferral = _this.$window.brookson.serverLogin.ApiKeySource + "-" + _this.$window.brookson.serverLogin.userNameString.toString().replace('@people20.com', '');
                            member.apiKeySource = _this.$window.brookson.serverLogin.ApiKeySource;
                        }
                    }
                    _this.brooksonNotificationsManager.clearNotificationsShown();
                    if (member.isAdmin) {
                        _this.$state.go("login.super", _this.$stateParams);
                    }
                    else {
                        _this.serviceLineSrv.getServiceLines(member)
                            .then(function (lines) {
                            if (lines.length) {
                                member.serviceLines = lines;
                                var hasMultipleServiceLines = _.keys(_.groupBy(lines, 'customerReference')).length > 1;
                                if (hasMultipleServiceLines) {
                                    _this.$state.go("login.serviceLine", _this.$stateParams);
                                }
                                else {
                                    member.businessType = lines[0].businessType;
                                    member.role = lines[0].role;
                                    member.companyRef = lines[0].customerReference;
                                    lines[0].navReferral = member.navReferral;
                                    _this.authenticationSrv.updateAccessTokenServiceLine(member.memberId, member.serviceLines[0], member.refreshToken, member.apiKeySource)
                                        .then(function (data) {
                                        // If is leaver, go to self assessment
                                        if (member.serviceLines[0].isEligible) {
                                            _this.brooksonNavigation.personalTax.selfAssessment();
                                            return;
                                        }
                                        if (_this.$stateParams['ReturnUrl']) {
                                            _this.$window.location.href = _this.$stateParams['ReturnUrl'];
                                        }
                                        else {
                                            _this.brooksonNavigation.dashboard.main();
                                        }
                                        // Umbrella users should go to Connect 2.0
                                        if (member.businessType.toLowerCase() === 'umbrella' && !_this.$window.appSettings.umbEnabled) {
                                            _this.$window.location.href = _this.$window.appSettings.connect2Url + '/Login.aspx?lo=a25';
                                            return;
                                        }
                                    })
                                        .catch(function () { });
                                }
                                _this.memberSrv.setMember(member);
                            }
                            else {
                                _this.message = "Unable to find service lines for user.";
                            }
                        }, function (err) {
                            _this.message = err.error_description;
                        });
                    }
                }, function (err) {
                    _this.message = err.error_description;
                }).then(function () {
                });
            };
            this.disableSubmitButton = function () {
                if (!_this.showOTP) {
                    return _this.selectedCommms === undefined || _this.submitted === true;
                }
                else {
                    return _this.otp === undefined || _this.otp === null || _this.otp === '' || _this.submitted === true;
                }
            };
            this.reset = function () {
                _this.stopTimer();
                _this.otp = undefined;
                _this.showOTP = false;
                _this.otpExpired = false;
            };
            this.isLoading = true;
        }
        TwoFactorAuthController.$inject = ['$window', '$state', '$stateParams', 'serviceLineSrv', 'memberSrv', 'authenticationSrv', 'focus', 'brookson.navigation', 'brookson.notifications.manager', '$interval', '$scope'];
        return TwoFactorAuthController;
    }());
})(Login || (Login = {}));
/// <reference path="../_all.ts"/>
/// <reference path="./app.login.state.ts" />
/// <reference path="./components/brookson.login.forgotten-password.ts" />
/// <reference path="./components/brookson.login.login.ts" />
/// <reference path="./components/brookson.login.password-reset.ts" />
/// <reference path="./components/brookson.login.registration.ts" />
/// <reference path="./components/brookson.login.service-line.ts" />
/// <reference path="./components/brookson.login.super.ts" />
/// <reference path="./components/brookson.login.shareholder.ts" />
/// <reference path="./components/brookson.login.twoFactorAuth.ts" />
var Login;
(function (Login) {
    var App = /** @class */ (function () {
        function App() {
        }
        App.createModule = function (angular) {
            angular.module('app.login', [
                'app.shared'
            ])
                .value('siloName', 'login')
                .config([
                "$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
                    return new Login.StateConfig($stateProvider, $urlRouterProvider);
                }
            ])
                .component('brooksonLoginForgottenPassword', new Login.BrooksonLoginForgottenPassword())
                .component('brooksonLoginLogin', new Login.BrooksonLoginLogin())
                .component('brooksonLoginPasswordReset', new Login.BrooksonLoginPasswordReset())
                .component('brooksonLoginRegistration', new Login.BrooksonLoginRegistration())
                .component('brooksonLoginServiceLine', new Login.BrooksonLoginServiceLine())
                .component('brooksonLoginSuper', new Login.BrooksonLoginSuper())
                .component('brooksonLoginShareholder', new Login.BrooksonLoginShareholder())
                .component('brooksonLoginTwofactorauth', new Login.BrooksonTwoFactorAuth());
        };
        return App;
    }());
    Login.App = App;
})(Login || (Login = {}));
Login.App.createModule(angular);
angular.module('app.login').run(['$templateCache', function ($templateCache) {
        $templateCache.put('src/app/login/views/forgottenPassword.html', '<div>\r\n    <div class="col-lg-4 col-md-4 col-md-offset-4" style="padding-top: 20px;">\r\n        <img class="brookson-logo" ng-if="!$ctrl.$window.appSettings.isIntouchSite" src="Content/img/logos/Brookson-One-Logo.png" title="Brookson Connect" />\r\n        <img class="intouch-logo" ng-if="$ctrl.$window.appSettings.isIntouchSite" src="/Content/img/logos/InTouch.png" title="Intouch Connect" style="margin-top: 1px;" />\r\n        <h2 style="display: inline-block; color: white; float:right; margin-top:12px;" ng-if="!$ctrl.$window.appSettings.isIntouchSite">Connect</h2>\r\n        <h2 style="display: inline-block; color: white; float:right;" ng-if="$ctrl.$window.appSettings.isIntouchSite">Connect</h2>\r\n        <form name="forgottenLoginForm" class="sign-in-container" novalidate>\r\n            <div class="login-wrapper">\r\n                <div class="header">\r\n                    <div class="row">\r\n                        <div class="col-md-12 col-lg-12 add-margin-top-1">\r\n                            <h4>Forgotten Details?</h4>\r\n                            <p>\r\n                                If you have forgotten your ClientId or Password, please complete the form below.\r\n                            </p>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class="content">\r\n                    <p>Please select which credential you have forgot.</p>\r\n                    <div class="row">\r\n                        <div class="col-xs-12">\r\n                            <label ng-if="!$ctrl.isForgottenId" for="forgottenIdRadio">\r\n                                <i class="fa-regular fa-circle"></i>\r\n                            </label>\r\n                            <label ng-if="$ctrl.isForgottenId" class="blue" for="forgottenIdRadio">\r\n                                <i class="fa-regular fa-circle-dot"></i>\r\n                            </label>\r\n                            <input id="forgottenIdRadio"\r\n                                   style="display: none"\r\n                                   type="checkbox"\r\n                                   name="forgotten"\r\n                                   ng-value="true"\r\n                                   ng-model="$ctrl.isForgottenId"\r\n                                   ng-change="$ctrl.hasForgottenId($ctrl.isForgottenId)" />\r\n                            <label for="forgottenIdRadio">Forgotten Client ID</label>\r\n                            <div ng-if="$ctrl.isForgottenId">\r\n                                <p>\r\n                                    Please enter your details below and we will send you an SMS with instruction on how to reset your password.\r\n                                </p>\r\n                                <div class="add-margin-top-1">\r\n                                    <brookson-input-text data-ng-model="$ctrl.forgottenIdFirstName"\r\n                                                         type="text"\r\n                                                         class="add-margin-top-1"\r\n                                                         data-field="forgottenIdFirstName"\r\n                                                         data-placeholder="First name"\r\n                                                         data-label="First name"\r\n                                                         is-required="true"\r\n                                                         autocomplete="off"\r\n                                                         autocorrect="off"\r\n                                                         autocapitalize="off"\r\n                                                         spellcheck="false"></brookson-input-text>\r\n                                </div>\r\n                                <div class="add-margin-top-1">\r\n                                    <brookson-input-text data-ng-model="$ctrl.forgottenIdSurname"\r\n                                                         type="text"\r\n                                                         class="add-margin-top-1"\r\n                                                         data-field="forgottenIdSurname"\r\n                                                         data-placeholder="Surname"\r\n                                                         data-label="Surname"\r\n                                                         is-required="true"\r\n                                                         autocomplete="off"\r\n                                                         autocorrect="off"\r\n                                                         autocapitalize="off"\r\n                                                         spellcheck="false"></brookson-input-text>\r\n                                </div>\r\n                                <div class="add-margin-top-1">\r\n                                    <brookson-input-email data-ng-model="$ctrl.forgottenIdEmail"\r\n                                                          data-field="forgottenIdEmail"\r\n                                                          data-label="Email"\r\n                                                          data-placeholder="Email"\r\n                                                          is-required="true"\r\n                                                          autocomplete="off"\r\n                                                          autocorrect="off"\r\n                                                          autocapitalize="off"\r\n                                                          spellcheck="false"></brookson-input-email>\r\n                                </div>\r\n\r\n                                <div class="add-margin-top-1">\r\n                                    <brookson-input-datepicker field="forgottenIdDob"\r\n                                                               label="Date of Birth"\r\n                                                               ng-model="$ctrl.forgottenIdDob" is-required="true"\r\n                                                               placeholder="Date of Birth" />\r\n                                </div>\r\n                            </div>\r\n\r\n                            <br />\r\n                            <label ng-if="!$ctrl.isForgottenPassword" for="forgottenPasswordRadio">\r\n                                <i class="fa-regular fa-circle"></i>\r\n                            </label>\r\n                            <label ng-if="$ctrl.isForgottenPassword" class="blue" for="forgottenPasswordRadio">\r\n                                <i class="fa-regular fa-circle-dot"></i>\r\n                            </label>\r\n                            <input id="forgottenPasswordRadio"\r\n                                   style="display: none"\r\n                                   type="checkbox"\r\n                                   name="forgotten"\r\n                                   ng-value="true"\r\n                                   ng-model="$ctrl.isForgottenPassword"\r\n                                   ng-change="$ctrl.hasForgottenPassword($ctrl.isForgottenPassword)" />\r\n                            <label for="forgottenPasswordRadio">Forgotten Password</label>\r\n                            <div ng-if="$ctrl.isForgottenPassword">\r\n                                <p>Please enter your Client ID in the field below and we will send you an SMS with instruction on how to reset your password.</p>\r\n                                <input data-ng-model="$ctrl.username"\r\n                                       type="text"\r\n                                       class="form-control add-margin-top-1"\r\n                                       id="username"\r\n                                       placeholder="Username"\r\n                                       ng-trim="true"\r\n                                       required focus-on="username"\r\n                                       autocomplete="off"\r\n                                       autocorrect="off"\r\n                                       autocapitalize="off"\r\n                                       spellcheck="false" />\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class="row">\r\n                        <div class="col-xs-12">\r\n                            <div ng-if="$ctrl.message !== null"\r\n                                 class="alert alert-danger add-margin-top-1"\r\n                                 role="alert"\r\n                                 ng-show="$ctrl.message">\r\n                                <i class="fa fa-exclamation-triangle"></i> {{$ctrl.message}}\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class="row add-margin-top-1">\r\n                        <div class="col-xs-12">\r\n                            <div ng-if="$ctrl.isForgottenPassword">\r\n                                <button href="" class="brooksonBtn mobileButton"\r\n                                        ng-click="$ctrl.requestPasswordReset(forgottenLoginForm)">\r\n                                    Send SMS\r\n                                </button>\r\n                            </div>\r\n\r\n                            <div ng-if="$ctrl.isForgottenId">\r\n                                <button class="brooksonBtn mobileButton"\r\n                                        ng-click="$ctrl.requestForgottenClientId(forgottenLoginForm);">\r\n                                    Send SMS\r\n                                </button>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class="actions">\r\n                    <div class="row">\r\n                        <button href=""\r\n                                class="brooksonBtn mobileButton"\r\n                                ng-click="$ctrl.goToLogin()">\r\n                            <i class="fa-regular fa-circle-left" style="font-size: 18px;"></i>\r\n                            Back\r\n                        </button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </form>\r\n    </div>\r\n</div>\r\n');
        $templateCache.put('src/app/login/views/login.html', '<div>\r\n    <div class="col-lg-4 col-md-4 col-md-offset-4" style="padding-top: 20px;">\r\n        <img class="brookson-logo" ng-if="!$ctrl.$window.appSettings.isIntouchSite" src="Content/img/logos/Brookson-One-Logo.png" title="Brookson Connect" />\r\n        <img class="intouch-logo" ng-if="$ctrl.$window.appSettings.isIntouchSite" src="/Content/img/logos/InTouch.png" title="Intouch Connect" style="margin-top: 1px;" />\r\n        <h2 style="display: inline-block; color: white; float:right; margin-top:12px;" ng-if="!$ctrl.$window.appSettings.isIntouchSite">Connect</h2>\r\n        <h2 style="display: inline-block; color: white; float:right;" ng-if="$ctrl.$window.appSettings.isIntouchSite">Connect</h2>\r\n        <div class="sign-in-container">\r\n            <form novalidate name="loginForm" class="login-wrapper">\r\n                <div class="header">\r\n                    <div class="row">\r\n                        <div class="col-md-12 col-lg-12">\r\n                            <h1 ng-if="!$ctrl.$window.appSettings.isIntouchSite" class="pull-left loginFormHeader">Welcome to Brookson One Connect</h1>\r\n                            <h1 ng-if="$ctrl.$window.appSettings.isIntouchSite" class="pull-left loginFormHeader">Welcome to Intouch Connect</h1>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class="content">\r\n                    <h5>Log in to your account</h5>\r\n                    <div class="input-group">\r\n                        <span class="input-group-addon"><i class="fa fa-user fa-fw" aria-hidden="true"></i></span>\r\n                        <input data-ng-model="$ctrl.email" type="text" class="form-control" id="userName" placeholder="Username" ng-trim="true" required focus-on="username" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" />\r\n                        <p ng-if="loginForm.name.$invalid && !loginForm.name.$pristine" class="help-block">Your name is required.</p>\r\n                    </div>\r\n                    <div class="input-group add-margin-top-1">\r\n                        <span class="input-group-addon"><i class="fa fa-unlock-alt fa-fw" aria-hidden="true"></i></span>\r\n                        <input data-ng-model="$ctrl.password" type="password" class="form-control" id="Password1" placeholder="Password" required focus-on="password" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false">\r\n                        <p ng-if="loginForm.password.$invalid && !loginForm.password.$pristine" class="help-block">Your password is required.</p>\r\n                    </div>\r\n                    <div class="alert alert-danger add-margin-top-1" role="alert" ng-if="$ctrl.message">\r\n                        <i class="fa fa-exclamation-triangle"></i> {{$ctrl.message}}\r\n                    </div>\r\n\r\n                    <button class="brooksonBtn mobileButton"\r\n                            name="submit"\r\n                            ng-click="$ctrl.login(loginForm.$valid)"\r\n                            ga-track-event="[\'Login\', \'click\', \'Login button pressed\']"\r\n                            ng-disabled="$ctrl.requestInProgress"\r\n                            style="margin-top: 10px;">\r\n                        Login\r\n                    </button>\r\n                </div>\r\n                <div class="actions">\r\n\r\n                    <div class="row" style="margin-bottom: 15px;">\r\n                        <div class="col-xs-12">\r\n                            <span>New account?</span>\r\n                            <button class="brooksonBtn pull-right"\r\n                                    ga-track-event="[\'Registration\', \'click\', \'Registration button pressed\']"\r\n                                    data-ui-sref="login.registration">\r\n                                Register your account\r\n                            </button>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class="row">\r\n                        <div class="col-xs-12">\r\n                            <span>Need help logging in?</span>\r\n                            <button class="brooksonBtn pull-right"\r\n                                    ga-track-event="[\'Login\', \'click\', \'Forgot Password button pressed\']"\r\n                                    data-ui-sref="login.forgottenPassword"\r\n                                    style="min-width: 176px;">\r\n                                Forgotten Password\r\n                            </button>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class="clearfix"></div>\r\n\r\n                </div>\r\n                <div class="actions" ng-if="$ctrl.$window.brookson.notice.ShowPerformanceMessage">\r\n                    Due to unusually high demand, Connect may be slower than usual. We are working improving the performance. Thank you for your patience.\r\n                </div>\r\n                <div class="actions" ng-if="$ctrl.$window.brookson.showLoginMessage.ShowLoginMessage">\r\n                    {{$ctrl.$window.brookson.loginMessage.LoginMessage}}\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n');
        $templateCache.put('src/app/login/views/passwordReset.html', '<div>\r\n    <div class="col-lg-4 col-md-4 col-md-offset-4" style="padding-top: 20px;">\r\n        <img class="brookson-logo" ng-if="!$ctrl.$window.appSettings.isIntouchSite" src="Content/img/logos/Brookson-One-Logo.png" title="Brookson Connect" />\r\n        <img class="intouch-logo" ng-if="$ctrl.$window.appSettings.isIntouchSite" src="/Content/img/logos/InTouch.png" title="Intouch Connect" style="margin-top: 1px;" />\r\n        <h2 style="display: inline-block; color: white; float:right; margin-top:12px;" ng-if="!$ctrl.$window.appSettings.isIntouchSite">Connect</h2>\r\n        <h2 style="display: inline-block; color: white; float:right;" ng-if="$ctrl.$window.appSettings.isIntouchSite">Connect</h2>\r\n        <div class="sign-in-container">\r\n            <form novalidate name="loginForm" class="login-wrapper">\r\n                <!--<div class="header">\r\n                    <div class="row">\r\n                        <div class="col-md-12 col-lg-12 add-margin-top-1">\r\n\r\n                        </div>\r\n                    </div>\r\n                </div>-->\r\n                <div class="content">\r\n                    <div class="form-group">\r\n                        <input data-ng-model="$ctrl.username"\r\n                               type="text"\r\n                               class="form-control"\r\n                               id="username"\r\n                               placeholder="Username"\r\n                               ng-trim="true"\r\n                               required focus-on="username"\r\n                               autocomplete="off"\r\n                               autocorrect="off"\r\n                               autocapitalize="off"\r\n                               spellcheck="false" />\r\n                    </div>\r\n                    <div class="form-group">\r\n                        <brookson-input-password-strength data-field="password" data-label="Password" ng-model="$ctrl.password" placeholder="Password" />\r\n                    </div>\r\n                    <div class="form-group">\r\n                        <input data-ng-model="$ctrl.confirmPassword"\r\n                               type="password"\r\n                               class="form-control"\r\n                               id="confirmPassword"\r\n                               placeholder="Confirm Password"\r\n                               ng-trim="true"\r\n                               required focus-on="confirmPassword"\r\n                               autocomplete="off"\r\n                               autocorrect="off"\r\n                               autocapitalize="off"\r\n                               spellcheck="false" />\r\n                    </div>\r\n                    <div class="alert alert-danger add-margin-top-1" role="alert" ng-show="$ctrl.message">\r\n                        <i class="fa fa-exclamation-triangle"></i> {{$ctrl.message}}\r\n                    </div>\r\n                    <div class="form-group">\r\n                        <p class="col-xs-12">We recommend that you use a combination of upper case and lower case letters as well as numbers and symbols.</p>\r\n                    </div>\r\n                </div>\r\n                <div class="actions add-margin-bottom-1">\r\n                    <button class="tst-login btn btn-primary col-xs-12" ng-click="$ctrl.setNewPassword()" ga-track-event="[\'Password Reset\', \'click\', \'Requesting Reset ID\']">\r\n                        Change Password\r\n                    </button>\r\n                    <div class="clearfix"></div>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>');
        $templateCache.put('src/app/login/views/registration.html', '<div>\r\n    <div class="col-lg-4 col-md-4 col-md-offset-4" style="padding-top: 20px;">\r\n        <img class="brookson-logo" ng-if="!$ctrl.$window.appSettings.isIntouchSite" src="Content/img/logos/Brookson-One-Logo.png" title="Brookson Connect" />\r\n        <img class="intouch-logo" ng-if="$ctrl.$window.appSettings.isIntouchSite" src="/Content/img/logos/InTouch.png" title="Intouch Connect" style="margin-top: 1px;" />\r\n        <h2 style="display: inline-block; color: white; float:right; margin-top:12px;" ng-if="!$ctrl.$window.appSettings.isIntouchSite">Connect</h2>\r\n        <h2 style="display: inline-block; color: white; float:right;" ng-if="$ctrl.$window.appSettings.isIntouchSite">Connect</h2>\r\n        <div class="sign-in-container">\r\n            <form novalidate name="registrationForm" class="login-wrapper">\r\n                <div class="header">\r\n                    <div class="row">\r\n                        <div class="col-md-12 col-lg-12 add-margin-top-1">\r\n                            <p>If you have received your account details, please register them below to enable your login.</p>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class="content">\r\n                    <h4>Register your account</h4>\r\n\r\n                    <div class="form-group">\r\n                        <input data-ng-model="$ctrl.username"\r\n                               type="text"\r\n                               class="form-control"\r\n                               id="username"\r\n                               placeholder="Username"\r\n                               ng-trim="true"\r\n                               required\r\n                               focus-on="username"\r\n                               autocomplete="off"\r\n                               autocorrect="off"\r\n                               autocapitalize="off"\r\n                               spellcheck="false" />\r\n                        <span>* Your username can be found joiner email</span>\r\n                    </div>\r\n                    <div class="form-group">\r\n                        <input data-ng-model="$ctrl.registrationId"\r\n                               type="text"\r\n                               class="form-control"\r\n                               id="registrationId"\r\n                               placeholder="Registration ID"\r\n                               ng-trim="true"\r\n                               required\r\n                               focus-on="registrationId"\r\n                               autocomplete="off"\r\n                               autocorrect="off"\r\n                               autocapitalize="off"\r\n                               spellcheck="false" />\r\n                        <span>* You\'ll receive a SMS with your Registration ID on joining</span>\r\n                    </div>\r\n                    <div class="form-group">\r\n                        <brookson-input-password-strength data-field="password" data-label="Password" ng-model="$ctrl.password" placeholder="Password" />\r\n                    </div>\r\n                    <div class="form-group">\r\n                        <input data-ng-model="$ctrl.confirmPassword"\r\n                               type="password"\r\n                               class="form-control"\r\n                               id="confirmPassword"\r\n                               placeholder="Confirm Password"\r\n                               ng-trim="true"\r\n                               required\r\n                               focus-on="confirmPassword"\r\n                               autocomplete="off"\r\n                               autocorrect="off"\r\n                               autocapitalize="off"\r\n                               spellcheck="false" />\r\n                    </div>\r\n                    <div class="alert alert-danger add-margin-top-1" role="alert" ng-show="$ctrl.message">\r\n                        <i class="fa fa-exclamation-triangle"></i> {{$ctrl.message}}\r\n                    </div>\r\n                    <button class="brooksonBtn mobileButton"\r\n                            ng-click="$ctrl.activateMember()">\r\n                        Register\r\n                    </button>\r\n                    <div class="clearfix"></div>\r\n                </div>\r\n                <div class="actions add-margin-bottom-1">\r\n                    <p>Already have an account?</p>\r\n                    <button href="" class="brooksonBtn mobileButton" ng-click="$ctrl.goToLogin()">\r\n                        <i class="fa-regular fa-circle-left" style="font-size: 18px;"></i>\r\n                        Return to log in page\r\n                    </button>\r\n                    <div class="clearfix"></div>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>');
        $templateCache.put('src/app/login/views/serviceLine.html', '<div>\r\n    <div class="col-lg-4 col-md-4 col-md-offset-4" style="padding-top: 20px;">\r\n        <img class="brookson-logo" ng-if="!$ctrl.$window.appSettings.isIntouchSite" src="Content/img/logos/Brookson-One-Logo.png" title="Brookson Connect" />\r\n        <img class="intouch-logo" ng-if="$ctrl.$window.appSettings.isIntouchSite" src="/Content/img/logos/InTouch.png" title="Intouch Connect" style="margin-top: 1px;" />\r\n        <h2 style="display: inline-block; color: white; float:right; margin-top:12px;" ng-if="!$ctrl.$window.appSettings.isIntouchSite">Connect</h2>\r\n        <h2 style="display: inline-block; color: white; float:right;" ng-if="$ctrl.$window.appSettings.isIntouchSite">Connect</h2>\r\n        <div class="sign-in-container">\r\n            <form name="serviceForm" class="form login-wrapper" data-ng-submit="$ctrl.submit(serviceForm.$valid)" novalidate>\r\n                <div class="header">\r\n                    <div class="row">\r\n                        <div class="col-md-12 col-lg-12">\r\n                            <p>Please select a company from the drop down list below</p>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class="content">\r\n                    <div class="form-group">\r\n                        <label>Company</label>\r\n                        <select name="serviceLine" data-ng-model="$ctrl.selectedServiceLine" data-ng-options="option.companyName for option in $ctrl.serviceLines track by option.customerReference | unique: \'option.companyName\'"\r\n                                type="text" class="form-control" placeholder="Company" required>\r\n                        </select>\r\n\r\n                        <div class="alert alert-danger" role="alert" ng-show="serviceForm.serviceLine.$invalid && !serviceForm.serviceLine.$pristine">\r\n                            Company is invalid.\r\n                        </div>\r\n                        <div class="alert alert-danger add-margin-top-1" role="alert" ng-show="$ctrl.message">\r\n                            <i class="fa fa-exclamation-triangle"></i> {{$ctrl.message}}\r\n                        </div>\r\n                    </div>\r\n\r\n                </div>\r\n                <div class="actions">\r\n                    <button class="brooksonBtn mobileButton"\r\n                            name="submit"\r\n                            ng-disabled="$ctrl.loading"\r\n                            ga-track-event="[\'Service Line\', \'click\', \'Submit Pressed\']">\r\n                        Submit\r\n                    </button>\r\n\r\n                    <div class="clearfix"></div>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>');
        $templateCache.put('src/app/login/views/shareholder.html', '<div>\r\n    <div class="col-lg-4 col-md-4 col-md-offset-4" style="padding-top: 20px;">\r\n        <img class="brookson-logo" ng-if="!$ctrl.$window.appSettings.isIntouchSite" src="Content/img/logos/Brookson-One-Logo.png" title="Brookson Connect" />\r\n        <img class="intouch-logo" ng-if="$ctrl.$window.appSettings.isIntouchSite" src="/Content/img/logos/InTouch.png" title="Intouch Connect" style="margin-top: 1px;" />\r\n        <h2 style="display: inline-block; color: white; float:right; margin-top:12px;" ng-if="!$ctrl.$window.appSettings.isIntouchSite">Connect</h2>\r\n        <h2 style="display: inline-block; color: white; float:right;" ng-if="$ctrl.$window.appSettings.isIntouchSite">Connect</h2>\r\n        <div class="sign-in-container">\r\n            <form novalidate name="shareholderloginForm" class="login-wrapper">\r\n                <div class="header">\r\n                    <div class="row">\r\n                        <div class="col-md-12 col-lg-12">\r\n                            <h1 ng-if="!$ctrl.$window.appSettings.isIntouchSite" class="pull-left loginFormHeader">Welcome to Brookson One Connect</h1>\r\n                            <h1 ng-if="$ctrl.$window.appSettings.isIntouchSite" class="pull-left loginFormHeader">Welcome to Intouch Connect</h1>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class="content">\r\n                    <div class="input-group">\r\n                        <span class="input-group-addon"><i class="fa fa-user fa-fw" aria-hidden="true"></i></span>\r\n                        <input data-ng-model="$ctrl.username" type="text" class="form-control" id="userName" placeholder="Username" ng-trim="true" required focus-on="username" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" />\r\n                        <p ng-if="shareholderloginForm.name.$invalid && !shareholderloginForm.name.$pristine" class="help-block">Your name is required.</p>\r\n                    </div>\r\n\r\n                    <div class="input-group add-margin-top-1">\r\n                        <span class="input-group-addon">\r\n                            <i class="fa fa-key fa-fw" aria-hidden="true"></i>\r\n                        </span>\r\n                        <input data-ng-model="$ctrl.registrationId" type="text" class="form-control" id="registrationId" placeholder="Registration ID" ng-trim="true" required focus-on="registrationId" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" />\r\n                    </div>\r\n                    <div class="small text-muted text-center bg-warning">\r\n                        Sent to you via SMS\r\n                    </div>\r\n\r\n                    <div class="input-group add-margin-top-1">\r\n                        <span class="input-group-addon">\r\n                            <i class="fa fa-unlock-alt fa-fw" aria-hidden="true"></i>\r\n                        </span>\r\n                        <input data-ng-model="$ctrl.newPassword" type="password" class="form-control" id="newPassword" placeholder="Create new password" ng-trim="true" required focus-on="newpassword" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" />\r\n                    </div>\r\n\r\n                    <div class="input-group add-margin-top-1">\r\n                        <span class="input-group-addon">\r\n                            <i class="fa fa-lock fa-fw" aria-hidden="true"></i>\r\n                        </span>\r\n                        <input data-ng-model="$ctrl.confirmPassword" type="password" class="form-control" id="confirmPassword" placeholder="Confirm password" ng-trim="true" required focus-on="confirmPassword" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" />\r\n                    </div>\r\n\r\n                    <div class="alert alert-danger add-margin-top-1" role="alert" ng-if="$ctrl.message">\r\n                        <i class="fa fa-exclamation-triangle"></i> {{$ctrl.message}}\r\n                    </div>\r\n                </div>\r\n                <div class="actions">\r\n                    <button ga-track-event="[\'Login\', \'click\', \'Login button pressed\']"\r\n                            ng-disabled="$ctrl.requestInProgress"\r\n                            ng-click="$ctrl.submitLogin(shareholderloginForm.$valid)"\r\n                            class="brooksonBtn mobileButton">\r\n                        Login\r\n                    </button>\r\n                    <div class="clearfix"></div>\r\n                </div>\r\n\r\n                <div class="alert alert-info add-margin-1">\r\n                    <p>If you have not received your text message or have any other problems logging in please call 0345 058 1200</p>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>\r\n');
        $templateCache.put('src/app/login/views/super.html', '<div>\r\n    <div class="col-lg-4 col-md-4 col-md-offset-4" style="padding-top: 20px;">\r\n        <img class="brookson-logo" ng-if="!$ctrl.$window.appSettings.isIntouchSite" src="Content/img/logos/Brookson-One-Logo.png" title="Brookson Connect" />\r\n        <img class="intouch-logo" ng-if="$ctrl.$window.appSettings.isIntouchSite" src="/Content/img/logos/InTouch.png" title="Intouch Connect" style="margin-top: 1px;" />\r\n        <h2 style="display: inline-block; color: white; float:right; margin-top:12px;" ng-if="!$ctrl.$window.appSettings.isIntouchSite">Connect</h2>\r\n        <h2 style="display: inline-block; color: white; float:right;" ng-if="$ctrl.$window.appSettings.isIntouchSite">Connect</h2>\r\n        <div class="sign-in-container">\r\n            <form name="superForm" class="form login-wrapper" data-ng-submit="$ctrl.submit(superForm.$valid)" novalidate>\r\n                <div class="header">\r\n                    <div class="row">\r\n                        <div class="col-md-12 col-lg-12">\r\n                            <p>Please enter a Member ID to impersonate</p>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class="content">\r\n                    <div class="form-group">\r\n                        <label for="memberId">Member ID</label>\r\n                        <input id="memberId" name="memberId" pattern="[0-9]*" data-ng-model="$ctrl.memberId" type="text" class="form-control" placeholder="Member ID" required focus-on="memberId" ng-trim="true" autocomplete="off" autocorrect="off">\r\n\r\n                        <div class="alert alert-danger add-margin-top-1" role="alert" ng-show="superForm.name.$invalid && !superForm.name.$pristine">\r\n                            <i class="fa fa-exclamation-triangle"></i> Member ID is required.\r\n                        </div>\r\n                        <div class="alert alert-danger add-margin-top-1" role="alert" ng-show="$ctrl.message">\r\n                            <i class="fa fa-exclamation-triangle"></i> {{$ctrl.message}}\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class="actions">\r\n                    <button name="submit"\r\n                            class="brooksonBtn mobileButton"\r\n                            ng-disabled="superForm.$invalid || $ctrl.isLoading"\r\n                            ga-track-event="[\'Login\', \'click\', \'Superuser submit pressed\']">\r\n                        Submit\r\n                    </button>\r\n                    <div class="clearfix"></div>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>\r\n');
        $templateCache.put('src/app/login/views/twoFactorAuth.html', '<div>\r\n    <div class="col-lg-6 col-md-6 col-md-offset-3" style="padding-top: 20px;">\r\n        <img class="brookson-logo" ng-if="!$ctrl.$window.appSettings.isIntouchSite" src="Content/img/logos/Brookson-One-Logo.png" title="Brookson Connect" />\r\n        <img class="intouch-logo" ng-if="$ctrl.$window.appSettings.isIntouchSite" src="/Content/img/logos/InTouch.png" title="Intouch Connect" style="margin-top: 1px;" />\r\n        <h2 style="display: inline-block; color: white; float:right; margin-top:12px;" ng-if="!$ctrl.$window.appSettings.isIntouchSite">Connect</h2>\r\n        <h2 style="display: inline-block; color: white; float:right;" ng-if="$ctrl.$window.appSettings.isIntouchSite">Connect</h2>\r\n        <div class="sign-in-container otp-container alignCentre">\r\n            <form name="tfaForm" class="form login-wrapper" data-ng-submit="$ctrl.submit(tfaForm.$valid)" novalidate>\r\n                <!--<div class="header">\r\n                    <div class="row">\r\n                        <div class="col-md-12 col-lg-12">\r\n                        </div>\r\n                    </div>\r\n                </div>-->\r\n                <div class="content">\r\n\r\n                    <div ng-show="$ctrl.isLoading">\r\n                        Loading data .... <i class="fa fa-spinner fa-4x fa-pulse loading"></i>\r\n                    </div>\r\n\r\n                    <div ng-hide="$ctrl.isLoading">\r\n                        <div ng-hide="$ctrl.showOTP">\r\n                            <h4>\r\n                                <i class="fa fa-lock fa-2x tfalock"></i>Two Factor Authentication\r\n                            </h4>\r\n                            <div class="col-xs-12 col-md-10 col-md-offset-1 marb30">\r\n                                <p ng-show="$ctrl.contactDetailList">\r\n                                    Please select how you would like to receive your one-time password:\r\n                                </p>\r\n                                <ul class="no-bullets" ng-show="$ctrl.contactDetailList">\r\n                                    <li ng-repeat="contact in $ctrl.contactDetailList.phoneNumbers">\r\n                                        <input type="radio" ng-model="$ctrl.selectedCommms" value="{{contact.maskedContactDetail}}" />\r\n                                        Mobile: {{contact.maskedContactDetail}}\r\n                                    </li>\r\n                                    <li ng-repeat="contact in $ctrl.contactDetailList.emailAddresses">\r\n                                        <input type="radio" ng-model="$ctrl.selectedCommms" value="{{contact.maskedContactDetail}}" />\r\n                                        Email: {{contact.maskedContactDetail}}\r\n                                    </li>\r\n                                </ul>\r\n                                <p ng-show="!$ctrl.contactDetailList">\r\n                                    We could not retrieve any contact details for you. Please contact us at 01925 232 526 so we can help\r\n                                </p>\r\n                                <p ng-show="$ctrl.authRequestError" class="col-xs-12 errorMessage">\r\n                                    There was an error sending your One Time Password.<br />Please select a different destination to send your One Time Password or try again later.\r\n                                </p>\r\n                                <p style="clear:both; margin-top:40px;" ng-show="$ctrl.contactDetailList">\r\n                                    Your one-time password will expire after 5 minutes.\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div ng-show="$ctrl.showOTP">\r\n                            <h4>\r\n                                <i class="fa fa-lock fa-2x tfalock"></i>Two Factor Authentication\r\n                            </h4>\r\n\r\n                            <div ng-hide="$ctrl.otpExpired">\r\n                                <p style="margin-bottom:25px;">\r\n                                    We have sent you a One Time Password to your selected choice.<br />Please enter the password below to proceed with your login.\r\n                                </p>\r\n                                <div class="col-xs-12 col-md-6 col-md-offset-3">\r\n                                    <input id="otp" name="otp" pattern="[0-9]*" data-ng-model="$ctrl.otp" type="text" class="form-control" placeholder="Your One Time Password" required focus-on="otp" ng-trim="true" autocomplete="off" autocorrect="off">\r\n                                </div>\r\n                                <p ng-show="$ctrl.otpError" class="col-xs-12 errorMessage">\r\n                                    The One Time Password you entered is incorrect or has expired.<br />Please enter the correct One Time Password or request a new one.\r\n                                </p>\r\n                                <p class="col-xs-12" style="margin-top: 15px;">\r\n                                    Your One Time Password will expire after 5 minutes of being sent.<br /> If you need a new One, please click <a ng-click="$ctrl.reset()" href="#">here</a>\r\n                                </p>\r\n                                <p class="col-xs-12">\r\n                                    Password expires in : <span class="countdown"></span>\r\n                                </p>\r\n                            </div>\r\n\r\n                            <div ng-show="$ctrl.otpExpired" style="padding-top: 20px;">\r\n                                <p>\r\n                                    Your One Time Password has expired. Click <a ng-click="$ctrl.reset()" href="#">here</a> to request a new one.\r\n                                </p>\r\n                            </div>\r\n\r\n                        </div>\r\n\r\n                    </div>\r\n\r\n\r\n                </div>\r\n                <div class="actions">\r\n                    <button type="submit" ng-hide="$ctrl.otpExpired" class="brooksonBtn" ga-track-event="[\'Login\', \'click\', \'OTP Submit\']" ng-disabled="$ctrl.disableSubmitButton()">Submit</button>\r\n                    <div class="clearfix"></div>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>');
    }]);
